// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MyMarginCls{
    margin-top: 100px;
} */
:root {
  /* --oragne-color: #d37c1d; */
  /* --orange: #fe7f3c; */
  --font-family: "Plus Jakarta Sans", sans-serif;
  --orange-color: #cd601d;
  /* --green-color: #49bf2b; */
  --green-color: #63a211;
  --red: #ff4d62;
  --half-red: #d37881;
  --green: #33c18d;
  --white: #fff;
  --black: #000;
  --primary-black: rgba(0, 0, 0, 0.12);
  --secondary-black: #212529;

  --primary-blue-color: #293b83;
  --secondary-blue-color: #3e56bf;
  --dark-blue: #0e527d;
  --border-lines: #e1e6e9;
  --light-blue: #1a87cb;
  --very-dark-blue: #24397a;
  --very-dark-elephant-gray: #8f7777;
  --elephant-dark-grey: #aaa;
  --light-eleph-light-grey: #e5f0ff;
  --disabled-light-grey: #e9ecef;
  --very-light-grey: #d1d1d1;
  --v-grey-light: #eee;
  --table-row-bg-light-grey: #fafafa;
  --box-shadow-color: #8b8084;
  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);
  /* linear-gradient(90deg, #031978, #3e56bf) */
  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);
  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);
  --light-blue-gradient-angle: linear-gradient(
    90deg,
    #46a4cf 8%,
    #2f324f 86.9%
  );
  --green-gradient: linear-gradient(
    73.1deg,
    rgba(34, 126, 34, 1) 8%,
    rgba(99, 162, 17, 1) 86.9%
  );
  /* --roboto-font-family: "Roboto", 'Halvetica', sans-serif; */
  --stickyBackground: #f5f5f5;
  --borderColor: #c9d1dc;
}
.OrganizationTableView thead th,
.CandidateListTableView thead th,
.DepartmentTableView thead th,
.JobTableView thead th {
  background-color: #e6f3ff;
}
body {
  font-family: var(--font-family);
}

.CandidateListTableView tbody td {
  background-color: white;
}

.job-candidate-table thead th {
  background-color: #afd6ee !important;
}

.CandidateTestTablewView thead th {
  background-color: #4a94da !important;
  color: #fff !important;
}

#CreateJobOrder .p-tabmenu-nav.p-reset {
  border: 0;
}

#CreateJobOrder .p-tabmenuitem.p-highlight {
  border-bottom: 2px solid #1a87cb;
}

#CreateJobOrder .p-tabmenuitem .p-menuitem-link {
  color: #1a87cb;
}

.create-job-candidate-panel {
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.create-job-candidate-panel #CandidateTest_DataTableView {
  padding: 0 12px 12px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_Table {
  border: 1px solid #e3ecf7;
  border-radius: 8px;
  overflow: hidden;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableHeadRow {
  background: #eef7ff;
  border-bottom: 1px solid #d8e8f7;
  min-height: 44px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableRow {
  min-height: 52px;
}

.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableBody {
  background: #fff;
}

.create-job-candidate-panel .form-control,
.create-job-candidate-panel .form-select,
.create-job-candidate-panel select {
  min-height: 34px;
  border-color: #d7e3ef;
  font-size: 13px;
}

.create-job-candidate-panel .btn-sm {
  min-height: 32px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.create-job-candidate-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #e6edf8;
  background: #f8fbff;
}

.create-job-candidate-count {
  min-width: 34px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #145b84;
  background: #e6f3ff;
  border: 1px solid #b9ddf4;
  font-size: 12px;
  font-weight: 700;
}

.create-job-candidate-search {
  padding: 12px;
  border-bottom: 1px solid #eef3f8;
}

.create-job-candidate-search .input-group-text {
  color: #1a87cb;
  background: #fff;
  border-color: #d7e3ef;
}

.create-job-candidate-search .form-control {
  border-color: #d7e3ef;
  font-size: 13px;
}

.create-job-candidate-list {
  max-height: 560px;
  overflow-y: auto;
  padding: 8px;
  background: #f8fafc;
}

.create-job-candidate-item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #e1e8f0;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;
}

.create-job-candidate-item:hover,
.create-job-candidate-item:focus {
  border-color: #1a87cb;
  background: #f3f9ff;
  box-shadow: 0 8px 18px rgba(26, 135, 203, 0.12);
  transform: translateY(-1px);
  outline: none;
}

.create-job-candidate-item.is-selected {
  border-color: #1a87cb;
  background: #eaf6ff;
  box-shadow: inset 4px 0 0 #1a87cb, 0 8px 18px rgba(26, 135, 203, 0.12);
}

.create-job-candidate-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #fff;
  background: #1a87cb;
  font-weight: 700;
  font-size: 13px;
}

.create-job-candidate-summary {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.create-job-candidate-name {
  color: #172033;
  font-weight: 700;
  line-height: 1.25;
}

.create-job-candidate-meta {
  color: #6c757d;
  font-size: 12px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.create-job-candidate-preview {
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);
}

.create-job-candidate-preview-header {
  padding: 14px 16px;
  background: #f8fbff;
  border-bottom: 1px solid #e6edf8;
}

.create-job-candidate-preview-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #145b84;
  background: #e6f3ff;
  border: 1px solid #b9ddf4;
  font-weight: 700;
}

.create-job-candidate-preview-meta {
  color: #6c757d;
  font-size: 13px;
  overflow-wrap: anywhere;
}

.create-job-candidate-detail-card {
  background: #fff;
}

.create-job-candidate-detail-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid #e6edf8;
  background: #fff;
}

.create-job-candidate-detail-tabs .btn {
  margin: 0;
  border-radius: 6px;
  font-weight: 600;
}

.create-job-candidate-detail-body {
  padding: 16px;
}

.create-job-candidate-detail-body .badge {
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 9px;
  white-space: normal;
  text-align: left;
}

.create-job-candidate-detail-body iframe {
  min-height: 620px;
}

.ats-candidate-detail-side {
  padding: 1rem;
  border-right: 1px solid #e2e8f0;
  overflow: hidden;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ats-candidate-detail-switch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 4px;
  border: 1px solid #d9e4f5;
  border-radius: 8px;
  background: #f8fbff;
  flex: 0 0 auto;
}

.ats-candidate-detail-switch button {
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  padding: 8px 10px;
  cursor: pointer;
}

.ats-candidate-detail-switch button.active {
  background: #1a87cb;
  color: #fff;
  box-shadow: 0 6px 14px rgba(26, 135, 203, 0.18);
}

.ats-candidate-detail-content {
  overflow-y: auto;
  padding-right: 4px;
  min-height: 0;
}

.ats-candidate-detail-fields {
  display: grid;
  gap: 8px;
}

.ats-candidate-detail-field {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
  align-items: flex-start;
  padding: 9px 10px;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  background: #fbfdff;
}

.ats-candidate-detail-field i {
  color: #1a87cb;
  font-size: 13px;
  margin-top: 2px;
}

.candidate-modal .candidate-contact-icon,
.candidate-modal .candidate-contact-icon * {
  color: #4f46e5 !important;
  stroke: #4f46e5 !important;
}

.ats-candidate-detail-field span {
  display: block;
  color: #64748b;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
}

.ats-candidate-detail-field strong {
  display: block;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.expander-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 50px;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.expander-bubble:hover {
  background-color: #e0e0e0;
  border-radius: 50%;
  background-color: #f4f4f4;
  border: 1px solid #d0d0d0;
}

.CDV_Container {
  position: relative;
  width: 70px;
  height: 70px;
  border-radius: 12px;
}

.CDV_Icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/* #JobOrder_DataTableView .rdt_Table {
    min-width: 100%;
} */

#CandidateTest_DataTableView .rdt_Table {
  /* min-width: 190%; */
  /* border: 2px solid red; */
}
.closeBtn,
.addBtn {
  padding: 8px 18px;
  margin-bottom: 8px;
  /* font-size: 16px; */
  font-weight: 700;
  background: var(--green-gradient);
  /* box-shadow: 5px 5px 10px var(--very-dark-elephant-gray); */
  /* text-transform: uppercase; */
  color: var(--white) !important;
  /* border: 0; */
  /* font-family: 'Mukta', sans-serif; */
}

.addBtn:hover {
  box-shadow: -1px 1px 5px 5px var(--box-shadow-color);
}
.blueBtn {
  background: var(--blue-gradient-right) !important;
  color: var(--white) !important;
  font-weight: 700;
  margin: 10px;
}
.talent-scan-view-result-btn {
  min-width: 82px;
  height: 34px;
  margin: 0;
  white-space: nowrap;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.talent-scan-view-result-btn:hover,
.talent-scan-view-result-btn:focus {
  font-size: 15px;
}
.searchIconBtn {
  background: var(--blue-gradient-right) !important;
  color: var(--white) !important;
  font-weight: 700;
}

.candidate-name-with-initials {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 44px;
  padding: 4px 0;
}

.candidate-name-initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  flex: 0 0 30px;
  margin-top: 0;
  padding: 0;
  box-sizing: border-box;
  border-radius: 50%;
  background: #f3e8ff;
  color: #7e22ce;
  border: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0;
  text-decoration: none;
}

.candidate-name-with-initials > span:last-child {
  flex: 1 1 auto;
  min-width: 0;
  line-height: 1.25;
  white-space: normal;
  overflow-wrap: break-word;
  font-size: 14px;
}

.expander-bubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 50px;
  font-weight: bold;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.expander-bubble:hover {
  background-color: #e0e0e0;
  border-radius: 50%;
  background-color: #f4f4f4;
  border: 1px solid #d0d0d0;
}
#JobOrderTableView .rdt_TableCol:nth-child(1),
#JobOrderTableView .rdt_TableCol:nth-child(3),
#JobOrderTableView .rdt_TableCol:nth-child(5) {
  justify-content: initial;
  text-align: center;
}
#JobOrderTableView .sc-hJRrWL .rdt_TableCell,
#JobOrderTableView .sc-hJRrWL .rdt_TableCell span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#JobOrderTableView,
#JobOrderTableView .rdt_Table,
#JobOrderTableView .rdt_TableHead,
#JobOrderTableView .rdt_TableBody,
#JobOrderTableView .rdt_TableRow {
  width: 100% !important;
}

#JobOrderTableView .rdt_Table,
#JobOrderTableView .rdt_TableBody {
  overflow-x: hidden !important;
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol {
  padding: 8px 8px !important;
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol,
#JobOrderTableView .rdt_TableHead .rdt_TableCol > div {
  min-width: 0;
  justify-content: center;
  overflow: visible;
  white-space: normal;
}

#JobOrderTableView .rdt_TableHead .rdt_TableCol .fs-6 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  font-size: 14px !important;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
}

#JobOrderTableView .addCandidateHeaderBtn {
  width: 100%;
  min-width: 0;
  padding: 0 !important;
  justify-content: center;
  white-space: normal;
  line-height: 1.2;
}

#JobOrderTableView .addCandidateHeaderBtn .ms-1 {
  margin-left: 0 !important;
}

#JobOrderTableView .job-order-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  width: 100%;
}

#JobOrderTableView .job-order-actions-cell .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0 !important;
}
/* #JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM{
        padding-left: 8px;
    padding-right: 4px;
    border-right: 1px solid var(--border-lines);
    border-bottom: 1px solid var(--border-lines);
} */

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell {
  border-right: 1px solid var(--border-lines);
  border-bottom: 1px solid var(--border-lines);
  /* border-right: 1px solid blue;
  border-bottom: 1px solid blue; */
  padding-left: 2px;
  padding-right: 2px;
}

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell span {
  /* width: 90%; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM:first-child {
  border-left: 1px solid var(--border-lines);
}

/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11), */
/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10), */
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(12),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2){
  justify-content: center;
}

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {
  font-weight: 500;
}

/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) span {
  font-weight: 500;
  background-color: #ebe9e9;
  border-radius: 0.375rem;
} */

#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) {
  font-weight: 500;
}

#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5),
#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(6),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(8),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(15),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(17),
/* #CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13), */
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(16),
#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(9) {
  justify-content: center;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5) {
  justify-content: center;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(16),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(14),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(17),
/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15), */
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6) {
  justify-content: center;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {
  justify-content: start !important;
}

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div {
  width: 95%;
  /* border: 2px solid red; */
}

/* 
#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div > span {
  border: 2px solid red;
} */

#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div span {
  width: 180px;
}

#CalendarScheduled_TableView tbody tr td:nth-child(2) {
  text-align: center !important;
}

/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9) {
  border: 2px solid red;
} */
/* MobilePhoneContaier */

/* #CalendarScheduled_TableView tbody tr td:nth-child(4) {
  border: 2px solid red;
  white-space: nowrap;
  width: 150px !important;
  overflow: hidden;
  text-overflow: ellipsis;
} */

#CandidateTest_DataTableView {
  /* Chandu */
}

#CandidateTest_DataTableView .rdt_TableHeadRow {
  min-height: 52px;
}

#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol {
  align-items: center;
  justify-content: center;
  padding: 8px 8px !important;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol > div {
  min-width: 0;
  justify-content: center;
  white-space: normal;
}

#CandidateTest_DataTableView .ColumnTitle,
#CandidateTest_DataTableView .font_15 {
  font-size: 14px !important;
  line-height: 1.15;
  text-align: center;
  white-space: normal;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableRow {
  min-height: 40px;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell {
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 5px 8px !important;
  text-align: center;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell > div {
  min-width: 0;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(2),
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(3),
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(4) {
  justify-content: flex-start;
  text-align: left;
}

#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(9) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(10) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(11) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(12) > div,
#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(13) > div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

#CandidateTest_DataTableView .job-candidate-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  width: 100%;
}

#CandidateTest_DataTableView .job-candidate-actions-cell .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0 !important;
  margin: 0 !important;
}

.candidate-modal .modal-content {
  border-radius: 16px;
  border: none;
}
.candidate-modal .modal-header {
  border-bottom: 1px solid #e9ecef;
}

.bg-light-subtle {
  background-color: #f8f9fa !important;
}

.candidate-modal .border {
  border-color: #dee2e6 !important;
}

.candidate-modal strong {
  /* min-width: 160px; */
  display: inline-block;
}

.candidate-modal .badge {
  font-size: 0.85rem;
  padding: 0.4em 0.8em;
  border-radius: 12px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background: white;
  /* padding: 20px; */
  border-radius: 8px;
  width: 400px;
  /* max-width: 90%; */
  border: 0px !important;
}
.modal-content h3 {
  margin-top: 0;
}
.modal-content textarea {
  width: 100%;
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.modal-buttons button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.modal-buttons button:first-child {
  background: #ccc;
}
.modal-buttons button:last-child {
  background: #3b82f6;
  color: white;
}

#ExistingCandidate_MultiSel .searchWrapper {
  display: flex;
  overflow-x: auto;
  padding: 0.1375rem 0.75rem !important;
  border-radius: 0.375rem !important;
  font-size: 0.875rem;
  height: 34px;
}

#ExistingCandidate_MultiSel .chip {
  position: absolute;
  left: 10px;
  cursor: pointer;
}

#ExistingCandidate_MultiSel input::placeholder {
  position: absolute;
  bottom: 1px;
  left: 0px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--secondary-black);
}

.JobTimeLineContainer {
  position: relative;
  border-left: 2px solid #1a87cb;
}

.JobTimeLineBlock {
  position: relative;
}

.JobTimeLineBlock::before {
  position: absolute;
  content: "";
  width: 20px;
  height: 20px;
  background-color: #1a87cb;
  border-radius: 50%;
}
.JobTimeLineBlock::after {
  position: absolute;
  top: 8px;
  /* right: 98%; */
  right: 97.7%;
  content: "";
  width: 18px;
  height: 2px;
  border: 2px solid #1a87cb;
}

.CandyTimeLine_ActionType,
.JobTimeLine_ActionType {
  font-weight: 600;
  font-size: 0.875rem;
}

.CandyTimeLine_CreaedBy,
.CandyTimeLine_ActionDateTime,
.JobTimeLine_CreaedBy,
.JobTimeLine_ActionDateTime {
  font-weight: 500;
  font-size: 0.75rem !important;
  color: #b1b0b0;
}

.CandyTimeLine_Actioned_By,
.JobTimeLine_Actioned_By {
  font-weight: 400;
  font-size: 0.75rem !important;
}

.TimeStamp {
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  background-color: #1a87cb;
  color: #fff;
}

#JobOrderTableView header {
  min-height: 1px;
}

.bg_blue {
  background-color: #1a87cb;
}
.skill-tag {
  background-color: #e9ecef;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  display: inline-block;
  margin-right: 0.5rem;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
  font-weight: 500;
}
.skill-box {
  border: 1px solid #dee2e6;
  padding: 0.9rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background-color: #fdfdfd;
}

input::-ms-reveal {
  display: none;
}
.section-title {
  color: #0e527d;
  font-weight: 600;
}
.calendar-container {
  height: 650px;
}
.calendar-cell {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: visible;
  padding: 3px;
  border-right: 1px solid #ddd;
}
.event-block {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 6px;
  border-radius: 4px;
  margin-top: 20px;
  height: 80px;
  overflow-y: auto;
}
.event-item {
  background: white;
  border: 1px solid #b6d4fe;
  padding: 4px;
  margin-bottom: 4px;
  border-radius: 3px;
}

.event-item div {
  font-size: 12px;
}
.event-join-link {
  font-size: 12px;
  color: #0d6efd;
}
.event-no-link {
  font-size: 11px;
  color: #888;
}

/* .event-more-btn {
  font-size: 11px !important;
  padding: 0 !important;
  text-decoration: underline;
} */
.event-box {
  max-height: 80px;
  overflow-y: auto;
}
.rbc-day-cell {
  padding: 4px;
}

.rbc-time-view .rbc-row {
  min-height: initial;
  height: 80px;
  overflow-y: scroll;
}

.rbc-btn-group > button:nth-child(2), /* Week */
.rbc-btn-group > button:nth-child(3)  /* Day */ {
  display: none !important;
}
/* Calendar container height */
.calendar-container {
  height: 80vh;
}

/* Enable scrolling in Week & Day view */
.rbc-time-view,
.rbc-time-content {
  overflow-y: auto !important;
}

/* Fix pointer events */
.calendar-cell,
.rbc-date-cell,
.rbc-event,
.rbc-timeslot-group,
.rbc-time-slot {
  pointer-events: auto !important;
}

.rbc-row-segment {
  display: none;
}

#ScreeningConfigTab .p-tabview-nav {
  display: none;
}

#CreateJobOrderTabs .p-tabview-nav-link {
  border: 1px solid #ddd;
  border-radius: 4px;
}

#CreateJobOrderTabs .p-tabview-nav {
  margin-top: 8px;
  margin-bottom: 4px !important;
}

.create-job-order-page {
  min-height: calc(100vh - 80px);
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
}

#CreateJobOrderTabs > .p-tabview-nav-container {
  position: sticky;
  top: 69px;
  z-index: 20;
  background: #fff;
  padding-top: 4px;
}

#CreateJobOrderTabs > .p-tabview-panels {
  overflow: visible;
}

#SkillsAndQuestionsBlock .p-accordion-header-text {
  color: #1a87cb;
}
/* Remove hover background */
.p-dropdown:not(.p-disabled):hover {
  box-shadow: none !important;
  border-color: #ced4da !important;
}

/* Remove blue focus outline */
.p-dropdown:focus,
.p-dropdown:focus-visible,
.p-dropdown.p-focus {
  box-shadow: none !important;
  outline: none !important;
  border-color: #ced4da !important;
}
.p-multiselect .p-multiselect-label {
  transition: none;
}
.p-dropdown-label.p-inputtext.p-placeholder:hover {
  border-color: inherit !important;
  box-shadow: none !important;
  cursor: pointer !important;
}
.p-dropdown-label.p-inputtext.p-placeholder {
  color: black !important ;
}
.p-dropdown:not(.p-disabled):hover .p-dropdown-label.p-inputtext.p-placeholder {
  color: white !important;
}

/* Default icon color = black */
.p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon {
  color: black !important;
}

/* On hover of the dropdown, icon color = white */
.p-dropdown:not(.p-disabled):hover
  .p-dropdown-trigger
  .p-dropdown-trigger-icon {
  color: white !important;
}

#AccessPrivileges_UserTable .rdt_TableCell input[type="checkbox"] {
  margin: 0 auto;
  display: block;
}
#AccessPrivileges_UserTable .rdt_TableCol_Sortable {
  text-align: center;
}

#AccessPrivileges_UserTable .sc-jwIPbr,
#AccessPrivileges_UserTable .bAhklE {
  text-align: center;
}

#AccessPrivileges_UserTable .rdt_TableCol_Sortable .rdt_TableSortLabel {
  display: inline-block;
  margin: 0 auto;
}

#RoleDropdown div svg,
#RoleDropdown div,
#RoleDropdown span {
  color: #000;
  background: #e0e0ea !important;
}

#SubTypeDropdown div svg,
#SubTypeDropdown span,
#PriorityDropdown div svg,
#PriorityDropdown span {
  color: #000 !important;
}
/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {
  border: 2px solid red;
} */
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(10),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(10),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(12),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#MailTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1) {
  /* border: 2px solid red; */
  justify-content: center;
  border-right: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {
  border-left: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(5),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),
#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {
  border-top: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6) {
  border-right: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {
  border-left: 1px solid #e0e0e0;
}

#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),
#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {
  border-right: 1px solid #e0e0e0;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  text-align: center;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}

#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AccessPrivileges_UserTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  /* padding-left: 20px; */
}

/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{
  border: 2px solid blue;
} */

#UserManagement_TableView .p-dropdown:not(.p-disabled):hover,
#UserManagement_TableView .p-dropdown:not(.p-disabled):hover {
  background-color: transparent !important;
  color: #000;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown span,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown span,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span,
#LookupCustomize .p-paginator-bottom .p-dropdown span,
#JobDatatable .p-paginator-bottom .p-dropdown span,
#RolesList .p-paginator-bottom .p-dropdown span,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown span,
#RecruiterReports_TableView .p-paginator-bottom .p-dropdown span,
#JobTableView .p-paginator-bottom .p-dropdown span,
#CandidateInfo .p-paginator-bottom .p-dropdown span,
#ArchiveReasonTableView .p-paginator-bottom .p-dropdown span,
#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown span,
#PlacementReportTable .p-paginator-bottom .p-dropdown span,
#UserManagement_TableView .p-paginator-bottom .p-dropdown span {
  background-color: white;
  border-left: 1px solid #ddd;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown div,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown div,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown div,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown div,
#LookupCustomize .p-paginator-bottom .p-dropdown div,
#RolesList .p-paginator-bottom .p-dropdown div,
#JobDatatable .p-paginator-bottom .p-dropdown div,
#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown div,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown div,
#PlacementReportTable .p-paginator-bottom .p-dropdown div,
#JobTableView .p-paginator-bottom .p-dropdown div,
#CandidateInfo .p-paginator-bottom .p-dropdown div,
#ArchiveReasonTableView .p-paginator-bottom .p-dropdown div,
#RecruiterReports_TableView .p-paginator-bottom .p-dropdown div,
#UserManagement_TableView .p-paginator-bottom .p-dropdown div {
  border: 1px solid #ddd;
  background-color: white;
  color: black;
  border-radius: 2px;
}

#All_Employees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#AllEmployees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#ActiveJobSummaryReport .p-paginator-bottom div .p-dropdown-trigger svg,
#RecruiterPerformanceReport .p-paginator-bottom div .p-dropdown-trigger svg,
#LookupCustomize .p-paginator-bottom div .p-dropdown-trigger svg,
#RolesList .p-paginator-bottom div .p-dropdown-trigger svg,
#JobDatatable .p-paginator-bottom div .p-dropdown-trigger svg,
#JobTableView .p-paginator-bottom div .p-dropdown-trigger svg,
#MyPlaceMentReportTable .p-paginator-bottom div .p-dropdown-trigger svg,
#PlacementReportTable .p-paginator-bottom div .p-dropdown-trigger svg,
#RecruiterReports_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#AllCandidates_TableView .p-paginator-bottom div .p-dropdown-trigger svg,
#UserManagement_TableView .p-paginator-bottom div .p-dropdown-trigger svg {
  color: black !important;
  background-color: white;
}

#All_Employees_TableView .p-paginator-bottom .p-dropdown span:hover,
#AllEmployees_TableView .p-paginator-bottom .p-dropdown span:hover,
#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span:hover,
#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span:hover,
#LookupCustomize .p-paginator-bottom .p-dropdown span:hover,
#RolesList .p-paginator-bottom .p-dropdown span:hover,
#JobDatatable .p-paginator-bottom .p-dropdown span:hover,
#AllCandidates_TableView .p-paginator-bottom .p-dropdown span:hover,
#UserManagement_TableView .p-paginator-bottom .p-dropdown span:hover {
  background-color: white;
  color: black;
}

.contacts-header-box .row {
  row-gap: 12px;
}

.contacts-header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

.contacts-company-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.contacts-company-filter label {
  margin: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.contacts-company-select {
  width: 200px;
}

.contacts-company-control,
.contacts-search-input,
.contacts-search-btn {
  height: 38px;
}

.contacts-company-control {
  font-size: 14px;
}

.contacts-search-filter {
  width: 260px;
}

.contacts-search-group {
  flex-wrap: nowrap;
}

.contacts-search-input {
  min-width: 0;
  font-size: 14px !important;
}

.contacts-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  padding: 0;
}

@media (max-width: 991.98px) {
  .contacts-header-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}

.roles-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 14px;
}

.roles-header-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

.roles-company-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 200px;
}

.roles-company-filter label {
  margin: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.roles-company-control,
.roles-add-action .p-button {
  height: 38px;
}

.roles-company-control {
  font-size: 14px;
}

.roles-add-action .p-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 767.98px) {
  .roles-header-row,
  .roles-header-actions {
    align-items: flex-start;
    flex-direction: column;
  }
}

.user-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-bottom: 14px;
}

.user-header-actions {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
}

.user-company-filter {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 200px;
}

.user-company-filter label {
  margin: 0;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
}

.user-company-control,
.user-search-input,
.user-search-btn {
  height: 38px;
}

.user-company-control {
  font-size: 14px;
}

.user-search-filter {
  width: 260px;
}

.user-search-group {
  flex-wrap: nowrap;
}

.user-search-input {
  min-width: 0;
  font-size: 14px !important;
}

.user-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  padding: 0;
}

@media (max-width: 767.98px) {
  .user-header-row,
  .user-header-actions {
    align-items: flex-start;
    flex-direction: column;
  }
}

#CandidateFinishTable table thead tr th:nth-child(5) {
  text-align: center;
}

#CandidateFinishTable table tbody tr td:nth-child(5) {
  text-align: center;
}
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  font-size: 0.85rem;
}



#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#AllCandidates_TableView table tr td:nth-child(7),
#AllCandidates_TableView table tr td:nth-child(6),
#AllCandidates_TableView table tr td:nth-child(5),
#AllCandidates_TableView table tr td:nth-child(4),
#AllCandidates_TableView table tr td:nth-child(3),
#AllCandidates_TableView table tr td:nth-child(2),
#AllCandidates_TableView table tr td:nth-child(1) {
  width: 150px !important;
}

.JobCreateBy_AllCandidates,
.JobName_AllCandidates,
.JobEmail_AllCandidates,
.JobTitle_AllCandidates {
  width: 140px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#CandidateList_CardView #AllCandidates_TableView .p-datatable-wrapper {
  overflow-x: hidden !important;
}

#CandidateList_CardView #AllCandidates_TableView table {
  width: 100% !important;
  table-layout: fixed;
}

#AllCandidates_TableView table tr th:nth-child(1),
#AllCandidates_TableView table tr td:nth-child(1) {
  width: 44px !important;
  min-width: 56px !important;
  max-width: 44px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  text-align: center !important;
}

#AllCandidates_TableView table tr th:nth-child(6),
#AllCandidates_TableView table tr td:nth-child(6) {
  width: 230px !important;
  min-width: 230px !important;
}

#AllCandidates_TableView table tr th:nth-child(2),
#AllCandidates_TableView table tr td:nth-child(2) {
  width: 200px !important;
  min-width: 200px !important;
}

#AllCandidates_TableView table tr th:nth-child(3),
#AllCandidates_TableView table tr td:nth-child(3) {
  width: 185px !important;
  min-width: 185px !important;
}

#AllCandidates_TableView table tr th:nth-child(4),
#AllCandidates_TableView table tr td:nth-child(4) {
  width: 145px !important;
  min-width: 145px !important;
}

#AllCandidates_TableView table tr th:nth-child(5),
#AllCandidates_TableView table tr td:nth-child(5) {
  width: 95px !important;
  min-width: 95px !important;
}

#AllCandidates_TableView table tr th:nth-child(8),
#AllCandidates_TableView table tr td:nth-child(8) {
  width: 190px !important;
  min-width: 190px !important;
}

#AllCandidates_TableView table tr th:nth-child(9),
#AllCandidates_TableView table tr td:nth-child(9) {
  width: 155px !important;
  min-width: 155px !important;
}

#CandidateList_CardView .JobName_AllCandidates,
#CandidateList_CardView .JobTitle_AllCandidates,
#CandidateList_CardView .JobCreateBy_AllCandidates {
  width: auto !important;
  max-width: 100%;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

#CandidateList_CardView .JobName_AllCandidates {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .JobName_AllCandidates > span:first-child {
  flex: 0 0 30px;
}

#CandidateList_CardView .JobName_AllCandidates > span:last-child {
  display: inline-block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .candidate-name-with-initials > span:last-child {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

#CandidateList_CardView .JobEmail_AllCandidates,
#CandidateList_CardView .JobPhone_AllCandidates {
  width: 100% !important;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

#CandidateList_CardView .JobEmail_AllCandidates span,
#CandidateList_CardView .JobPhone_AllCandidates span {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#CandidateList_CardView .JobTitle_AllCandidates span,
#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.3;
}

#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {
  margin-bottom: 4px;
}

#CandidateList_CardView .JobCreateBy_AllCandidates > div:last-child {
  white-space: nowrap;
}

#CandidateList_CardView .candidate-pipeline-stage-cell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 34px;
}

#CandidateList_CardView .candidate-pipeline-stage-cell.no-history {
  display: flex;
  justify-content: center;
}

#CandidateList_CardView .candidate-pipeline-stage-text {
  display: block;
  min-width: 0;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#CandidateList_CardView .candidate-pipeline-history-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  min-width: 28px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  color: #111827;
  background: #f8fafc;
  box-shadow: none;
}

#CandidateList_CardView .candidate-pipeline-history-btn svg {
  width: 14px;
  height: 14px;
}

#CandidateList_CardView .CandidateListTableView .p-radiobutton,
#CandidateList_CardView .CandidateListTableView .p-radiobutton .p-radiobutton-box {
  width: 18px;
  height: 18px;
}

#CandidateList_CardView .candidate-actions-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

#CandidateList_CardView .candidate-action-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  padding: 0 !important;
  margin: 0;
  border-radius: 6px;
  line-height: 1;
}

#CandidateList_CardView .candidate-action-icon-btn svg,
#CandidateList_CardView .candidate-action-icon-btn i {
  display: block;
  margin: 0;
  font-size: 14px;
}

#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child {
  border-left: 1px solid #e0e0e0;
}

#JobOrderTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  background-color: #e6f3ff;
}
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child {
  border-left: 1px solid #e0e0e0;
}
#CandidateTest_DataTableView .rdt_Table .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  background-color: #f8f8f8;
}
#JobOrderTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#UserManagement_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  span {
  font-size: 0.85rem;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:first-child {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#TelephonicTest_Table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#TalentScanResultView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  border-right: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
  background-color: #e6f3ff;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:first-child {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#ExtensionLogs_Datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#TelephonicTest_Table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell {
  border-right: 1px solid #e0e0e0;
}

/* #CandidateViewSummaryTable .rdt_Table .rdt_TableBody,
#CandidateViewSummaryTable .rdt_Table .rdt_TableHead {
  border-left: 1px solid #e0e0e0;
} */

#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell,
#CandidateViewSummaryTable
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol {
  text-align: center;
  justify-content: center;
}

/* #CandidateViewSummaryTable .rdt_Table {
  border: 1px solid #e0e0e0;
  
} */

#CandidateViewSummaryTable .rdt_ExpanderRow {
  border-left: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable .rdt_Table .rdt_TableHead .bGNKtt:first-child,
#JobOrderTableView .rdt_Table .rdt_TableHead .bGNKtt:first-child {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}

#CandidateViewSummaryTable .rdt_Table .rdt_TableRow .gOAnHZ:first-child,
#JobOrderTableView .rdt_Table .rdt_TableRow .gOAnHZ:first-child {
  border-right: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
  /* border-right: 2px solid red; */
}

#TalentScanResultView.rdt_Table .rdt_TableRow div:first-child {
  border-right: 2px solid blue;
}

#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#CandidateTest_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#TalentScanResultView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#TalentScanResultView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(2),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(4),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(6),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#AllLoginActivitysCandy_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(9),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(8),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(7),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(5),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(3),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableHead
  .rdt_TableHeadRow
  .rdt_TableCol:nth-child(1),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#CandidateTest_DataTableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(12),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(11),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(2),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(3),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(4),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(5),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(6),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(7),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(8),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(9),
#TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(10),
#AllReferralCandidates_TableView
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell:nth-child(1) {
  justify-content: center;
}

.font_12 {
  font-size: 12px;
}

.font_15,
.ColumnTitle {
  font-size: 0.85rem;
}

#CandidateApprovalTable table thead tr th {
  text-align: center;
}

#CandidateApprovalTable table tbody tr td:nth-child(2) div,
#CandidateApprovalTable table tbody tr td:nth-child(4) div,
#CandidateApprovalTable table tbody tr td:nth-child(3) div {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


/* #UserManagement_TableView table tbody tr td:nth-child(4),
#UserManagement_TableView table tbody tr td:nth-child(3),
#UserManagement_TableView table tbody tr td:nth-child(2), */
/* #CandidateApprovalTable table tbody tr td:nth-child(3), */
/* #CandidateApprovalTable table tbody tr td:nth-child(2) {
  text-align: center;
   
} */
#VitelMeetLink table tbody tr td:nth-child(1),
#VitelMeetLink table tbody tr td:nth-child(2),
#VitelMeetLink table tbody tr td:nth-child(3),
#VitelMeetLink table tbody tr td:nth-child(4),
#UserManagement_TableView table tbody tr td:nth-child(1),
#UserManagement_TableView table tbody tr td:nth-child(2),
#UserManagement_TableView table tbody tr td:nth-child(3),
#UserManagement_TableView table tbody tr td:nth-child(4),
#UserManagement_TableView table tbody tr td:nth-child(5) {
  text-align: center !important;
  border-right: 1px solid #e0e0e0;
}

#UserManagement_TableView table tbody tr td:nth-child(5) div {
  justify-content: center;
}

#UserManagement_TableView table thead tr th div span {
  width: 100%;
  text-align: center !important;
}

#CandidateTest_DataTableView .rdt_Table {
  border-top: 1px solid #e0e0e0;
  border-left: 1px solid #e0e0e0;
}

#All_Employees_TableView table tbody tr td {
  border-right: 1px solid #e0e0e0;
}

#All_Employees_TableView table tbody tr td span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#All_Employees_TableView table tbody tr td:nth-child(3) {
  width: 150px;
}

#All_Employees_TableView table tbody tr td:nth-child(2) {
  width: 150px;
}

#All_Employees_TableView table tbody tr td:nth-child(3) span,
#All_Employees_TableView table tbody tr td:nth-child(2) span {
  display: block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* #All_Employees_TableView table thead tr th:nth-child(3) div,
 */

#VitelMeetLink table thead tr th:nth-child(1) div,
#VitelMeetLink table thead tr th:nth-child(2) div,
#VitelMeetLink table thead tr th:nth-child(3) div,
#VitelMeetLink table thead tr th:nth-child(4) div,
#All_Employees_TableView table thead tr th:nth-child(6) div,
#All_Employees_TableView table thead tr th:nth-child(5) div,
#All_Employees_TableView table thead tr th:nth-child(4) div,
#All_Employees_TableView table thead tr th:nth-child(2) div,
#All_Employees_TableView table thead tr th:nth-child(1) div {
  justify-content: center;
}
#recentAactivityTable table thead tr th:nth-child(1) div,
#recentAactivityTable table thead tr th:nth-child(2) div,
#recentAactivityTable table thead tr th:nth-child(3) div,
#recentAactivityTable table thead tr th:nth-child(4) div,

#Smtp_table table thead tr th:nth-child(1) div,
#Smtp_table table thead tr th:nth-child(2) div,
#Smtp_table table thead tr th:nth-child(3) div,
#Smtp_table table thead tr th:nth-child(4) div,
#Smtp_table table thead tr th:nth-child(5) div,
#Smtp_table table thead tr th:nth-child(6) div{
  /* text-align: center !important; */
  /* text-align: center !important; */
  justify-content: center;
}

#recentAactivityTable table thead tr th:nth-child(1),
#recentAactivityTable table tbody tr td:nth-child(2),
#recentAactivityTable table tbody tr td:nth-child(3),
#recentAactivityTable table tbody tr td:nth-child(4),
#recentAactivityTable table tbody tr td:nth-child(5),
#Smtp_table table tbody tr td:nth-child(1),
#Smtp_table table tbody tr td:nth-child(2),
#Smtp_table table tbody tr td:nth-child(3),
#Smtp_table table tbody tr td:nth-child(4),
#Smtp_table table tbody tr td:nth-child(5),
#Smtp_table table tbody tr td:nth-child(6){
  text-align: center !important;
  border-left: 1px solid #e0e0e0;
}

#Smtp_table table tbody tr td:nth-child(6) div {
  justify-content: space-evenly;
}
#All_Employees_TableView table tbody tr td:nth-child(5),
#All_Employees_TableView table tbody tr td:nth-child(4),
#All_Employees_TableView table tbody tr td:nth-child(2),
#All_Employees_TableView table tbody tr td:nth-child(1) {
  text-align: center !important;
}
/* Modal */
.notification-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
}

/* Header */
.notification-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e5e5e5;
  padding: 12px 16px;
}

/* Body */
.notification-body {
  max-height: 420px;
  overflow-y: auto;
  padding: 8px;
}

/* Notification Item */
.notification-item {
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 6px;
  transition: background 0.2s ease;
}

.notification-item.unread {
  background: #f1f7ff;
}

.notification-item.read {
  background: #ffffff;
  opacity: 0.8;
}

.notification-item:hover {
  background: #eef4ff;
}

/* Icon */
.notification-icon {
  width: 40px;
  height: 40px;
  background: #e7f0ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
  font-size: 16px;
}

/* Content */
.notification-content {
  flex: 1 1;
  padding-left: 12px;
}

.notification-title {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
}

.notification-message {
  font-size: 13px;
  color: #495057;
  margin-top: 2px;
}

/* Footer */
.notification-footer {
  margin-top: 6px;
  font-size: 11px;
  color: #6c757d;
}

/* Date */
.notification-date {
  font-size: 11px;
}

/* Mark Read Button */
.mark-read-btn {
  background: none;
  border: none;
  color: #0d6efd;
  font-size: 11px;
  cursor: pointer;
  padding: 0;
}

.mark-read-btn:hover {
  text-decoration: underline;
}

/* Empty State */
.no-notification {
  text-align: center;
  padding: 30px;
  color: #6c757d;
  font-size: 14px;
}

/* #All_Employees_TableView table thead tr th:nth-child(2) {
  border: 2px solid red;
  width: 120px;
}

#All_Employees_TableView table tbody tr td:nth-child(2) span {
  border: 2px solid red;
  width: 120px;
} */

.CandidateAprRejReason {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 200px;
}

#AdminModule_Tabs .p-tabview-panels {
  display: none;
}

#PreviewJobPortalCards ul {
}

#All_Notifications_Modal .btn-close {
  margin-left: 3px;
  filter: invert(1);
  opacity: 1;
}
.tab-btn {
  background: none;
  border: none;
  padding: 10px 14px;
  font-size: 14px;
  color: #6b7280;
  position: relative;
  cursor: pointer;
}

.tab-btn.active {
  color: #3a85f7;
  font-weight: 600;
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #4c8cec;
  border-radius: 2px;
}

/* #RecentOpenJobs_TableView table tr td { 
  border: 2px solid red;
   
} */
#RecentOpenJobs_TableView table tbody tr td {
  border-right: 1px solid #ddd;
}

#RecentOpenJobs_TableView table tbody tr td:last-child {
  border-right: initial;
}

#RecentOpenJobs_TableView table tr td:nth-child(10) span,
#RecentOpenJobs_TableView table tr td:nth-child(9) span,
#RecentOpenJobs_TableView table tr td:nth-child(6) span,
#RecentOpenJobs_TableView table tr td:nth-child(5) span,
#RecentOpenJobs_TableView table tr td:nth-child(2) span {
  display: inline-block;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#RecentOpenJobs_TableView table tr th:nth-child(12) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(11) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(10) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(9) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(8) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(7) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(6) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(5) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(4) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(3) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(2) span:first-child,
#RecentOpenJobs_TableView table tr th:nth-child(1) span:first-child {
  width: 100%;
  justify-content: center !important;
  display: inline-block;
  text-align: center;
}

#RecentOpenJobs_TableView table tr td:nth-child(12),
#RecentOpenJobs_TableView table tr td:nth-child(11),
#RecentOpenJobs_TableView table tr td:nth-child(7),
#RecentOpenJobs_TableView table tr td:nth-child(4),
#RecentOpenJobs_TableView table tr td:nth-child(3),
#RecentOpenJobs_TableView table tr td:nth-child(1) {
  text-align: center !important;
}
/* 
white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
 */
#JObInfoModal .btn-close {
  /* border: 2px solid red; */
  /* display: none; */
}
#BulkUploadModal .btn-close {
  border: 2px solid red;
  display: none;
}
/* highlight today's cell */
/* .rbc-month-view .rbc-day-bg.today-highlight {
  background-color: #eaf6ff; /* light blue */
/* }  */
.today-highlight {
  /* border: 2px solid #0d6efd; */
  background-color: #eaf6ff;
  /* border-radius: 6px;   */
}

.Selected_BgColor {
  /* background-color: lightblue; */
  background-color: #e0f2f7;
}
#AllEmployees_TableView table th:nth-child(1),
#AllEmployees_TableView table th:nth-child(2),
#AllEmployees_TableView table th:nth-child(3),
#AllEmployees_TableView table th:nth-child(4),
#AllEmployees_TableView table th:nth-child(5) {
  width: 260px;
}
/* #AllEmployees_TableView table tbody td:nth-child(3) span, */
#AllEmployees_TableView
  table
  tbody
  td:nth-child(2)
  #AllEmployees_TableView
  table
  tbody
  td:nth-child(5) {
  border: 2px solid red;
  width: 200px;
}
.sun-editor-wrapper .sun-editor {
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.sun-editor-wrapper.sun-error .sun-editor {
  border: 2px solid #dc3545 !important;
}

.RecruiterNamesListContainer {
  height: 50vh;
  overflow: auto;
}
#SectioScoreDatatable table tbody td:nth-child(1),
#SectioScoreDatatable table tbody td:nth-child(2),
#SectioScoreDatatable table tbody td:nth-child(3),
#SectioScoreDatatable table tbody td:nth-child(4),
#SectioScoreDatatable table tbody td:nth-child(5),
#SectioScoreDatatable table tbody td:nth-child(6) {
  text-align: center !important;
  border-right: 1px solid #eaf6ff;
}
#SectioScoreDatatable table th:nth-child(1) div,
#SectioScoreDatatable table th:nth-child(2) div,
#SectioScoreDatatable table th:nth-child(3) div,
#SectioScoreDatatable table th:nth-child(4) div,
#SectioScoreDatatable table th:nth-child(5) div,
#SectioScoreDatatable table th:nth-child(6) div {
  justify-content: center !important;
}

/* #LinkCandidates_DataTableView table tbody {
  height: 60vh;
  overflow: auto;
} */
#ArchiveReasonTableView table tr td:nth-child(10) div {
  width: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(4) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(3) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#LinkCandidates_DataTableView table tr td:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.MobilePhoneContaier {
  display: inline-block;
  /* width: 80px !important; */
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#RecruiterReports_TableView table thead tr th:nth-child(6) div,
#RecruiterReports_TableView table thead tr th:nth-child(5) div,
#RecruiterReports_TableView table thead tr th:nth-child(4) div,
#MyPipelineReportTable table thead tr th:nth-child(6) div,
#MyPipelineReportTable table thead tr th:nth-child(5) div,
#MyPipelineReportTable table thead tr th:nth-child(4) div,
#MyPipelineReportTable table thead tr th:nth-child(3) div,
#MyPipelineReportTable table thead tr th:nth-child(2) div,
#MyPipelineReportTable table thead tr th:nth-child(1) div,
#RecruiterPerformanceReport table thead tr th:nth-child(11) div,
#RecruiterPerformanceReport table thead tr th:nth-child(10) div,
#RecruiterPerformanceReport table thead tr th:nth-child(9) div,
#RecruiterPerformanceReport table thead tr th:nth-child(8) div,
#RecruiterPerformanceReport table thead tr th:nth-child(7) div,
#RecruiterPerformanceReport table thead tr th:nth-child(6) div,
#RecruiterPerformanceReport table thead tr th:nth-child(5) div,
#RecruiterPerformanceReport table thead tr th:nth-child(4) div,
#RecruiterPerformanceReport table thead tr th:nth-child(3) div,
#RecruiterPerformanceReport table thead tr th:nth-child(2) div,
#RecruiterPerformanceReport table thead tr th:nth-child(1) div,
#MyPlaceMentReportTable table thead tr th:nth-child(9) div,
#MyPlaceMentReportTable table thead tr th:nth-child(8) div,
#MyPlaceMentReportTable table thead tr th:nth-child(7) div,
#MyPlaceMentReportTable table thead tr th:nth-child(6) div,
#MyPlaceMentReportTable table thead tr th:nth-child(5) div,
#MyPlaceMentReportTable table thead tr th:nth-child(4) div,
#MyPlaceMentReportTable table thead tr th:nth-child(3) div,
#MyPlaceMentReportTable table thead tr th:nth-child(2) div,
#MyPlaceMentReportTable table thead tr th:nth-child(1) div,
#JobTableView table thead tr th:nth-child(1) div,
#JobTableView table thead tr th:nth-child(2) div,
#JobTableView table thead tr th:nth-child(3) div,
#JobTableView table thead tr th:nth-child(1) div,
#CandidateInfo table thead tr th:nth-child(2) div,
#CandidateInfo table thead tr th:nth-child(3) div,
#CandidateInfo table thead tr th:nth-child(4) div,
#ArchiveReasonTableView table thead tr th:nth-child(1) div,
#ArchiveReasonTableView table thead tr th:nth-child(2) div,
#ArchiveReasonTableView table thead tr th:nth-child(3) div,
#ArchiveReasonTableView table thead tr th:nth-child(4) div,
#ArchiveReasonTableView table thead tr th:nth-child(5) div,
#ArchiveReasonTableView table thead tr th:nth-child(6) div,
#ArchiveReasonTableView table thead tr th:nth-child(7) div,
#ArchiveReasonTableView table thead tr th:nth-child(8) div,
#ArchiveReasonTableView table thead tr th:nth-child(9) div,
#ArchiveReasonTableView table thead tr th:nth-child(10) div,
#ActiveJobSummaryReport table thead tr th:nth-child(11) div,
#ActiveJobSummaryReport table thead tr th:nth-child(12) div,
#ActiveJobSummaryReport table thead tr th:nth-child(10) div,
#ActiveJobSummaryReport table thead tr th:nth-child(9) div,
#ActiveJobSummaryReport table thead tr th:nth-child(8) div,
#ActiveJobSummaryReport table thead tr th:nth-child(7) div,
#ActiveJobSummaryReport table thead tr th:nth-child(6) div,
#ActiveJobSummaryReport table thead tr th:nth-child(5) div,
#ActiveJobSummaryReport table thead tr th:nth-child(4) div,
#ActiveJobSummaryReport table thead tr th:nth-child(3) div,
#ActiveJobSummaryReport table thead tr th:nth-child(2) div,
#ActiveJobSummaryReport table thead tr th:nth-child(1) div,
#RecruiterReports_TableView table thead tr th:nth-child(3) div,
#RecruiterReports_TableView table thead tr th:nth-child(2) div,
#RecruiterReports_TableView table thead tr th:nth-child(1) div,
#RolesList table thead tr th:nth-child(1) div,
#RolesList table thead tr th:nth-child(2) div,
#RolesList table thead tr th:nth-child(3) div,
#RolesList table thead tr th:nth-child(4) div {
  justify-content: center;
  border-right: 1px solid #eaf6ff;
}

#RecruiterReports_TableView table tbody tr td:nth-child(15),
#RecruiterReports_TableView table tbody tr td:nth-child(14),
#RecruiterReports_TableView table tbody tr td:nth-child(13),
#RecruiterReports_TableView table tbody tr td:nth-child(12),
#RecruiterReports_TableView table tbody tr td:nth-child(11),
#RecruiterReports_TableView table tbody tr td:nth-child(10),
#RecruiterReports_TableView table tbody tr td:nth-child(9),
#RecruiterReports_TableView table tbody tr td:nth-child(8),
#RecruiterReports_TableView table tbody tr td:nth-child(7),
#RecruiterReports_TableView table tbody tr td:nth-child(6),
#RecruiterReports_TableView table tbody tr td:nth-child(5),
#RecruiterReports_TableView table tbody tr td:nth-child(4),
#RecruiterReports_TableView table tbody tr td:nth-child(3),
#RecruiterReports_TableView table tbody tr td:nth-child(2),
#RecruiterReports_TableView table tbody tr td:nth-child(1),
#JobTableView table tbody tr td:nth-child(3),
#JobTableView table tbody tr td:nth-child(2),
#JobTableView table tbody tr td:nth-child(1),
#CandidateInfo table tbody tr td:nth-child(1),
#CandidateInfo table tbody tr td:nth-child(2),
#CandidateInfo table tbody tr td:nth-child(3),
#CandidateInfo table tbody tr td:nth-child(4),
#ArchiveReasonTableView table tbody tr td:nth-child(1),
#ArchiveReasonTableView table tbody tr td:nth-child(2),
#ArchiveReasonTableView table tbody tr td:nth-child(3),
#ArchiveReasonTableView table tbody tr td:nth-child(4),
#ArchiveReasonTableView table tbody tr td:nth-child(5),
#ArchiveReasonTableView table tbody tr td:nth-child(6),
#ArchiveReasonTableView table tbody tr td:nth-child(7),
#ArchiveReasonTableView table tbody tr td:nth-child(8),
#ArchiveReasonTableView table tbody tr td:nth-child(9),
#ArchiveReasonTableView table tbody tr td:nth-child(10),
#ArchiveReasonTableView table tbody tr td:nth-child(11),
#RecruiterReports_TableView table tbody tr td:nth-child(2),
#RecruiterPerformanceReport table tbody tr td:nth-child(14),
#RecruiterPerformanceReport table tbody tr td:nth-child(13),
#RecruiterPerformanceReport table tbody tr td:nth-child(12),
#RecruiterPerformanceReport table tbody tr td:nth-child(11),
#RecruiterPerformanceReport table tbody tr td:nth-child(10),
#RecruiterPerformanceReport table tbody tr td:nth-child(9),
#RecruiterPerformanceReport table tbody tr td:nth-child(8),
#RecruiterPerformanceReport table tbody tr td:nth-child(7),
#RecruiterPerformanceReport table tbody tr td:nth-child(6),
#RecruiterPerformanceReport table tbody tr td:nth-child(5),
#RecruiterPerformanceReport table tbody tr td:nth-child(4),
#RecruiterPerformanceReport table tbody tr td:nth-child(3),
#RecruiterPerformanceReport table tbody tr td:nth-child(2),
#RecruiterPerformanceReport table tbody tr td:nth-child(1),
#ActiveJobSummaryReport table tbody tr td:nth-child(12),
#ActiveJobSummaryReport table tbody tr td:nth-child(11),
#ActiveJobSummaryReport table tbody tr td:nth-child(10),
#ActiveJobSummaryReport table tbody tr td:nth-child(9),
#ActiveJobSummaryReport table tbody tr td:nth-child(8),
#ActiveJobSummaryReport table tbody tr td:nth-child(7),
#ActiveJobSummaryReport table tbody tr td:nth-child(6),
#ActiveJobSummaryReport table tbody tr td:nth-child(5),
#ActiveJobSummaryReport table tbody tr td:nth-child(4),
#ActiveJobSummaryReport table tbody tr td:nth-child(3),
#ActiveJobSummaryReport table tbody tr td:nth-child(2),
#ActiveJobSummaryReport table tbody tr td:nth-child(1),
#TimeToHireReport table tbody tr td:nth-child(13),
#TimeToHireReport table tbody tr td:nth-child(12),
#TimeToHireReport table tbody tr td:nth-child(11),
#TimeToHireReport table tbody tr td:nth-child(10),
#TimeToHireReport table tbody tr td:nth-child(9),
#TimeToHireReport table tbody tr td:nth-child(8),
#TimeToHireReport table tbody tr td:nth-child(7),
#TimeToHireReport table tbody tr td:nth-child(6),
#TimeToHireReport table tbody tr td:nth-child(5),
#TimeToHireReport table tbody tr td:nth-child(4),
#TimeToHireReport table tbody tr td:nth-child(3),
#TimeToHireReport table tbody tr td:nth-child(2),
#TimeToHireReport table tbody tr td:nth-child(1),
#PlacementReportTable table tbody tr td:nth-child(7),
#PlacementReportTable table tbody tr td:nth-child(6),
#PlacementReportTable table tbody tr td:nth-child(5),
#PlacementReportTable table tbody tr td:nth-child(4),
#PlacementReportTable table tbody tr td:nth-child(3),
#PlacementReportTable table tbody tr td:nth-child(2),
#PlacementReportTable table tbody tr td:nth-child(1),
#MyPlaceMentReportTable table tbody tr td:nth-child(9),
#MyPlaceMentReportTable table tbody tr td:nth-child(8),
#MyPlaceMentReportTable table tbody tr td:nth-child(7),
#MyPlaceMentReportTable table tbody tr td:nth-child(6),
#MyPlaceMentReportTable table tbody tr td:nth-child(5),
#MyPlaceMentReportTable table tbody tr td:nth-child(4),
#MyPlaceMentReportTable table tbody tr td:nth-child(3),
#MyPlaceMentReportTable table tbody tr td:nth-child(2),
#MyPlaceMentReportTable table tbody tr td:nth-child(1),
#AllEmployees_TableView table tbody tr td:nth-child(10),
#AllEmployees_TableView table tbody tr td:nth-child(9),
#AllEmployees_TableView table tbody tr td:nth-child(7),
#MyPipelineReportTable table tbody tr td:nth-child(7),
#MyPipelineReportTable table tbody tr td:nth-child(6),
#MyPipelineReportTable table tbody tr td:nth-child(5),
#MyPipelineReportTable table tbody tr td:nth-child(4),
#MyPipelineReportTable table tbody tr td:nth-child(3),
#MyPipelineReportTable table tbody tr td:nth-child(2),
#MyPipelineReportTable table tbody tr td:nth-child(1),
#RolesList table tbody tr td:nth-child(1),
#RolesList table tbody tr td:nth-child(2),
#RolesList table tbody tr td:nth-child(3),
#RolesList table tbody tr td:nth-child(4) {
  text-align: center !important;
  border-right: 1px solid #dbe1e6;
}
#RecruiterReports_TableView table tbody tr td:nth-child(2) div {
  width: 240px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#ExtensionLogs_Datatable
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  div
  #TelephonicTest_Table
  .rdt_Table
  .rdt_TableBody
  .rdt_TableRow
  .rdt_TableCell
  div {
  font-size: 14px;
}

/* ========== Candidate View Modal - Clean UI ========== */
.cv-modal .modal-content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.cv-modal .modal-body {
  max-height: 85vh;
  overflow-y: auto;
  padding: 0 !important;
}

/* Profile Header */
.cv-profile-header {
  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 100%);
  padding: 2rem 2rem 1.8rem;
  text-align: center;
  position: relative;
}

.cv-close-btn {
  position: absolute;
  top: 12px;
  right: 14px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
}

.cv-close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.cv-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 3px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0.75rem;
  letter-spacing: 2px;
}

.cv-profile-name {
  color: #fff;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

.cv-profile-company {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
  margin-bottom: 0.2rem;
}

.cv-profile-exp {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  font-style: italic;
}

/* Sections */
.cv-section {
  padding: 1.25rem 1.75rem;
  border-bottom: 1px solid #f0f0f0;
}

.cv-section--last {
  border-bottom: none;
  padding-bottom: 1.75rem;
}

.cv-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: #0e527d;
  margin-bottom: 1rem;
}

/* Info Items */
.cv-info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  background: #f8fafb;
  transition: background 0.2s;
}

.cv-info-item:hover {
  background: #eef4f8;
}

.cv-info-icon {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
}

.cv-info-label {
  font-size: 0.75rem;
  color: #8a9bae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 2px;
}

.cv-info-value {
  font-size: 0.95rem;
  color: #212529;
  font-weight: 500;
  word-break: break-word;
}

/* Skills Section */
.cv-skills-section {
  margin-bottom: 0.85rem;
}

.cv-skills-section:last-child {
  margin-bottom: 0;
}

.cv-skills-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #8a9bae;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.4rem;
}

.cv-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.cv-skill-badge {
  padding: 0.3rem 0.7rem;
  border-radius: 20px;
  font-size: 0.82rem;
  font-weight: 500;
  display: inline-block;
  transition: transform 0.15s, box-shadow 0.15s;
}

.cv-skill-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.cv-skill-badge--primary {
  background: #e3f2fd;
  color: #0d47a1;
  border: 1px solid #bbdefb;
}

.cv-skill-badge--secondary {
  background: #e8f5e9;
  color: #1b5e20;
  border: 1px solid #c8e6c9;
}

.cv-skill-badge--other {
  background: #fff3e0;
  color: #e65100;
  border: 1px solid #ffe0b2;
}

/* Resume Button */
.cv-resume-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.6rem 1.25rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  font-weight: 600;
  font-size: 0.9rem;
  text-decoration: none;
  transition: opacity 0.2s, transform 0.15s;
}

.cv-resume-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  color: #fff;
  text-decoration: none;
}

.cv-resume-ext {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  margin-left: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* ========== Candidates Page - Premium UI ========== */

/* Hero Banner */
.cd-hero {
  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 50%, #46a4cf 100%);
  border-radius: 16px;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  position: relative;
  overflow: hidden;
}

.cd-hero::before {
  content: "";
  position: absolute;
  top: -40%;
  right: -5%;
  width: 250px;
  height: 250px;
  background: rgba(255, 255, 255, 0.06);
  border-radius: 50%;
}

.cd-hero::after {
  content: "";
  position: absolute;
  bottom: -60%;
  right: 10%;
  width: 180px;
  height: 180px;
  background: rgba(255, 255, 255, 0.04);
  border-radius: 50%;
}

.cd-hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.cd-hero-title {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.3px;
}

.cd-hero-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  margin: 0.2rem 0 0;
}

.cd-hero-right {
  display: flex;
  gap: 1.5rem;
}

.cd-hero-stat {
  text-align: center;
}

.cd-hero-stat-number {
  display: block;
  color: #fff;
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
}

.cd-hero-stat-label {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

/* Controls Bar */
.cd-controls {
  background: #fff;
  border-radius: 14px;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid #f0f0f0;
}

.cd-controls-top {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #f5f5f5;
}

.cd-search-wrapper {
  flex: 1 1;
  max-width: 400px;
  position: relative;
}

.cd-search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.85rem;
  z-index: 2;
}

.cd-search-wrapper .cd-search-input {
  padding-left: 36px !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 10px !important;
  height: 40px;
  font-size: 0.88rem;
  background: #f9fafb !important;
  transition: all 0.2s;
}

.cd-search-wrapper .cd-search-input:focus {
  border-color: #1a87cb !important;
  background: #fff !important;
  box-shadow: 0 0 0 3px rgba(26, 135, 203, 0.1) !important;
}

.cd-search-clear {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  font-size: 11px;
  z-index: 2;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cd-search-clear:hover {
  background: #f3f4f6;
  color: #374151;
}

.cd-controls-right-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
}

.cd-company-select {
  width: 185px;
}

/* Filter Chips */
.cd-controls-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.cd-filters {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.cd-filter-chip-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.cd-filter-chip {
  display: flex;
  align-items: center;
  background: #f4f7fa;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0;
  overflow: hidden;
  transition: border-color 0.2s;
}

.cd-filter-chip:focus-within {
  border-color: #1a87cb;
  box-shadow: 0 0 0 2px rgba(26, 135, 203, 0.1);
}

.cd-filter-chip-icon {
  padding: 0 0.6rem;
  color: #6b7280;
  font-size: 0.8rem;
  border-right: 1px solid #e5e7eb;
  height: 36px;
  display: flex;
  align-items: center;
  background: #eef1f5;
}

.cd-filter-chip-select {
  border: none !important;
  background: transparent !important;
  font-size: 0.84rem;
  color: #374151;
  padding: 0.35rem 1.75rem 0.35rem 0.6rem;
  cursor: pointer;
  outline: none;
  min-width: 120px;
  appearance: auto;
}

.cd-clear-filters {
  display: flex;
  align-items: center;
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.cd-clear-filters:hover {
  background: #fee2e2;
  border-color: #f87171;
}

/* Action Buttons */
.cd-actions {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.cd-action-btn {
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  padding: 0.42rem 0.85rem !important;
  transition: all 0.2s !important;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.15rem;
}

.cd-action-btn--outline {
  background: #fff !important;
  color: #374151 !important;
  border: 1px solid #d1d5db !important;
}

.cd-action-btn--outline:hover {
  background: #f9fafb !important;
  border-color: #9ca3af !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.cd-action-btn--outline:disabled {
  opacity: 0.5 !important;
  transform: none !important;
}

.cd-action-btn--primary {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  color: #fff !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.25);
}

.cd-action-btn--primary:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(14, 82, 125, 0.35) !important;
}

/* Data Card */
.cd-data-card {
  border: none !important;
  border-radius: 14px !important;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04) !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: #fff !important;
  border: 1px solid #f0f0f0 !important;
}

.cd-table-wrapper {
  overflow: hidden;
}

.cd-loading-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px;
  background: #fafbfc;
}

/* ===== DataTable Cell Styles ===== */

/* Name Cell - Avatar + Name + Email */
.cd-name-cell {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.cd-name-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #0e527d, #1a87cb);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 1px;
}

.cd-name-text {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.88rem;
  line-height: 1.3;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cd-name-email {
  font-size: 0.73rem;
  color: #94a3b8;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Job Tag */
.cd-job-tag {
  background: #eff6ff;
  color: #1d4ed8;
  padding: 0.25rem 0.6rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #dbeafe;
}

/* Phone */
.cd-phone-cell {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  color: #475569;
}

.cd-phone-icon {
  color: #10b981;
  font-size: 0.7rem;
}

/* Source Badge */
.cd-source-badge {
  background: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* Cell Primary / Meta */
.cd-cell-primary {
  font-weight: 600;
  color: #1e293b;
  font-size: 0.85rem;
}

.cd-cell-meta {
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 2px;
  display: flex;
  align-items: center;
}

/* Pipeline Badge */
.cd-pipeline-badge {
  background: #fef3c7;
  color: #92400e;
  border: 1px solid #fde68a;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* HRMS Badge */
.cd-hrms-badge {
  background: #fae8ff;
  color: #86198f;
  border: 1px solid #f0abfc;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
  font-size: 0.78rem;
  font-weight: 600;
}

/* Talent Scan Button */
.cd-scan-btn {
  border: none;
  border-radius: 8px;
  padding: 0.3rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.2s;
}

.cd-scan-btn--ready {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.cd-scan-btn--ready:hover {
  background: #d1fae5;
  transform: translateY(-1px);
}

.cd-scan-btn--pending {
  background: #f1f5f9;
  color: #94a3b8;
  border: 1px solid #e2e8f0;
  cursor: not-allowed;
}

/* Actions Cell */
.cd-actions-cell {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  align-items: center;
}

.cd-actions-main {
  display: flex;
  gap: 0.3rem;
}

.cd-icon-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.82rem;
  transition: all 0.2s;
  color: #64748b;
}

.cd-icon-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.cd-icon-btn--edit:hover {
  background: #eff6ff;
  color: #2563eb;
  border-color: #bfdbfe;
}

.cd-icon-btn--view:hover {
  background: #f0fdf4;
  color: #16a34a;
  border-color: #bbf7d0;
}

.cd-icon-btn--logs:hover {
  background: #fefce8;
  color: #ca8a04;
  border-color: #fde68a;
}

/* Approval Buttons */
.cd-actions-approval {
  display: flex;
  gap: 0.25rem;
}

.cd-approval-btn {
  border: none;
  border-radius: 6px;
  padding: 0.2rem 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.15s;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.cd-approval-btn--approve {
  background: #dcfce7;
  color: #15803d;
}

.cd-approval-btn--approve:hover {
  background: #bbf7d0;
}

.cd-approval-btn--reject {
  background: #fee2e2;
  color: #dc2626;
}

.cd-approval-btn--reject:hover {
  background: #fecaca;
}

.cd-approval-btn--info {
  background: #e0f2fe;
  color: #0369a1;
}

.cd-approval-btn--info:hover {
  background: #bae6fd;
}

/* Empty State */
.cd-empty-state {
  text-align: center;
  padding: 3rem 1rem;
}

.cd-empty-icon {
  font-size: 2.5rem;
  color: #cbd5e1;
  margin-bottom: 0.75rem;
  display: block;
}

.cd-empty-text {
  font-size: 1rem;
  font-weight: 600;
  color: #475569;
  margin: 0;
}

.cd-empty-sub {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0.25rem 0 0;
}

/* ===== DataTable Overrides ===== */
#CandidateList_CardView .cd-datatable .p-datatable-thead > tr > th {
  background: #f8fafc !important;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  border-bottom: 2px solid #e2e8f0 !important;
  border-top: none !important;
  padding: 0.9rem 0.75rem;
  white-space: nowrap;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr {
  transition: all 0.15s ease;
  border-left: 3px solid transparent;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:nth-child(even) {
  background: #fafbfc;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:hover {
  background: #eff6ff !important;
  border-left-color: #1a87cb;
}

#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr > td {
  padding: 0.7rem 0.75rem;
  font-size: 0.86rem;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: middle;
}

/* Paginator */
#CandidateList_CardView .cd-datatable .p-paginator {
  border: none !important;
  background: #f8fafc !important;
  padding: 0.75rem 1rem !important;
  border-top: 2px solid #e2e8f0 !important;
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page {
  border-radius: 8px;
  min-width: 34px;
  height: 34px;
  margin: 0 2px;
  font-weight: 600;
  font-size: 0.82rem;
  transition: all 0.15s;
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page.p-highlight {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  border-color: transparent !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.3);
}

#CandidateList_CardView
  .cd-datatable
  .p-paginator
  .p-paginator-pages
  .p-paginator-page:not(.p-highlight):hover {
  background: #eff6ff !important;
}

/* Checkbox */
#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box {
  border-radius: 6px;
  border: 2px solid #cbd5e1;
  width: 20px;
  height: 20px;
  transition: all 0.15s;
}

#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box.p-highlight {
  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;
  border-color: #0e527d !important;
}

/* Scrollbar */
#CandidateList_CardView .cd-datatable .p-datatable-wrapper::-webkit-scrollbar {
  height: 6px;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

#CandidateList_CardView
  .cd-datatable
  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Responsive */
@media (max-width: 992px) {
  .cd-hero-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .cd-hero-right {
    align-self: flex-start;
  }
  .cd-controls-top {
    flex-direction: column;
    align-items: stretch;
  }
  .cd-search-wrapper {
    max-width: 100%;
  }
  .cd-controls-right-group {
    margin-left: 0;
  }
  .cd-controls-bottom {
    flex-direction: column;
    align-items: stretch;
  }
  .cd-actions {
    justify-content: flex-start;
  }
}

@media (max-width: 576px) {
  .cd-hero {
    padding: 1.25rem;
    border-radius: 12px;
  }
  .cd-hero-title {
    font-size: 1.25rem;
  }
  .cd-filter-chip-group {
    flex-direction: column;
  }
  .cd-actions {
    flex-direction: column;
  }
  .cd-action-btn {
    width: 100% !important;
    justify-content: center !important;
  }
}

#SecondScreeningContainer {
  height: 500px;
  overflow-y: scroll;
}

/* Telephonic Test Table Sticky Columns Starting */
#TelephonicTest_Table {
  position: relative;
}

#TelephonicTest_Table .rdt_Table,
#TelephonicTest_Table .sc-fLlhyt {
  position: relative;
}

#TelephonicTest_Table .rdt_TableBody {
  position: sticky;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(1) {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(2) {
  position: sticky;
  left: 180px;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableCol:nth-child(3) {
  position: sticky;
  left: 380px;
  top: 0;
  z-index: 1008;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {
  position: sticky;
  left: 0;
  top: 0;
  background-color: var(--white);
  z-index: 1;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {
  position: sticky;
  left: 180px;
  top: 0;
  z-index: 1;
}

#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {
  position: sticky;
  left: 380px;
  top: 0;
  z-index: 1;
  justify-content: initial;
}

#TelephonicTest_Table .rdt_TableRow:nth-child(even) .rdt_TableCell {
  background-color: var(--white);
}

#TelephonicTest_Table .rdt_TableRow:nth-child(odd) .rdt_TableCell {
  background-color: var(--table-row-bg-light-grey);
}

@media screen and (min-width: 100px) and (max-width: 991px) {
  #TelephonicTest_Table .rdt_TableBody {
    position: relative;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(1) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(2) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableCol:nth-child(3) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {
    position: relative;
    left: initial;
    top: initial;
  }

  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {
    position: relative;
    left: initial;
    top: initial;
  }
}
/* /Telephonic Test Table Sticky Columns Ending */

#SkillLevelConfiguration_TableView .rdt_Table .rdt_TableBody .rdt_TableRow {
  /* border: 2px solid white; */
  /* margin-bottom: 8px;
  margin-top: 8px; */
  padding-top: 5px;
  padding-bottom: 5px;
}
/* ── Bulk Outreach Modal ─────────────────────────────────────── */
.bo-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}
.bo-modal .modal-header {
  padding: 20px 24px 0;
  border: none;
}
.bo-modal .modal-body {
  padding: 0 24px 14px;
  background: linear-gradient(180deg, #f8fbff 0%, #f4f8ff 100%);
}
.bo-modal .modal-footer {
  padding: 18px 24px 22px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}
.bo-modal .modal-content {
  border: 0;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
}
.bo-modal .modal-header {
  padding: 22px 24px 10px;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.sent-email-modal .modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
}

.sent-email-modal-header {
  padding: 18px 22px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.sent-email-modal-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.4;
}

.sent-email-modal-body {
  padding: 16px;
  max-height: 78vh;
  overflow-y: auto;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.sent-email-modal-footer {
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.sent-email-preview-shell {
  width: 100%;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: #f8fafc;
}

.email-body-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #ffffff;
  color: #0f172a;
  overflow-wrap: anywhere;
  word-break: break-word;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.email-body-content img {
  max-width: 100% !important;
  height: auto !important;
}

.email-body-content table {
  max-width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.email-body-content td,
.email-body-content th {
  word-break: break-word;
  vertical-align: top;
}

.email-body-content a {
  color: #2563eb;
}

.email-body-content p,
.email-body-content div,
.email-body-content li,
.email-body-content span {
  line-height: 1.55;
}

.email-body-content ul,
.email-body-content ol {
  padding-left: 24px;
  margin-bottom: 1rem;
}

.email-body-content * {
  max-width: 100%;
}

.email-body-content > * {
  margin-left: auto !important;
  margin-right: auto !important;
}

.email-body-content > table,
.email-body-content > div,
.email-body-content > section {
  width: 100%;
}
.bo-tabs {
  display: flex;
  gap: 10px;
  margin: 14px 0 22px;
  border-bottom: 0;
}
.bo-tab {
  flex: 1 1;
  text-align: center;
  padding: 11px 12px;
  font-size: 13px;
  font-weight: 700;
  color: #64748b;
  border: 1px solid #dbe7f5;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  transition: 0.2s ease;
}
.bo-tab.active {
  color: #1d4ed8;
  border-color: #bfdbfe;
  background: #eff6ff;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
}
.bo-tab.done {
  color: #15803d;
  background: #f0fdf4;
  border-color: #bbf7d0;
}
.bo-channel-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
  font-size: 0;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s ease;
}
.bo-channel-btn::after {
  content: "Email";
  font-size: 13px;
  line-height: 1;
}
.bo-channel-btn.wp::after {
  content: "WhatsApp";
}
.bo-channel-btn.active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #2563eb;
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);
}
.bo-channel-btn.active.wp {
  border-color: #16a34a;
  background: #f0fdf4;
  color: #16a34a;
  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.12);
}
.bo-channel-btn svg {
  font-size: 15px;
  flex-shrink: 0;
}
.bo-channel-btn input {
  flex-shrink: 0;
}

.bo-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #64748b;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.bo-input {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 11px 14px;
  font-size: 14px;
  background: #ffffff;
  color: #0f172a;
  outline: none;
  transition: 0.15s ease;
}
.bo-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}
.bo-textarea {
  resize: vertical;
  min-height: 190px;
  font-family: inherit;
}
.bo-input-subject {
  min-height: 48px;
  border-width: 1.5px;
  font-weight: 600;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}
.bo-input-message {
  min-height: 220px;
  line-height: 1.65;
  border-width: 1.5px;
  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 100%);
}
.bo-input-subject::placeholder,
.bo-input-message::placeholder {
  color: #94a3b8;
}
.bo-review-list {
  height: auto;
  min-height: 0;
  max-height: 320px;
  overflow-y: auto;
  overflow-x: hidden;
}
.bo-review-list::-webkit-scrollbar {
  width: 8px;
}
.bo-review-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}
.bo-review-list::-webkit-scrollbar-track {
  background: #f8fafc;
}
.bo-panel {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}
.bo-section-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
}
.bo-section-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2563eb;
  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);
  flex-shrink: 0;
}
.bo-section-title {
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
  color: #0f172a;
}
.bo-section-subtitle {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.bo-vars {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}
.bo-var {
  background: #f1f5f9;
  color: #475569;
  border-radius: 6px;
  padding: 3px 10px;
  font-size: 12px;
  font-family: monospace;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  transition: 0.15s;
}
.bo-var:hover {
  background: #e2e8f0;
}

.bo-hint {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 13px;
  color: #9a3412;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  margin-top: 16px;
}

.bo-alert {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 13px;
  color: #1d4ed8;
  margin-bottom: 18px;
}

.bo-info-row {
  display: flex;
  align-items: baseline;
  padding: 6px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
}
.bo-info-row:last-child {
  border: none;
}
.bo-info-label {
  width: 110px;
  color: #64748b;
  font-size: 13px;
  flex-shrink: 0;
}

.bo-card {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px 20px;
  height: 300px;
  overflow: auto;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}
.bo-card-1 {
  background: #ffffff;
  border: 1px solid #d9e4f5;
  border-radius: 18px;
  padding: 18px 20px;
  /* height: 300px; */
  /* overflow: auto; */
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
}

.bo-candidate-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}
.bo-candidate-item:last-child {
  border: none;
}
.bo-avatar {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.bo-check-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  font-size: 14px;
  cursor: pointer;
}
.bo-check-row input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2563eb;
  cursor: pointer;
}

.bo-btn-primary {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);
}
.bo-btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24);
}
.bo-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.bo-btn-secondary {
  background: #fff;
  color: #374151;
  border: 1px solid #d6deeb;
  border-radius: 12px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.15s ease;
}
.bo-btn-secondary:hover {
  background: #f8fafc;
  border-color: #bfdbfe;
  color: #1d4ed8;
}
@media (max-width: 767px) {
  .bo-tabs {
    flex-direction: column;
  }
  .bo-modal .modal-body {
    padding: 0 16px 14px;
  }
  .bo-modal .modal-footer {
    padding: 16px;
    flex-direction: column;
    gap: 12px;
  }
  .bo-card,
  .bo-card-1,
  .bo-panel {
    padding: 16px;
  }
}
.cs-root {
  min-height: 100vh;
  background: #eef0f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 16px 48px;
    font-family: 'DM Sans', sans-serif;
}

.cs-card {
  background: #fff;
  border-radius: 20px;
  width: 100%;
  max-width: 420px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.10);
  overflow: hidden;
}

/* ── Header Banner ── */
.cs-header {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 60%, #6366f1 100%);
  padding: 28px 24px 32px;
  position: relative;
  overflow: hidden;
}
.cs-header::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -40px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.cs-header::after {
  content: "";
  position: absolute;
  bottom: -30px;
  left: -20px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}
.cs-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.cs-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.cs-logo {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.cs-company-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.cs-company-sub {
  color: rgba(255, 255, 255, 0.65);
  font-size: 11px;
  font-weight: 400;
}
.cs-expires {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}
.cs-job-title {
  font-family: "Fraunces", serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 8px;
  line-height: 1.2;
}
.cs-greeting {
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
  line-height: 1.5;
}
.cs-greeting strong {
  color: #fff;
  font-weight: 600;
}

/* ── Body ── */
.cs-body {
  padding: 24px;
}

/* Info grid */
.cs-info-grid {
  display: grid;
  /* grid-template-columns: 2fr 2fr; */
  gap: 10px;
  margin-bottom: 22px;
}
.cs-info-box {
  background: #f7f8fc;
  border: 1px solid #ebebf0;
  border-radius: 12px;
  padding: 12px 14px;
}
.cs-info-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #9399a6;
  text-transform: uppercase;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cs-info-value {
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
  line-height: 1.3;
}

/* Section label */
.cs-section-label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9399a6;
  margin-bottom: 10px;
}

/* About the role */
.cs-about {
  margin-bottom: 22px;
}
.cs-about-text {
  font-size: 13.5px;
  color: #444b5a;
  line-height: 1.65;
  margin-bottom: 10px;
}
.cs-bullet {
  font-size: 13px;
  color: #555e6e;
  line-height: 1.6;
  padding-left: 14px;
  position: relative;
}
.cs-bullet::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #7c3aed;
  font-weight: 700;
}

/* Skills */
.cs-skills {
  margin-bottom: 22px;
}
.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.cs-skill-chip {
  background: #f0f0f8;
  border: 1px solid #ddddf5;
  color: #3d3d8f;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 20px;
}

/* Interview process */
.cs-process {
  margin-bottom: 26px;
}
.cs-round {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: #f7f8fc;
  border: 1px solid #ebebf0;
  border-radius: 12px;
  margin-bottom: 8px;
}
.cs-round:last-child {
  margin-bottom: 0;
}
.cs-round-num {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #7c3aed;
  color: #7c3aed;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
}
.cs-round-title {
  font-size: 13.5px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 2px;
}
.cs-round-sub {
  font-size: 12px;
  color: #8b93a4;
}

/* Divider */
.cs-divider {
  border: none;
  border-top: 1px solid #ebebf0;
  margin: 6px 0 22px;
}

/* CTA section */
.cs-cta-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1d23;
  text-align: center;
  margin-bottom: 5px;
}
.cs-cta-sub {
  font-size: 13px;
  color: #9399a6;
  text-align: center;
  margin-bottom: 18px;
}

/* Response buttons */
.cs-btn-interested {
  width: 100%;
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  margin-bottom: 10px;
  transition: all 0.18s ease;
  text-align: left;
}
.cs-btn-interested:hover {
  background: #dcfce7;
  border-color: #4ade80;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.15);
}
.cs-btn-interested.selected {
  background: #dcfce7;
  border-color: #22c55e;
}
.cs-btn-decline {
  width: 100%;
  background: #fff;
  border: 1.5px solid #fecaca;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  transition: all 0.18s ease;
  text-align: left;
}
.cs-btn-decline:hover {
  background: #fef2f2;
  border-color: #f87171;
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.12);
}
.cs-btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}
.cs-btn-icon.green {
  background: #22c55e;
}
.cs-btn-icon.red {
  background: #ef4444;
}
.cs-btn-label {
  font-size: 14px;
  font-weight: 700;
  color: #1a1d23;
  margin-bottom: 2px;
}
.cs-btn-label.green {
  color: #15803d;
}
.cs-btn-label.red {
  color: #dc2626;
}
.cs-btn-sublabel {
  font-size: 12px;
  color: #8b93a4;
}
.cs-btn-arrow {
  margin-left: auto;
  color: #22c55e;
  font-size: 18px;
  font-weight: 300;
}

/* Schedule slot picker */
.cs-schedule-box {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 10px;
  animation: fadeSlideIn 0.25s ease;
}
@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.cs-schedule-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}
.cs-schedule-icon {
  width: 28px;
  height: 28px;
  background: #22c55e;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
}
.cs-schedule-title {
  font-size: 14px;
  font-weight: 700;
  color: #15803d;
}
.cs-schedule-sub {
  font-size: 12px;
  color: #4ade80;
}
.cs-slot-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 14px;
}
.cs-slot-field label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.cs-slot-field input {
  width: 100%;
  padding: 9px 12px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  font-size: 13px;
  font-family: "DM Sans", sans-serif;
  color: #1a1d23;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
}
.cs-slot-field input:focus {
  border-color: #7c3aed;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}
.cs-slot-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}
.cs-back-btn {
  background: #fff;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.cs-back-btn:hover {
  background: #f9fafb;
}
.cs-confirm-btn {
  flex: 1 1;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border: none;
  border-radius: 10px;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.18s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 3px 12px rgba(124, 58, 237, 0.35);
}
.cs-confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);
}
.cs-confirm-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.cs-slot-error {
  font-size: 12px;
  color: #f59e0b;
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Declined state */
.cs-declined-box {
  background: #fef2f2;
  border: 1.5px solid #fecaca;
  border-radius: 14px;
  padding: 16px;
  text-align: center;
  animation: fadeSlideIn 0.25s ease;
}
.cs-declined-icon {
  font-size: 28px;
  margin-bottom: 8px;
}
.cs-declined-title {
  font-size: 15px;
  font-weight: 700;
  color: #dc2626;
  margin-bottom: 4px;
}
.cs-declined-sub {
  font-size: 13px;
  color: #9399a6;
}

/* Confirmed state */
.cs-confirmed-box {
  background: #f0fdf4;
  border: 1.5px solid #86efac;
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  animation: fadeSlideIn 0.25s ease;
}
.cs-confirmed-icon {
  font-size: 36px;
  margin-bottom: 10px;
}
.cs-confirmed-title {
  font-size: 16px;
  font-weight: 700;
  color: #15803d;
  margin-bottom: 4px;
}
.cs-confirmed-sub {
  font-size: 13px;
  color: #6b7280;
}

/* Privacy note */
.cs-privacy {
  text-align: center;
  font-size: 12px;
  color: #9399a6;
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* Footer */
.cs-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #9399a6;
}
.cs-footer a {
  color: #6366f1;
  font-weight: 600;
  text-decoration: none;
}
.cs-root {
  min-height: 100vh;
  background: linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 40px;
  font-family: "Segoe UI", sans-serif;
}
.cs-card {
  width: 100%;
  max-width: 820px;
  background: #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 16px 50px rgba(15, 23, 42, 0.12);
}
.cs-header {
  padding: 20px 20px 10px 20px;
  background: linear-gradient(135deg, #0f766e 0%, #155e75 100%);
  color: #fff;
}
.cs-kicker {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.8;
  margin-bottom: 8px;
}
.cs-company-name {
  font-size: 15px;
  font-weight: 600;
  opacity: 0.92;
  margin-bottom: 8px;
}
.cs-job-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 10px;
}
.cs-greeting {
  font-size: 14px;
  line-height: 1.6;
  opacity: 0.95;
  max-width: 680px;
}
.cs-body {
  padding: 28px;
}
.cs-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}
.cs-info-box {
  padding: 14px 16px;
  border-radius: 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.cs-info-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  margin-bottom: 6px;
}
.cs-info-value {
  font-size: 14px;
  color: #0f172a;
  font-weight: 600;
  line-height: 1.5;
}
.cs-section {
  margin-bottom: 24px;
}
.cs-section-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
  margin-bottom: 12px;
}
.cs-about-text {
  color: #334155;
  font-size: 14px;
  line-height: 1.7;
  margin: 0 0 10px;
}
.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.cs-skill-chip {
  padding: 8px 12px;
  border-radius: 999px;
  background: #ecfeff;
  border: 1px solid #a5f3fc;
  color: #155e75;
  font-size: 13px;
  font-weight: 600;
}
.cs-divider {
  border: 0;
  border-top: 1px solid #e2e8f0;
  margin: 24px 0;
}
.cs-cta-title {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 6px;
}
.cs-cta-sub {
  text-align: center;
  color: #64748b;
  margin-bottom: 20px;
  font-size: 14px;
}
.cs-btn-interested,
.cs-btn-decline {
  width: 100%;
  border-radius: 16px;
  padding: 16px 18px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: 0.2s ease;
}
.cs-btn-interested {
  border: 1px solid #86efac;
  background: #f0fdf4;
  margin-bottom: 12px;
}
.cs-btn-decline {
  border: 1px solid #fecaca;
  background: #fff7f7;
}
.cs-btn-interested.selected {
  background: #dcfce7;
}
.cs-btn-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  flex-shrink: 0;
}
.cs-btn-icon.green {
  background: #16a34a;
}
.cs-btn-icon.red {
  background: #dc2626;
}
.cs-btn-label {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}
.cs-btn-sublabel {
  font-size: 13px;
  color: #64748b;
}
.cs-btn-arrow {
  margin-left: auto;
  color: #16a34a;
  font-size: 20px;
}
.cs-schedule-box,
.cs-declined-box,
.cs-confirmed-box {
  border-radius: 16px;
  padding: 18px;
}
.cs-schedule-box {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
}
.cs-slot-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}
.cs-slot-field label {
  display: block;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  margin-bottom: 6px;
}
.cs-slot-field input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  font-size: 14px;
}
.cs-slot-actions {
  display: flex;
  gap: 10px;
}
.cs-back-btn,
.cs-confirm-btn {
  border-radius: 10px;
  padding: 11px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.cs-back-btn {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}
.cs-confirm-btn {
  border: 0;
  background: #0f766e;
  color: #fff;
  flex: 1 1;
}

#TemplateForJobOpportunity .btn-success {
  border: 0;
  background: #0f766e !important;
  color: #fff;
}

.cs-slot-error {
  margin-top: 10px;
  color: #b45309;
  font-size: 13px;
  font-weight: 600;
}
.cs-declined-box {
  background: #fef2f2;
  border: 1px solid #fecaca;
  text-align: center;
}
.cs-confirmed-box {
  background: #f0fdf4;
  border: 1px solid #86efac;
  text-align: center;
}
.cs-state-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
}
.cs-state-sub {
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
}
.cs-privacy {
  text-align: center;
  margin-top: 18px;
  color: #64748b;
  font-size: 13px;
}
.cs-footer {
  margin-top: 16px;
  color: #64748b;
  font-size: 12px;
  text-align: center;
}
@media (max-width: 640px) {
  .cs-header,
  .cs-body {
    padding: 20px;
  }
  .cs-job-title {
    font-size: 26px;
  }
  .cs-info-grid,
  .cs-slot-row {
    grid-template-columns: 1fr;
  }
}
.bo-input {
  padding: 6px 30px 6px 10px; /* space for arrow */
  appearance: none; /* remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: #fff;
  border: 1px solid #d4dce7;
  border-radius: 6px;
  font-size: 14px;
  height: 36px;
  /* background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='14' viewBox='0 0 20 20' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.148l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.041a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>"); */
  background-repeat: no-repeat;
  background-position: right 10px center; /* arrow aligned */
  cursor: pointer;
}
.react-select__menu {
  z-index: 99999 !important;
}

.react-select__menu-list {
  z-index: 99999 !important;
}
/* Recruiter Report */
.recruiter-report-page {
  padding: 16px 12px 28px;
  background: radial-gradient(
      circle at top right,
      rgba(59, 130, 246, 0.08),
      transparent 22%
    ),
    linear-gradient(180deg, #f6f9fc 0%, #eef4fb 100%);
  min-height: calc(100vh - 110px);
}

.recruiter-report-hero {
  background: radial-gradient(
      circle at top left,
      rgba(255, 255, 255, 0.22),
      transparent 18%
    ),
    linear-gradient(135deg, #163b8c 0%, #155e75 45%, #0f172a 100%);
  border-radius: 28px;
  padding: 22px 24px;
  color: #fff;
  margin-bottom: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.18);
}

.recruiter-report-hero-copy {
  flex: 1 1 560px;
}

.recruiter-report-eyebrow {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  opacity: 0.78;
  font-weight: 700;
  margin-bottom: 6px;
}

.recruiter-report-title {
  font-size: 32px;
  font-weight: 800;
  line-height: 1.05;
}

.recruiter-report-subtitle {
  font-size: 14px;
  opacity: 0.92;
  line-height: 1.55;
  max-width: 760px;
}

.recruiter-report-company-card {
  min-width: 250px;
  max-width: 300px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 20px;
  padding: 12px;
  backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.recruiter-report-company-label {
  font-size: 11px;
  margin-bottom: 6px;
  display: block;
  opacity: 0.92;
  font-weight: 700;
}

.recruiter-report-loading,
.recruiter-report-error {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #dbe7f5;
  border-radius: 22px;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.06);
}

.recruiter-report-loading {
  padding: 40px 18px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.recruiter-report-loading-text {
  margin-top: 12px;
  color: #64748b;
  font-size: 14px;
  font-weight: 600;
}

.recruiter-report-error {
  color: #be123c;
  padding: 16px;
}

.recruiter-report-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.recruiter-summary-card {
  border-radius: 22px;
  padding: 18px 16px;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.recruiter-summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);
}

.recruiter-summary-card-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.recruiter-summary-value {
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
}

.recruiter-summary-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  margin-top: 8px;
}

.recruiter-summary-accent {
  width: 34px;
  height: 34px;
  border-radius: 12px;
}

.recruiter-panel,
.recruiter-breakdown-panel {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid #dbe7f5;
  border-radius: 24px;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.06);
}

.recruiter-panel {
  padding: 18px;
  height: 100%;
}

.recruiter-panel-header,
.recruiter-breakdown-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.recruiter-panel-header {
  margin-bottom: 16px;
}

.recruiter-panel-title {
  font-size: 17px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-panel-kicker,
.recruiter-breakdown-count {
  font-size: 11px;
  color: #64748b;
  font-weight: 700;
}

.recruiter-snapshot-list,
.recruiter-metrics-list {
  display: grid;
  gap: 12px;
}

.recruiter-snapshot-card {
  display: grid;
  grid-template-columns: 48px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 16px 18px;
  border-radius: 20px;
  border: 1px solid #e5edf8;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.03);
}

.recruiter-avatar,
.recruiter-table-avatar {
  background: linear-gradient(135deg, #2563eb 0%, #0f766e 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  flex-shrink: 0;
}

.recruiter-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.recruiter-snapshot-name {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-snapshot-meta {
  font-size: 12px;
  color: #64748b;
  margin-top: 3px;
}

.recruiter-progress-track,
.recruiter-table-bartrack {
  margin-top: 9px;
  height: 6px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.recruiter-progress-bar {
  height: 100%;
  border-radius: 999px;
}

.recruiter-snapshot-side {
  text-align: right;
}

.recruiter-snapshot-score {
  font-size: 20px;
  font-weight: 800;
  color: #2563eb;
  line-height: 1;
}

.recruiter-snapshot-side-label,
.recruiter-table-subtext,
.recruiter-breakdown-subtitle,
.recruiter-empty-state {
  font-size: 10px;
  color: #64748b;
}

.recruiter-snapshot-side-label {
  margin-top: 4px;
}

.recruiter-metric-card {
  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);
  border: 1px solid #e5edf8;
  border-radius: 16px;
  padding: 14px 15px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.02);
}

.recruiter-metric-title {
  font-size: 12px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 4px;
}

.recruiter-metric-desc {
  font-size: 12px;
  color: #475569;
}

.recruiter-breakdown-panel {
  overflow: hidden;
}

.recruiter-breakdown-header {
  padding: 18px;
  border-bottom: 1px solid #e5edf8;
}

.recruiter-breakdown-subtitle {
  margin-top: 4px;
}

.recruiter-breakdown-table-wrap {
  overflow-x: auto;
}

.recruiter-breakdown-table {
  width: 100%;
}

.recruiter-breakdown-table thead {
  background: #f8fbff;
}

.recruiter-breakdown-table th {
  padding: 14px 16px;
  text-align: left;
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  border-bottom: 1px solid #e5edf8;
  white-space: nowrap;
}

.recruiter-breakdown-table tbody tr.is-alt td {
  background: #fcfdff !important;
}

.recruiter-table-person {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recruiter-table-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 13px;
}

.recruiter-table-name {
  color: #0f172a;
  font-weight: 200;
}

.recruiter-table-barcell {
  min-width: 90px;
}

.recruiter-table-barvalue {
  color: #0f172a;
  font-weight: 700;
}

.recruiter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  padding: 5px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.recruiter-chip-warn {
  color: #b45309;
  background: #fff7ed;
}

.recruiter-chip-pink {
  color: #be185d;
  background: #fdf2f8;
}

.recruiter-chip-blue {
  color: #1d4ed8;
  background: #eff6ff;
}

.recruiter-chip-teal {
  color: #0f766e;
  background: #ecfeff;
}

.recruiter-chip-green {
  color: #15803d;
  background: #f0fdf4;
}

.recruiter-empty-table {
  padding: 24px;
  text-align: center;
  color: #64748b;
}

@media (max-width: 991px) {
  .recruiter-report-hero {
    border-radius: 22px;
    padding: 18px 16px;
  }

  .recruiter-report-title {
    font-size: 26px;
  }

  .recruiter-report-company-card {
    width: 100%;
    max-width: none;
  }

  .recruiter-panel,
  .recruiter-breakdown-panel {
    border-radius: 20px;
  }
}

@media (max-width: 640px) {
  .recruiter-report-page {
    padding: 12px 6px 24px;
  }

  .recruiter-report-title {
    font-size: 22px;
  }

  .recruiter-summary-card,
  .recruiter-panel {
    border-radius: 18px;
  }

  .recruiter-snapshot-card {
    grid-template-columns: 44px 1fr;
  }

  .recruiter-snapshot-side {
    grid-column: 2;
    text-align: left;
  }
}

/* Recruiter Report Refinements */
.recruiter-report-page {
  padding: 14px 14px 28px;
  background: radial-gradient(
      circle at top left,
      rgba(14, 165, 233, 0.08),
      transparent 24%
    ),
    radial-gradient(
      circle at right 20%,
      rgba(37, 99, 235, 0.07),
      transparent 18%
    ),
    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);
}

.recruiter-report-hero {
  position: relative;
  overflow: hidden;
  /* min-height: 152px; */
  margin-bottom: 14px;
  padding: 20px 22px 16px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.12);
}

.recruiter-report-hero-copy,
.recruiter-report-company-card {
  position: relative;
  z-index: 2;
}

.recruiter-report-hero-copy {
  max-width: 820px;
}

.recruiter-report-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  letter-spacing: 0.16em;
}

.recruiter-report-title {
  margin-top: 12px;
  margin-bottom: 6px !important;
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
  color: #ffffff;
}

.recruiter-report-subtitle {
  max-width: 720px;
  font-size: 13px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.78);
}

.recruiter-report-hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.recruiter-report-hero-pill {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
  min-width: 118px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.84);
  backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.recruiter-report-hero-pill-highlight {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.14) 0%,
    rgba(59, 130, 246, 0.18) 100%
  );
}

.recruiter-report-hero-pill-value {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.1;
  color: #ffffff;
}

.recruiter-report-company-card {
  min-width: 260px;
  max-width: 290px;
  padding: 14px;
  border-radius: 18px;
  background: rgba(15, 23, 42, 0.28);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(12px);
}

.recruiter-report-company-label {
  margin-bottom: 4px;
  color: rgba(255, 255, 255, 0.68);
}

.recruiter-report-company-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
}

.recruiter-report-company-footnote {
  margin-top: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.74);
}

.recruiter-report-company-card .form-select,
.recruiter-report-company-card select,
.recruiter-report-company-card .form-control {
  min-height: 46px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.35);
  box-shadow: none;
}

.recruiter-report-filter-bar {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1.2fr) repeat(
      2,
      minmax(160px, 0.8fr)
    ) auto;
  gap: 12px;
  align-items: end;
  margin-bottom: 14px;
  padding: 14px 16px;
  border-radius: 20px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.recruiter-report-filter-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 90px;
  padding: 12px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #f2f7fd 100%);
  border: 1px solid #dbe7f3;
}

.recruiter-report-filter-summary-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-report-filter-summary-value {
  margin-top: 5px;
  font-size: 20px;
  line-height: 1.15;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-report-filter-summary-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}

.recruiter-report-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.recruiter-report-filter-group-wide {
  min-width: 0;
}

.recruiter-report-filter-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-report-filter-input {
  min-height: 40px;
  border-radius: 12px;
  border: 1px solid #d7e3f1;
  background: #f8fbff;
  color: #0f172a;
  box-shadow: none;
}

.recruiter-report-filter-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);
  background: #ffffff;
}

.recruiter-report-filter-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.recruiter-report-filter-chip {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-report-filter-chip-soft {
  background: #f8fafc;
  color: #475569;
}

.recruiter-report-filter-reset {
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 12px;
  border: 1px solid #d7e3f1;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-report-filter-reset:hover {
  background: #f8fbff;
  border-color: #bfd3ea;
}

.recruiter-report-hero-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(2px);
  opacity: 0.55;
}

.recruiter-report-hero-orb-one {
  top: -40px;
  right: 220px;
  width: 160px;
  height: 160px;
  background: radial-gradient(
    circle,
    rgba(14, 165, 233, 0.42) 0%,
    rgba(14, 165, 233, 0) 72%
  );
}

.recruiter-report-hero-orb-two {
  right: -20px;
  bottom: -36px;
  width: 220px;
  height: 220px;
  background: radial-gradient(
    circle,
    rgba(37, 99, 235, 0.34) 0%,
    rgba(37, 99, 235, 0) 72%
  );
}

.recruiter-report-loading,
.recruiter-report-error {
  min-height: 180px;
  border-radius: 22px;
  border: 1px solid #dce8f5;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.96) 0%,
    rgba(246, 250, 255, 0.98) 100%
  );
  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.06);
}

.recruiter-report-loading {
  gap: 14px;
}

.recruiter-report-loading-text {
  font-size: 15px;
  font-weight: 600;
  color: #47617d;
}

.recruiter-report-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin-bottom: 14px;
}

.recruiter-summary-card {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
}

.recruiter-summary-card::after {
  content: "";
  position: absolute;
  inset: auto -18px -18px auto;
  width: 88px;
  height: 88px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.24);
}

.recruiter-summary-card-inner {
  position: relative;
  z-index: 1;
  min-height: 74px;
}

.recruiter-summary-value {
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.recruiter-summary-label {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #47617d;
}

.recruiter-summary-accent {
  width: 38px;
  height: 38px;
  border-radius: 14px;
}

.recruiter-insight-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

.recruiter-insight-item {
  padding: 14px 16px;
  border-radius: 18px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.recruiter-insight-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-insight-value {
  margin-top: 8px;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-insight-value-small {
  font-size: 15px;
}

.recruiter-panel,
.recruiter-breakdown-panel {
  border-radius: 20px;
  border: 1px solid #dbe7f3;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
  backdrop-filter: blur(12px);
}

.recruiter-panel-header,
.recruiter-breakdown-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px 12px;
}

.recruiter-panel-title {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.recruiter-panel-subtitle,
.recruiter-breakdown-subtitle {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.recruiter-panel-kicker,
.recruiter-breakdown-count {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.recruiter-snapshot-list,
.recruiter-metrics-list {
  padding: 0 18px 18px;
}

.recruiter-snapshot-list {
  display: grid;
  gap: 12px;
}

.recruiter-snapshot-card {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.recruiter-rank-badge {
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 999px;
  background: #e8f1ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
}

.recruiter-snapshot-main {
  min-width: 0;
}

.recruiter-snapshot-card:hover,
.recruiter-metric-card:hover,
.recruiter-summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);
}

.recruiter-avatar,
.recruiter-table-avatar {
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);
}

.recruiter-progress-track,
.recruiter-table-bartrack {
  height: 8px;
  background: #e8eef7;
}

.recruiter-snapshot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.recruiter-inline-chip {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

.recruiter-inline-chip-violet {
  background: #f5f3ff;
  color: #7c3aed;
}

.recruiter-inline-chip-blue {
  background: #eff6ff;
  color: #2563eb;
}

.recruiter-snapshot-score {
  font-size: 26px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-snapshot-side {
  min-width: 110px;
  text-align: right;
}

.recruiter-snapshot-side-label {
  font-size: 11px;
  color: #64748b;
}

.recruiter-metrics-list {
  display: grid;
  gap: 12px;
}

.recruiter-metrics-list-tight {
  gap: 10px;
}

.recruiter-scope-card {
  padding: 14px;
  border-radius: 16px;
  border: 1px solid #dbe7f3;
  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);
}

.recruiter-scope-title {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.recruiter-scope-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.recruiter-scope-k {
  display: block;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.recruiter-scope-v {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  word-break: break-word;
}

.recruiter-metric-card {
  position: relative;
  overflow: hidden;
  padding: 12px 14px 12px;
  border-radius: 14px;
}

.recruiter-metric-card::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(180deg, #2563eb 0%, #0f766e 100%);
}

.recruiter-breakdown-header {
  padding-bottom: 18px;
}

.recruiter-breakdown-table thead {
  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fd 100%);
}

.recruiter-breakdown-table th {
  font-size: 10.5px;
  letter-spacing: 0.08em;
}

.recruiter-breakdown-table td {
  font-size: 13px;
}

.recruiter-breakdown-table tbody td {
  vertical-align: middle;
}

.recruiter-breakdown-table tbody tr:hover td {
  background: #f8fbff !important;
}

.recruiter-chip {
  min-width: 44px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);
}

.recruiter-detail-modal .modal-content {
  overflow: hidden;
  border: 1px solid rgba(191, 219, 254, 0.8);
  border-radius: 24px;
  background: radial-gradient(
      circle at top right,
      rgba(59, 130, 246, 0.12),
      transparent 28%
    ),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);
}

.recruiter-detail-modal .modal-dialog {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.recruiter-detail-modal-header {
  position: relative;
  padding: 22px 24px 14px !important;
  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 56%, #f0fdf4 100%);
  border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;
}

.recruiter-detail-modal-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-right: 64px;
}

.recruiter-detail-modal-header::after {
  content: "";
  position: absolute;
  inset: auto 24px 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    rgba(37, 99, 235, 0.2),
    rgba(16, 185, 129, 0.16)
  );
}

.recruiter-detail-modal-heading {
  min-width: 0;
  flex: 1 1 auto;
}

.recruiter-detail-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
}

.recruiter-detail-modal-title {
  font-size: 1.12rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.recruiter-detail-modal-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 8px;
  font-size: 0;
  color: #64748b;
}

.recruiter-detail-modal-meta > span {
  font-size: 0.9rem;
}

.recruiter-detail-modal-dot {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: #94a3b8;
}

.recruiter-detail-modal-count {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.08);
  color: #1d4ed8;
  font-size: 0.78rem;
  font-weight: 700;
}

.recruiter-detail-modal .btn-close {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 34px;
  height: 34px;
  margin: 0 !important;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.86);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
  opacity: 1;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.recruiter-detail-modal .btn-close:hover {
  transform: rotate(90deg);
  background-color: #ffffff;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
}

.recruiter-detail-modal-export {
  min-height: 42px;
  padding: 10px 16px;
  border: 1px solid rgba(37, 99, 235, 0.18);
  border-radius: 12px;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: 0.01em;
  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.recruiter-detail-modal-export:hover {
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 14px 28px rgba(29, 78, 216, 0.28);
}

.recruiter-detail-modal-export:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.recruiter-detail-modal-body {
  padding: 18px 24px 24px !important;
  max-height: 68vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.7) transparent;
}

.recruiter-detail-modal-body::-webkit-scrollbar {
  width: 10px;
}

.recruiter-detail-modal-body::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.65);
  background-clip: padding-box;
}

.recruiter-detail-modal-table-wrap {
  overflow: hidden;
  border: 1px solid #dbe7f3;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.recruiter-detail-modal-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);
  white-space: nowrap;
  font-size: 0.8rem;
  font-weight: 800;
  color: #334155;
  border-bottom: 1px solid #dbeafe;
  border-right: 1px solid #e2e8f0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.recruiter-detail-modal-table tbody td {
  border-color: #edf2f7;
  transition: background-color 0.18s ease;
}

.recruiter-detail-modal-table tbody tr:nth-child(even) td {
  background: rgba(248, 251, 255, 0.72);
}

.recruiter-detail-modal-table tbody tr:hover td {
  background: #eff6ff;
}

.recruiter-detail-modal-empty {
  padding: 42px 20px;
  border: 1px dashed #cbd5e1;
  border-radius: 18px;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);
  text-align: center;
  color: #64748b;
  font-weight: 600;
}

@media (max-width: 991px) {
  .recruiter-report-page {
    padding: 16px 10px 28px;
  }

  .recruiter-report-filter-bar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recruiter-report-filter-summary {
    grid-column: 1 / -1;
  }

  .recruiter-report-filter-actions {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }

  .recruiter-report-hero {
    min-height: auto;
    padding: 20px 18px 18px;
  }

  .recruiter-report-title {
    font-size: 28px;
  }

  .recruiter-report-hero-meta {
    gap: 10px;
  }

  .recruiter-report-hero-pill {
    min-width: calc(50% - 10px);
  }

  .recruiter-insight-strip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .recruiter-detail-modal-body {
    padding: 16px 16px 18px !important;
  }

  .recruiter-detail-modal-header-row {
    flex-direction: column;
    align-items: flex-start;
    padding-right: 56px;
  }

  .recruiter-detail-modal-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 640px) {
  .recruiter-report-page {
    padding: 12px 4px 24px;
  }

  .recruiter-report-hero {
    border-radius: 24px;
    padding: 18px 14px 16px;
  }

  .recruiter-report-title {
    font-size: 24px;
  }

  .recruiter-report-subtitle {
    font-size: 13px;
  }

  .recruiter-report-hero-pill,
  .recruiter-report-company-card {
    width: 100%;
    max-width: none;
  }

  .recruiter-report-filter-bar {
    grid-template-columns: 1fr;
    padding: 12px;
  }

  .recruiter-insight-strip,
  .recruiter-scope-grid {
    grid-template-columns: 1fr;
  }

  .recruiter-panel-header,
  .recruiter-breakdown-header,
  .recruiter-snapshot-list,
  .recruiter-metrics-list {
    padding-left: 14px;
    padding-right: 14px;
  }

  .recruiter-snapshot-card {
    grid-template-columns: 1fr;
  }

  .recruiter-snapshot-side {
    text-align: left;
  }

  .recruiter-rank-badge {
    position: static;
    width: fit-content;
    margin-bottom: 8px;
  }

  .recruiter-detail-modal .modal-content {
    border-radius: 18px;
  }

  .recruiter-detail-modal-header {
    padding: 18px 16px 12px !important;
  }

  .recruiter-detail-modal-heading {
    width: 100%;
  }

  .recruiter-detail-modal-title {
    font-size: 1rem;
  }

  .recruiter-detail-modal-meta {
    gap: 8px;
    font-size: 0.82rem;
  }

  .recruiter-detail-modal .btn-close {
    top: 14px;
    right: 14px;
  }
}
.recruiter-report-filter-summary-value {
  min-height: 22px;
  display: inline-flex;
  align-items: center;
}

.ModalStickyTabs {
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.activeBorder {
  border-bottom: 3px solid #2563eb !important;
}

.inActiveBorder {
  border: 1px solid #dbe7f3 !important;
}
.addCandidateBtn {
  display: flex;
  align-items: center;
  gap: 6px;

  border: none;
  background: transparent;

  color: #1976d2;
  font-size: 14px;
  font-weight: 600;

  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;

  transition: all 0.2s ease;
}

.addCandidateBtn:hover {
  background-color: rgba(25, 118, 210, 0.08);
}

.addCandidateHeaderBtn {
  display: flex;
  align-items: center;
  gap: 4px;

  border: none;
  background: transparent;
  color: inherit;
}
.manager-pipeline-panel .p-card-body,
.manager-pipeline-panel .p-card-content {
  overflow: hidden !important;
  padding: 12px !important;
  height: 100%;
  box-sizing: border-box;
}
.candidate-modal .modal-content {
  height: 85vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}
.candidate-modal .modal-body {
  overflow: hidden;
}
.candidate-modal .modal-dialog {
  display: flex;
  align-items: center;
  min-height: 100vh;
  margin: 0 auto;
}
.candidate-modal .modal-content {
  height: 85vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}
#ExpandBtn {
  position: absolute;
  right: 40px;
  top: 10px;
  z-index: 1050;
}

/* .CreateJobOrderFooter {
  position: absolute;
  top:80px;
  right: 0;
  z-index: 1050;
  background: red;
  width: 100px;
} */
.cs-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 12px;
}

.cs-tabs button {
  padding: 8px 14px;
  border: 1px solid #ddd;
  background: #f8fafc;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
}

.cs-tabs button.active {
  background: #103d63;
  color: #fff;
  border-color: #103d63;
  border-radius: 40px;
}
/* Full screen blur background */
#global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Center content */
.loader-content {
  text-align: center;
  color: #fff;
  font-family: Arial, sans-serif;
}

/* Spinner */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #ccc;
  border-top: 5px solid #00bcd4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/* .calendar-container {
  display: flex;
  height: 500px;
}

.calendar-left {
  width: 40%;
  padding: 20px;
  border-right: 1px solid #eee;
}

.calendar-right {
  width: 60%;
  padding: 20px;
  overflow-y: auto;
}

.slots {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.slot-btn {
  border: 1px solid #0d6efd;
  background: white;
  color: #0d6efd;
  padding: 10px;
  border-radius: 6px;
  text-align: center;
  font-weight: 500;
}

.slot-btn:hover {
  background: #e7f1ff;
}

.slot-btn.active {
  background: #0d6efd;
  color: white;
} */

.cs-root {
  min-height: 100vh;
  background: #f0f4f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 40px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI",
    sans-serif;
}

.cs-card {
  width: 100%;
  max-width: 640px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.cs-header {
  background: linear-gradient(135deg, #103d63 0%, #1a5a90 100%);
  padding: 24px 24px 20px;
}

.cs-kicker {
  display: inline-block;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 20px;
}

.cs-body {
  padding: 20px 20px 24px;
}

@media (min-width: 480px) {
  .cs-body {
    padding: 24px 28px 28px;
  }
  .cs-header {
    padding: 20px 28px 6px;
  }
}

.cs-section {
  margin-bottom: 16px;
}

.cs-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #3e4b5f;
  margin-bottom: 6px;
}

.cs-about-text {
  font-size: 14px;
  color: #374151;
  line-height: 1.65;
  margin: 0 0 6px;
}

.cs-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 14px;
  border-bottom: 2px solid #f1f5f9;
  padding-bottom: 0;
}

.cs-tabs button {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 0;
  transition: color 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.cs-tabs button.active {
  border-bottom-color: #103d63;
}

.cs-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 16px;
}

@media (min-width: 480px) {
  .cs-info-grid {
    /* grid-template-columns: repeat(4, 1fr); gap: 12px; */
  }
}

.cs-info-box {
  background: #f8fafc;
  border: 1px solid #e9eef4;
  border-radius: 10px;
  padding: 10px 12px;
}

.cs-info-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
  margin-bottom: 3px;
}

.cs-info-value {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
}

.cs-skills-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.cs-skill-chip {
  background: #e8f4fd;
  color: #0e5fa3;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

.cs-divider {
  border: none;
  border-top: 1px solid #f1f5f9;
  margin: 16px 0;
}

.cs-cta-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
  text-align: center;
}

.cs-cta-sub {
  font-size: 13px;
  color: #64748b;
  text-align: center;
  margin-bottom: 16px;
}

.cs-btn-interested,
.cs-btn-decline {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1.5px solid;
  cursor: pointer;
  transition: transform 0.1s, box-shadow 0.1s;
  margin-bottom: 10px;
  text-align: left;
  background: #fff;
}

.cs-btn-interested {
  border-color: #22c55e;
}
.cs-btn-interested:hover {
  background: #f0fdf4;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);
}

.cs-btn-decline {
  border-color: #f87171;
}
.cs-btn-decline:hover {
  background: #fff5f5;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(248, 113, 113, 0.15);
}

.cs-btn-icon {
  width: 38px;
  height: 38px;
  min-width: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}
.cs-btn-icon.green {
  background: #22c55e;
}
.cs-btn-icon.red {
  background: #f87171;
}

.cs-btn-label {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}
.cs-btn-sublabel {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
}

.cs-btn-arrow {
  margin-left: auto;
  font-size: 22px;
  color: #cbd5e1;
}

.cs-declined-box,
.cs-confirmed-box {
  background: #f8fafc;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  margin-bottom: 12px;
}

.cs-state-title {
  font-size: 16px;
  font-weight: 700;
  color: #103d63;
  margin-bottom: 6px;
}

.cs-state-sub {
  font-size: 13px;
  color: #64748b;
  line-height: 1.5;
}

.cs-privacy {
  font-size: 11px;
  color: #cbd5e1;
  text-align: center;
  margin-top: 12px;
}

.cs-footer {
  margin-top: 20px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

/* ── Schedule Modal ── */
.sched-modal .modal-dialog {
  margin: 0 auto;
  max-width: 860px;
  width: 100%;
}

@media (max-width: 767px) {
  .sched-modal .modal-dialog {
    margin: 0;
    max-width: 100%;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .sched-modal .modal-content {
    border-radius: 20px 20px 0 0 !important;
    max-height: 92vh;
    overflow-y: auto;
  }
}

.sched-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.sched-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: #e8f4fd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #0069ff;
}

.sched-company {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 2px;
}
.sched-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

@media (min-width: 480px) {
  .sched-title {
    max-width: 340px;
  }
}

.sched-close {
  margin-left: auto;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 22px;
  color: #9ca3af;
  line-height: 1;
  padding: 4px 6px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sched-subheader {
  padding: 14px 20px 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.sched-body {
  display: flex;
  flex-direction: column;
  padding: 14px 20px 20px;
  gap: 20px;
}

@media (min-width: 640px) {
  .sched-body {
    flex-direction: row;
    gap: 24px;
  }
}

.sched-calendar {
  width: 100%;
}

@media (min-width: 640px) {
  .sched-calendar {
    width: 280px;
    min-width: 280px;
  }
}

.sched-divider-v {
  display: none;
}
@media (min-width: 640px) {
  .sched-divider-v {
    display: block;
    width: 1px;
    background: #f1f5f9;
    flex-shrink: 0;
  }
}

.sched-divider-h {
  display: block;
  height: 1px;
  background: #f1f5f9;
  width: 100%;
}
@media (min-width: 640px) {
  .sched-divider-h {
    display: none;
  }
}

.sched-slots {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.sched-slots-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 10px;
}

.sched-slots-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  overflow-y: auto;
  max-height: 260px;
  padding-right: 2px;
}

@media (min-width: 640px) {
  .sched-slots-grid {
    grid-template-columns: 1fr;
    max-height: 300px;
  }
}

.sched-slot-btn {
  padding: 11px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: border-color 0.1s, background 0.1s;
  white-space: nowrap;
}

.sched-footer {
  padding: 14px 20px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sched-footer-btns {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.sched-footer-btns button {
  flex: 1 1;
  max-width: 200px;
  padding: 11px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-height: 44px;
}

.sched-btn-cancel {
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
}

.sched-btn-confirm {
  border: none;
  background: #0069ff;
  color: #fff;
}
.sched-btn-confirm:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

.sched-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #b91c1c;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cal nav */
.cal-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.cal-nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  font-size: 18px;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  min-width: 44px;
}

.cal-month-label {
  font-weight: 700;
  font-size: 14px;
  color: #111827;
}

.cal-days-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 6px;
}

.cal-day-name {
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.04em;
  padding: 3px 0;
}

.cal-days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px 0;
}

.cal-day-btn {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 13px;
  cursor: pointer;
  min-height: 36px;
  min-width: 36px;
}
.offer-letter-modal .modal-dialog {
  max-width: 1200px; /* Increase width */
  margin-top: 30px; /* Distance from top */
}

.offer-letter-modal .modal-content {
  min-height: 85vh; /* Taller modal */
}

.offer-letter-modal .modal-body {
  max-height: calc(85vh - 140px);
  overflow-y: auto;
}
.sun-editor-editable[contenteditable="true"] .se-component {
  outline: "" !important;
}
#OfferLetterModal .btn-close {
  color: white !important;
}
.offer-letter-modal .modal-header .btn-close {
  filter: invert(1) brightness(2);
}
.sun-editor-editable p {
  border: none !important;
}
.table tbody tr:hover {
  background: #f8fafc;
}

.nav-tabs .nav-link.active {
  font-weight: 600;
  color: #12395c !important;
}

.card {
  border-radius: 12px;
}

.modal-content {
  border-radius: 12px;
}
/* Remove SunEditor's default dashed border on inserted images */
.sun-editor-editable img,
.sun-editor img,
#OfferLetterModal .sun-editor-editable img,
#OfferLetterModal .sun-editor img {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}
.jor-page {
  --bg: #f6f7f9;
  --surface: #ffffff;
  --line: #e4e7ec;
  --line-soft: #eef0f3;
  --text: #13202e;
  --muted: #5f6b7a;
  --faint: #98a2b1;
  --navy: #000053;
  --orange: #ee751d;
  --orange-hover: #d4661a;
  --orange-soft: #fdeedd;
  --accent: #1f4fd8;
  --accent-soft: #eef3fe;
  --green: #0f9d58;
  --green-soft: #e9f7ef;
  --amber: #b97509;
  --amber-soft: #fdf4e3;
  --red: #d23b3b;
  --red-soft: #fdeeee;
  --radius: 10px;
  --font-display: "Manrope", sans-serif;
  --font-body: "Inter", sans-serif;
  font-family: var(--font-body);
  background: var(--bg);
  color: var(--text);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  position: relative;
}
.jor-page * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.jor-page button {
  font: inherit;
  cursor: pointer;
}

.jor-page .content {
  padding: 22px 24px 32px;
  width: 100%;
  margin: 0 auto;
}
.jor-page .page-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.jor-page .page-head h1 {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.01em;
  color: var(--navy);
}
.jor-page .page-head .sub {
  color: var(--muted);
  font-size: 13.5px;
  margin-top: 3px;
}

.jor-page .selbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 14px 16px;
  margin-bottom: 18px;
}
.jor-page .selbar .lbl {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--faint);
}
.jor-page .selbar select {
  height: 40px;
  min-width: 280px;
  padding: 0 12px;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--navy);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .selbar select:focus {
  outline: none;
  border-color: var(--orange);
  box-shadow: 0 0 0 3px var(--orange-soft);
}
.jor-page .selbar .meta {
  font-size: 13px;
  color: var(--muted);
}
.jor-page .selbar .meta b {
  color: var(--navy);
}

.jor-page .stat-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 18px;
}
.jor-page .stat-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  overflow: hidden;
}
.jor-page .stat-card .sc-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line-soft);
}
.jor-page .stat-card .sc-head .ico {
  width: 40px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.jor-page .stat-card .sc-head .ico.blue {
  background: var(--accent-soft);
  color: var(--accent);
}
.jor-page .stat-card .sc-head .ico.orange {
  background: var(--orange-soft);
  color: var(--orange);
}
.jor-page .stat-card .sc-head .ico.green-ico {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .stat-card .sc-head h3 {
  font-family: var(--font-display);
  font-size: 14.5px;
  font-weight: 700;
  color: var(--navy);
}
.jor-page .stat-card .sc-body {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.jor-page .stat-card .sc-item {
  padding: 14px 16px;
  border-right: 1px solid var(--line-soft);
}
.jor-page .stat-card .sc-item:last-child {
  border-right: none;
}
.jor-page .stat-card .sc-item .v {
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 22px;
  letter-spacing: -0.02em;
}
.jor-page .stat-card .sc-item .v.green {
  color: var(--green);
}
.jor-page .stat-card .sc-item .v.amber {
  color: var(--amber);
}
.jor-page .stat-card .sc-item .v.gray {
  color: var(--faint);
}
.jor-page .stat-card .sc-item .l {
  font-size: 12px;
  color: var(--muted);
  margin-top: 2px;
}

.jor-page .panel {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius);
}
.jor-page .toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px 16px;
  border-bottom: 1px solid var(--line-soft);
}
.jor-page .toolbar .lbl {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--faint);
}
.jor-page .toolbar select {
  height: 36px;
  padding: 0 10px;
  font: inherit;
  font-size: 13.5px;
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .toolbar input[type="date"] {
  height: 36px;
  padding: 0 10px;
  font: inherit;
  font-size: 13px;
  color: var(--text);
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
}
.jor-page .toolbar select:focus,
.jor-page .toolbar input[type="date"]:focus {
  outline: none;
  border-color: var(--orange);
}
.jor-page .toolbar .reset {
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  color: var(--muted);
  font-weight: 500;
  font-size: 13px;
}
.jor-page .toolbar .reset:hover {
  background: var(--bg);
  color: var(--text);
}
.jor-page .toolbar .right {
  margin-left: auto;
  display: flex;
  gap: 10px;
  align-items: center;
}
.jor-page .t-search {
  position: relative;
}
.jor-page .t-search svg {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--faint);
}
.jor-page .t-search input {
  height: 36px;
  width: 220px;
  padding: 0 10px 0 32px;
  font: inherit;
  font-size: 13.5px;
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 8px;
  color: var(--text);
}
.jor-page .t-search input:focus {
  outline: none;
  border-color: var(--orange);
  box-shadow: 0 0 0 3px var(--orange-soft);
}
.jor-page .btn-export {
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  color: var(--muted);
  font-weight: 500;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.jor-page .btn-export:hover {
  border-color: var(--accent);
  color: var(--accent);
  background: var(--accent-soft);
}

.jor-page table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}
.jor-page thead th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--faint);
  padding: 11px 14px;
  border-bottom: 1px solid var(--line-soft);
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  background: #fcfcfd;
  vertical-align: bottom;
}
.jor-page thead th.sortable {
  cursor: pointer;
}
.jor-page thead th.sortable:hover {
  color: var(--muted);
}
.jor-page thead th .arrow {
  font-size: 10px;
  margin-left: 3px;
}
.jor-page thead tr.grouprow th {
  font-size: 10px;
  text-align: left;
  color: var(--navy);
  border-bottom: none;
  padding-bottom: 2px;
  letter-spacing: 0.05em;
}
.jor-page thead tr.grouprow th.gsep {
  border-left: 1px solid var(--line-soft);
}
.jor-page tbody td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
  white-space: nowrap;
}
.jor-page tbody tr:last-child td {
  border-bottom: none;
}
.jor-page tbody tr:hover td {
  background: #fafbfc;
}
.jor-page td.gsep,
.jor-page th.gsep {
  border-left: 1px solid var(--line-soft);
}

.jor-page .person {
  display: flex;
  align-items: center;
  gap: 10px;
}
.jor-page .person .avatar {
  width: 30px;
  height: 30px;
  font-size: 11.5px;
}
.jor-page .person .p-name {
  font-weight: 600;
}
.jor-page .person .p-sub {
  font-size: 12px;
  color: var(--faint);
}
.jor-page .jobtag {
  font-size: 12px;
  color: var(--faint);
}
.jor-page .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex: none;
}

.jor-page .badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 999px;
  white-space: nowrap;
}
.jor-page .badge::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.jor-page .badge.green {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .badge.amber {
  background: var(--amber-soft);
  color: var(--amber);
}
.jor-page .badge.blue {
  background: var(--accent-soft);
  color: var(--accent);
}
.jor-page .badge.gray {
  background: var(--line-soft);
  color: var(--muted);
}
.jor-page .badge.red {
  background: var(--red-soft);
  color: var(--red);
}
.jor-page .badge.navy {
  background: #e6e6f2;
  color: var(--navy);
}

.jor-page .tl {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 210px;
}
.jor-page .tl .step {
  display: grid;
  grid-template-columns: 8px 78px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
}
.jor-page .tl .step .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: none;
  background: var(--line);
  position: relative;
}
.jor-page .tl .step.done .dot {
  background: var(--green);
}
.jor-page .tl .step.sched .dot {
  background: var(--amber);
}
.jor-page .tl .step.sent .dot {
  background: var(--accent);
}
.jor-page .tl .step .lab {
  color: var(--muted);
  white-space: nowrap;
}
.jor-page .tl .step .time {
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  color: var(--text);
  white-space: nowrap;
}
.jor-page .tl .step.pending .lab,
.jor-page .tl .step.pending .time {
  color: var(--faint);
  font-weight: 400;
}
.jor-page .tl .step .time.muted {
  color: var(--faint);
  font-weight: 400;
}

.jor-page .res-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px dashed var(--line);
}
.jor-page .score {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 13px;
  color: var(--navy);
  font-variant-numeric: tabular-nums;
}
.jor-page .score .den {
  color: var(--faint);
  font-weight: 600;
  font-size: 12px;
}
.jor-page .res-chip {
  font-size: 11.5px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}
.jor-page .res-chip.pass {
  background: var(--green-soft);
  color: var(--green);
}
.jor-page .res-chip.fail {
  background: var(--red-soft);
  color: var(--red);
}
.jor-page .res-chip.pend {
  background: var(--amber-soft);
  color: var(--amber);
}
.jor-page .scorebar {
  flex: 1 1;
  height: 5px;
  border-radius: 3px;
  background: var(--line-soft);
  overflow: hidden;
  min-width: 40px;
}
.jor-page .scorebar i {
  display: block;
  height: 100%;
  border-radius: 3px;
}
.jor-page .scorebar i.pass {
  background: var(--green);
}
.jor-page .scorebar i.fail {
  background: var(--red);
}

.jor-page .locked {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: var(--faint);
  font-size: 12.5px;
  line-height: 1.45;
  padding: 2px 0;
}
.jor-page .locked svg {
  flex: none;
  margin-top: 1px;
  color: var(--faint);
}
.jor-page .locked .lk-title {
  font-weight: 600;
  color: var(--muted);
}
.jor-page .badge.lock {
  background: var(--line-soft);
  color: var(--faint);
}
.jor-page .badge.lock::before {
  display: none;
}

.jor-page .table-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 1px solid var(--line-soft);
  font-size: 13px;
  color: var(--muted);
  flex-wrap: wrap;
  gap: 10px;
}
.jor-page .rows-per {
  display: flex;
  align-items: center;
  gap: 8px;
}
.jor-page .rows-per select {
  height: 30px;
  border: 1px solid var(--line);
  border-radius: 8px;
  background: var(--surface);
  padding: 0 8px;
  font: inherit;
  font-size: 13px;
}
.jor-page .pager {
  display: flex;
  gap: 4px;
}
.jor-page .pager button {
  min-width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--muted);
  font-size: 13px;
}
.jor-page .pager button:hover:not(:disabled) {
  background: var(--bg);
}
.jor-page .pager button.cur {
  background: var(--navy);
  color: #fff;
  border-color: var(--navy);
  font-weight: 600;
}
.jor-page .pager button:disabled {
  opacity: 0.4;
  cursor: default;
}
.jor-page .empty {
  padding: 36px 18px;
  text-align: center;
  color: var(--faint);
  font-size: 13.5px;
}

.jor-page .toast {
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%) translateY(8px);
  background: var(--navy);
  color: #fff;
  font-size: 13.5px;
  font-weight: 500;
  padding: 10px 18px;
  border-radius: 999px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s, transform 0.2s;
  z-index: 60;
}
.jor-page .toast.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@media (max-width: 1100px) {
  .jor-page .stat-groups {
    grid-template-columns: 1fr;
  }
}
@media (prefers-reduced-motion: reduce) {
  .jor-page * {
    transition: none !important;
  }
}

.test-result-modal .modal-content {
  border: 0;
  border-radius: 16px;
  overflow: hidden;
  background: #f6f8fb;
}

.talent-scan-result-dialog.p-dialog {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  background: #f6f8fb;
}

.talent-scan-result-dialog .p-dialog-header {
  padding: 14px 18px;
  border: 0;
  color: #fff;
  background: #1976ad;
}

.talent-scan-result-dialog .p-dialog-title {
  min-width: 0;
}

.talent-scan-result-dialog .p-dialog-header-icons {
  flex: 0 0 auto;
}

.talent-scan-result-dialog .p-dialog-header-close {
  color: #fff;
}

.talent-scan-result-dialog .p-dialog-content {
  max-height: 75vh;
  overflow-y: auto;
  padding: 16px;
  background: #f6f8fb;
}

.test-result-modal-header {
  position: sticky;
  top: 0;
  z-index: 10;
  align-items: center;
  padding: 14px 18px;
  border: 0;
  color: #fff;
  background: #1976ad;
}

.test-result-modal-header .modal-title {
  min-width: 0;
}

.test-result-modal-header .btn-close {
  flex: 0 0 auto;
  margin: 0;
  opacity: 0.85;
  filter: brightness(0) invert(1);
}

.test-result-modal-header .btn-close:hover {
  opacity: 1;
}

.test-result-modal-heading {
  min-width: 0;
}

.test-result-modal-title {
  overflow: hidden;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-result-modal-candidate-contact {
  overflow: hidden;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-result-modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding: 16px;
  background: #f6f8fb;
}

.test-result-modal-footer {
  justify-content: center;
  display: flex;
  gap: 10px;
  padding: 12px 20px;
  border-top: 1px solid #d8e1eb;
  background: #fff;
}

.ts-result-list,
.ts-result-content,
.ts-result-section-list {
  display: flex;
  flex-direction: column;
}

.ts-result-list {
  gap: 16px;
}

.ts-result-shell {
  border: 1px solid #d8e1eb;
  border-radius: 16px;
  overflow: hidden;
  background: #f6f8fb;
}

.ts-result-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: #0c447c;
}

.ts-result-header-main {
  min-width: 0;
}

.ts-result-title {
  color: #e6f1fb;
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.ts-result-subtitle {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 5px;
  color: #b7daf9;
  font-size: 12px;
}

.ts-result-header-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.ts-result-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}

.ts-result-badge.success,
.ts-result-score-pill.good {
  color: #27500a;
  background: #eaf3de;
}

.ts-result-badge.danger,
.ts-result-score-pill.low {
  color: #791f1f;
  background: #fcebeb;
}

.ts-result-badge.warning {
  color: #633806;
  background: #faeeda;
}

.ts-result-badge.info,
.ts-result-score-pill.mid {
  color: #0c447c;
  background: #e6f1fb;
}

.ts-result-badge.neutral {
  color: #444441;
  background: #f1efe8;
}

.ts-result-content {
  gap: 14px;
  padding: 16px;
  background: #f6f8fb;
}

.ts-result-section-label {
  margin-bottom: 8px;
  /* color: #7b8794; */
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.ts-result-card {
  padding: 14px 16px;
  border: 1px solid #d8e1eb;
  border-radius: 12px;
  background: #fff;
}

.ts-result-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
}

.ts-result-card.ts-result-grid-2 {
  overflow: hidden;
  padding: 0;
  border-color: #c7d2df;
}

.ts-result-info-table {
  overflow: hidden;
  padding: 0;
  border-color: #c7d2df;
}

.ts-result-info-table-heading {
  padding: 8px 12px;
  border-bottom: 1px solid #c7d2df;
  color: #0c447c;
  background: #edf5fc;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.ts-result-info-table .ts-result-grid-2 + .ts-result-info-table-heading {
  border-top: 1px solid #c7d2df;
}

.ts-result-kv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 30px;
  padding: 8px 12px;
  border-right: 1px solid #d8e1eb;
  border-bottom: 1px solid #d8e1eb;
}

.ts-result-kv-row:nth-child(even) {
  border-right: 0;
}

.ts-result-kv-row:nth-last-child(-n + 2) {
  border-bottom: 0;
}

.ts-result-kv-key {
  color: #667085;
  font-size: 12px;
}

.ts-result-kv-val {
  max-width: 58%;
  color: #172033;
  font-size: 12px;
  font-weight: 600;
  text-align: right;
  overflow-wrap: anywhere;
}

.ts-result-kv-val.timeline {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 9px;
  border: 1px solid #b9d7ef;
  border-radius: 999px;
  color: #0c447c;
  background: #eaf4fc;
  box-shadow: 0 2px 5px rgba(24, 95, 165, 0.12);
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.ts-result-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.ts-result-metrics.ts-result-metrics-four {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ts-result-metric {
  position: relative;
  overflow: hidden;
  min-height: 72px;
  padding: 14px 16px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #fff;
  text-align: center;
  box-shadow: 0 2px 7px rgba(23, 32, 51, 0.06);
}

.ts-result-metric::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 4px;
  background: currentColor;
  content: "";
  opacity: 0.75;
}

.ts-result-metric.info,
.ts-result-metric.mid {
  color: #0c447c;
  border-color: #b9d7ef;
  background: #f0f7fd;
}

.ts-result-metric.good {
  color: #27500a;
  border-color: #b8d698;
  background: #f2f8e9;
}

.ts-result-metric.low {
  color: #991b1b;
  border-color: #f0b8b8;
  background: #fff3f3;
}

.ts-result-metric.advanced {
  color: #26215c;
  background: #eeedfe;
}

.ts-result-metric.neutral {
  color: #172033;
  background: #fff;
  border: 1px solid #e5ebf1;
}

.ts-result-metric-val {
  color: currentColor;
  font-size: 19px;
  font-weight: 800;
  line-height: 1.2;
}

.ts-result-metric-label {
  margin-top: 5px;
  color: #475467;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ts-result-dict-row {
  display: grid;
  grid-template-columns: minmax(120px, 160px) 1fr minmax(82px, auto) minmax(
      66px,
      auto
    );
  align-items: center;
  gap: 10px;
  min-height: 34px;
  padding: 7px 0;
  border-bottom: 1px solid #e5ebf1;
}

.ts-result-dict-row:last-child {
  border-bottom: 0;
}

.ts-result-dict-name {
  color: #172033;
  font-size: 12px;
  font-weight: 600;
}

.ts-result-bar,
.ts-result-level-bar {
  overflow: hidden;
  border: 1px solid #d8e1eb;
  border-radius: 999px;
  background: #eef2f6;
}

.ts-result-bar {
  height: 6px;
}

.ts-result-bar-fill {
  height: 100%;
  border-radius: inherit;
}

.ts-result-bar-fill.good {
  background: #639922;
}

.ts-result-bar-fill.mid {
  background: #185fa5;
}

.ts-result-bar-fill.low {
  background: #e24b4a;
}

.ts-result-score-pill {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.ts-result-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
  /* color: #7b8794; */
  font-size: 11px;
  font-weight: 600;
}

.ts-result-legend-item,
.ts-result-level-head {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.ts-result-legend-item {
  color: #667085;
  font-weight: 500;
}

.ts-result-legend-item span,
.ts-result-level-head span {
  width: 8px;
  height: 8px;
  border-radius: 2px;
  flex: 0 0 auto;
}

.ts-result-legend-item.beginner span,
.ts-result-level.beginner .ts-result-level-head span,
.ts-result-level.beginner .ts-result-level-bar div {
  background: #639922;
}

.ts-result-legend-item.intermediate span,
.ts-result-level.intermediate .ts-result-level-head span,
.ts-result-level.intermediate .ts-result-level-bar div {
  background: #185fa5;
}

.ts-result-legend-item.advanced span,
.ts-result-level.advanced .ts-result-level-head span,
.ts-result-level.advanced .ts-result-level-bar div {
  background: #534ab7;
}

.ts-result-section-list {
  gap: 8px;
}

.ts-result-section-card {
  display: grid;
  grid-template-columns:
    minmax(260px, 300px)
    minmax(180px, 240px)
    minmax(360px, 1fr);
  align-items: stretch;
  overflow: hidden;
  border: 1px solid #cbd7e4;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(23, 32, 51, 0.05);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ts-result-section-card:hover {
  border-color: #aebdcd;
  box-shadow: 0 4px 12px rgba(23, 32, 51, 0.08);
}

.ts-result-section-card.cheated {
  border: 2px solid #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.ts-result-section-card.cheated .ts-result-section-name-col,
.ts-result-section-card.cheated .ts-result-section-score-col,
.ts-result-section-card.cheated .ts-result-level {
  background: #fff7f7;
}

.ts-result-section-top {
  display: contents;
}

.ts-result-section-name-col {
  padding: 12px 14px;
  border-right: 1px solid #d8e1eb;
  background: #fbfcfe;
}

.ts-result-section-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
  color: #101828;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.25;
}

.ts-result-cheated-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 3px 9px;
  border-radius: 999px;
  color: #fff;
  background: #dc2626;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
}

.ts-result-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.ts-result-chip-row > span:not(.ts-result-badge) {
  padding: 3px 8px;
  border: 1px solid #d6e0eb;
  border-radius: 999px;
  color: #344054;
  background: #f8fafc;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.25;
}

.ts-result-chip-row.status {
  margin-top: 7px;
}


.ts-result-level-head {
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.ts-result-section-score-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-right: 1px solid #d8e1eb;
  height: 100%;
  background: #f8fbff;
}

.ts-result-big-score {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: flex-start;
}

.ts-result-big-score span {
  color: #475467;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1.2;
  margin: 0;
}

.ts-result-big-score strong {
  color: #12639a;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  margin: 1px 0;
}

.ts-result-big-score small {
  color: #344054;
  font-size: 11px;
  line-height: 1.3;
  margin: 0;
}
.ts-result-section-bar-wrap {
  flex: 1 1 auto;
  min-width: 110px;
}

.ts-result-section-bar-label {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
  /* color: #7b8794; */
  font-size: 11px;
}

.ts-result-section-bar-label .good {
  color: #27500a;
}

.ts-result-section-bar-label .mid {
  color: #0c447c;
}

.ts-result-section-bar-label .low {
  color: #791f1f;
}

.ts-result-levels {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: stretch;
}

.ts-result-level {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 12px 14px;
  border-right: 1px solid #d8e1eb;
  border-top: 3px solid transparent;
}

.ts-result-level:last-child {
  border-right: 0;
}

.ts-result-level-head {
  margin-bottom: 7px;
  color: #344054;
  font-size: 9px;
}

.ts-result-level-score-label {
  margin-bottom: 3px;
  color: #667085;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  text-transform: uppercase;
}

.ts-result-level-score {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 4px;
}

.ts-result-level-score strong {
  font-size: 17px;
  line-height: 1;
}

.ts-result-level.beginner {
  border-top-color: #639922;
  background: #fbfdf8;
}

.ts-result-level.intermediate {
  border-top-color: #185fa5;
  background: #f8fbff;
}

.ts-result-level.advanced {
  border-top-color: #534ab7;
  background: #faf9ff;
}

.ts-result-level > small {
  color: #475467;
  font-size: 11px;
  font-weight: 600;
}

.ts-result-level.beginner .ts-result-level-score strong {
  color: #639922;
}

.ts-result-level.intermediate .ts-result-level-score strong {
  color: #185fa5;
}

.ts-result-level.advanced .ts-result-level-score strong {
  color: #534ab7;
}

.ts-result-level-score span {
  /* color: #7b8794; */
  font-size: 11px;
}

.ts-result-level-bar {
  height: 4px;
}

.ts-result-level-bar div {
  height: 100%;
}

.ts-result-level-empty {
  color: #b91c1c;
  font-size: 13px;
}

.ts-result-section-extra {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid #d8e1eb;
}

.ts-result-section-extra div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  border-right: 1px solid #d8e1eb;
}

.ts-result-section-extra div:last-child {
  border-right: 0;
}

.ts-result-section-extra span {
  color: #7b8794;
  font-size: 10px;
}

.ts-result-section-extra strong {
  color: #172033;
  font-size: 11px;
}

.ts-result-cheated-note {
  grid-column: 1 / -1;
  padding: 9px 14px;
  border-top: 1px solid #dc2626;
  color: #991b1b;
  background: #fee2e2;
  font-size: 12px;
  font-weight: 700;
}

.ts-result-actions {
  display: flex;
  justify-content: center;
}

.ts-result-detail-btn,
.ts-result-close-btn {
  min-height: 34px;
  padding: 7px 20px;
  border: 1px solid #185fa5 !important;
  border-radius: 8px !important;
  color: #0c447c !important;
  background: #e6f1fb !important;
  font-size: 13px;
  font-weight: 700;
}

.ts-result-close-btn {
  border-color: #cbd5e1 !important;
  color: #172033 !important;
  background: #f8fafc !important;
}

.ts-result-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 260px;
  padding: 48px 24px;
  color: #667085;
  text-align: center;
}

.ts-result-empty-icon {
  width: 56px;
  height: 56px;
  border: 2px solid #d8e1eb;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0c447c;
  background: #e6f1fb;
  font-size: 24px;
  font-weight: 800;
  font-family: Georgia, serif;
}

.ts-result-empty-title {
  color: #172033;
  font-size: 18px;
  font-weight: 700;
}

.ts-result-empty-copy {
  max-width: 300px;
  font-size: 14px;
}

@media (max-width: 991.98px) {
.ts-result-grid-2,
.ts-result-levels,
.ts-result-section-extra {
  grid-template-columns: repeat(2, 1fr);
}

.ts-result-metrics {
  grid-template-columns: repeat(3, 1fr);
}

  .ts-result-kv-row:nth-last-child(-n + 2) {
    border-bottom: 1px solid #e5ebf1;
  }

  .ts-result-kv-row:last-child {
    border-bottom: 0;
  }

  .ts-result-section-top {
    display: contents;
  }

  .ts-result-section-card {
    grid-template-columns: 1fr;
  }

  .ts-result-section-name-col,
  .ts-result-section-score-col,
  .ts-result-level,
  .ts-result-section-extra div {
    border-right: 0;
  }

  .ts-result-section-name-col,
  .ts-result-section-score-col,
  .ts-result-level {
    border-bottom: 1px solid #d8e1eb;
  }

  .ts-result-dict-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

@media (max-width: 575.98px) {
  .test-result-modal-body,
  .ts-result-content {
    padding: 12px;
  }

  .ts-result-header,
  .ts-result-section-score-col {
    flex-direction: column;
  }

  .ts-result-header-badges {
    justify-content: flex-start;
  }

  .ts-result-kv-row {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }

  .ts-result-kv-val {
    max-width: 100%;
    text-align: left;
  }
}
.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box .search-icon {
  position: absolute;
  left: 12px;
  color: #667085;
  font-size: 14px;
}

.search-box input[type="search"] {
  width: 300px;
  padding: 10px 14px 10px 36px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  background: #fff;
  transition: all 0.3s ease;
}

.search-box input[type="search"]:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
  outline: none;
}
.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.right input[type="search"] {
  width: 280px;
  padding: 10px 14px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  background: #fff;
}

.right input[type="search"]:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

.right input[type="search"]::placeholder {
  color: #98a2b3;
}
.count-bubble {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--navy, #000053);
  background: #eef1f6;
  border: 1px solid var(--line, #e4e7ec);
  border-radius: 999px;
  padding: 4px 12px;
  white-space: nowrap;
}
.count-bubble b {
  color: var(--orange, #ee751d);
  font-weight: 700;
}
.cutoff-bubble {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--orange, #ee751d);
  background: #fff4e6;
  border: 1px solid #ffd9b3;
  border-radius: 999px;
  padding: 2px 10px;
  margin-left: 6px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.cutoff-bubble b {
  color: var(--orange, #ee751d);
}
  .job-title-filter-dropdown.p-dropdown {
    background: #fff !important;
    border: 1px solid #ced4da !important;
    box-shadow: none !important;
    min-height: 31px;
  }
  .job-title-filter-dropdown .p-dropdown-label {
    background: transparent !important;
    color: #212529 !important;
    font-weight: 400 !important;
    padding: 4px 8px !important;
    text-shadow: none !important;
  }
  .job-title-filter-dropdown .p-dropdown-label.p-placeholder {
    color: #6c757d !important;
  }
  .job-title-filter-dropdown .p-dropdown-clear-icon {
    color: #6c757d !important;
    right: 2rem;
  }
  .job-title-filter-dropdown .p-dropdown-trigger {
    color: #6c757d !important;
  }
  .job-title-filter-dropdown:not(.p-disabled):hover {
    border-color: #adb5bd !important;
  }
  .job-title-filter-dropdown:not(.p-disabled).p-focus {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25) !important;
  }

  #TelephonicTest_Table .rdt_TableHead {
    z-index: 1;
  }
.swal-on-top {
  z-index: 99999 !important;
}
#VitelMeetLink{

}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;AAEH;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,8CAA8C;EAC9C,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,oCAAoC;EACpC,0BAA0B;;EAE1B,6BAA6B;EAC7B,+BAA+B;EAC/B,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;EAC1B,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,kEAAkE;EAClE,6CAA6C;EAC7C,gEAAgE;EAChE,+DAA+D;EAC/D;;;;GAIC;EACD;;;;GAIC;EACD,6DAA6D;EAC7D,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uGAAuG;AACzG;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;EAC/C,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,6DAA6D;EAC7D,+BAA+B;EAC/B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,oDAAoD;AACtD;AACA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,4EAA4E;AAC9E;AACA;;EAEE,eAAe;AACjB;AACA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;;;EAGE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;AACA;;;;;GAKG;;AAEH;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C;kCACgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,kFAAkF;AAClF,kFAAkF;AAClF;;;;;;;;;;;EAWE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;EAcE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;GAEG;AACH,wBAAwB;;AAExB;;;;;;GAMG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;;;GAIG;AACH;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;AACA,8BAA8B;AAC9B;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;;EAEE,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;;;;;EAKE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;;;EAGE,2BAA2B;EAC3B,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,8BAA8B;AAChC;;AAEA;;;;EAIE,sBAAsB;AACxB;AACA;;GAEG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0KE,2BAA2B;EAC3B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;EAME,+BAA+B;AACjC;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;;EAKE,+BAA+B;AACjC;;AAEA;;;;;;;;;;;EAWE,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;;EAEE,wCAAwC;EACxC,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;EAeE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;EAaE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;;;;;;;;EASE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;AACpB;;;;AAIA;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;;;;EAIE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;;;;;;;;;;EAUE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;EAWE,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;;;;;;;;;;EAUE,8BAA8B;AAChC;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;;;;;;;;;;;;;;;;;EAiBE,+BAA+B;AACjC;AACA;;;;;;;;;;;EAWE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,+BAA+B;AACjC;;AAEA;;;GAGG;;AAEH;;;;;;;;;;EAUE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgZE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;;2DAE2D;AAC3D,4DAA4D;AAC5D;;;GAGG;AACH;;;;;;;;;EASE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;;AAEF;;;;;;;;;EASE,uBAAuB;AACzB;AACA;;;;;;;;;;;EAWE,mCAAmC;EACnC,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;;;;;;;;;;;EAWE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;AACA;;;;EAIE,6BAA6B;AAC/B;AACA,UAAU;AACV;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;AACA;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;GAGG;AACH;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;;EAME,6BAA6B;AAC/B;AACA;;;;EAIE;AACF;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,aAAa;AACf;AACA,2BAA2B;AAC3B;4CAC4C;AAC5C,OAAO;AACP;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;;;;;EAKE,YAAY;AACd;AACA,8DAA8D;AAC9D;;;;;;;;EAQE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;EAME,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;;;;;EAME,kCAAkC;AACpC;;AAEA;;;GAGG;AACH;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiEE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuGE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,uDAAuD;;AAEvD,gBAAgB;AAChB;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,gEAAgE;EAChE,sBAAsB;EACtB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,oDAAoD;EACpD,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sCAAsC;;AAEtC,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;;;;EAKE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;;;EAKE,gEAAgE;EAChE,oCAAoC;EACpC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;;;;;EAKE,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gEAAgE;EAChE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,MAAM;EACN,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;EACd;AACF;AACA,iDAAiD;;AAEjD;EACE,6BAA6B;EAC7B;oBACkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,6DAA6D;AAC/D;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;AAC/D;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,6DAA6D;AAC/D;AACA;;EAEE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;AAChD;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;;;IAGE,aAAa;EACf;AACF;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;IACrB,kCAAkC;AACtC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;IACd,uCAAuC;EACzC,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,0EAA0E;EAC1E,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,+CAA+C;AACjD;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,4BAA4B;EAC5B,6DAA6D;EAC7D,WAAW;AACb;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE,0BAA0B,EAAE,oBAAoB;EAChD,gBAAgB,EAAE,yBAAyB;EAC3C,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,2TAA2T;EAC3T,4BAA4B;EAC5B,sCAAsC,EAAE,kBAAkB;EAC1D,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA,qBAAqB;AACrB;EACE,uBAAuB;EACvB;;;;;qDAKmD;EACnD,+BAA+B;AACjC;;AAEA;EACE;;;;;kEAKgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;EAEE,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB;;;;;;;;;;qDAUmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;;UAGQ;EACR,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb;;;;GAIC;AACH;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB;;;;GAIC;EACD,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB;;;;;qDAKmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0EAA0E;EAC1E,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX;;;;GAIC;AACH;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,2CAA2C;EAC3C,8CAA8C;EAC9C,UAAU;EACV;+BAC6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,+CAA+C;EAC/C,2EAA2E;EAC3E,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,6DAA6D;EAC7D,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,uBAAuB;;EAEvB,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;AACA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;;;;;;;GAOG;AACH;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyCG;;AAEH;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;cACY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,sDAAsD;EACxD;AACF;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;EACV;EACA;IACE,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,gBAAgB,EAAE,iBAAiB;AACrC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA,gEAAgE;AAChE;;;;EAIE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2CAA2C;EAC3C,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,oBAAoB;EACpB,wCAAwC;EACxC,WAAW;AACb;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;AACR;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb;;;KAGG;EACH,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb;;;sBAGoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;AACA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;EAEE;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;;;IAGE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,6BAA6B;AAC/B;EACE;IACE,2BAA2B;IAC3B,oCAAoC;IACpC,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,UAAU;EACZ;AACF;EACE,yBAAyB;AAC3B;AACA;;AAEA","sourcesContent":["/* .MyMarginCls{\n    margin-top: 100px;\n} */\n @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n:root {\n  /* --oragne-color: #d37c1d; */\n  /* --orange: #fe7f3c; */\n  --font-family: \"Plus Jakarta Sans\", sans-serif;\n  --orange-color: #cd601d;\n  /* --green-color: #49bf2b; */\n  --green-color: #63a211;\n  --red: #ff4d62;\n  --half-red: #d37881;\n  --green: #33c18d;\n  --white: #fff;\n  --black: #000;\n  --primary-black: rgba(0, 0, 0, 0.12);\n  --secondary-black: #212529;\n\n  --primary-blue-color: #293b83;\n  --secondary-blue-color: #3e56bf;\n  --dark-blue: #0e527d;\n  --border-lines: #e1e6e9;\n  --light-blue: #1a87cb;\n  --very-dark-blue: #24397a;\n  --very-dark-elephant-gray: #8f7777;\n  --elephant-dark-grey: #aaa;\n  --light-eleph-light-grey: #e5f0ff;\n  --disabled-light-grey: #e9ecef;\n  --very-light-grey: #d1d1d1;\n  --v-grey-light: #eee;\n  --table-row-bg-light-grey: #fafafa;\n  --box-shadow-color: #8b8084;\n  --blue-gradient-right: linear-gradient(to right, #0e527d, #1a87cb);\n  /* linear-gradient(90deg, #031978, #3e56bf) */\n  --blue-gradient-left: linear-gradient(to left, #0e527d, #1a87cb);\n  --blue-gradient-angle: linear-gradient(90deg, #0e527d, #1a87cb);\n  --light-blue-gradient-angle: linear-gradient(\n    90deg,\n    #46a4cf 8%,\n    #2f324f 86.9%\n  );\n  --green-gradient: linear-gradient(\n    73.1deg,\n    rgba(34, 126, 34, 1) 8%,\n    rgba(99, 162, 17, 1) 86.9%\n  );\n  /* --roboto-font-family: \"Roboto\", 'Halvetica', sans-serif; */\n  --stickyBackground: #f5f5f5;\n  --borderColor: #c9d1dc;\n}\n.OrganizationTableView thead th,\n.CandidateListTableView thead th,\n.DepartmentTableView thead th,\n.JobTableView thead th {\n  background-color: #e6f3ff;\n}\nbody {\n  font-family: var(--font-family);\n}\n\n.CandidateListTableView tbody td {\n  background-color: white;\n}\n\n.job-candidate-table thead th {\n  background-color: #afd6ee !important;\n}\n\n.CandidateTestTablewView thead th {\n  background-color: #4a94da !important;\n  color: #fff !important;\n}\n\n#CreateJobOrder .p-tabmenu-nav.p-reset {\n  border: 0;\n}\n\n#CreateJobOrder .p-tabmenuitem.p-highlight {\n  border-bottom: 2px solid #1a87cb;\n}\n\n#CreateJobOrder .p-tabmenuitem .p-menuitem-link {\n  color: #1a87cb;\n}\n\n.create-job-candidate-panel {\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView {\n  padding: 0 12px 12px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_Table {\n  border: 1px solid #e3ecf7;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableHeadRow {\n  background: #eef7ff;\n  border-bottom: 1px solid #d8e8f7;\n  min-height: 44px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableRow {\n  min-height: 52px;\n}\n\n.create-job-candidate-panel #CandidateTest_DataTableView .rdt_TableBody {\n  background: #fff;\n}\n\n.create-job-candidate-panel .form-control,\n.create-job-candidate-panel .form-select,\n.create-job-candidate-panel select {\n  min-height: 34px;\n  border-color: #d7e3ef;\n  font-size: 13px;\n}\n\n.create-job-candidate-panel .btn-sm {\n  min-height: 32px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.create-job-candidate-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e6edf8;\n  background: #f8fbff;\n}\n\n.create-job-candidate-count {\n  min-width: 34px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #145b84;\n  background: #e6f3ff;\n  border: 1px solid #b9ddf4;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.create-job-candidate-search {\n  padding: 12px;\n  border-bottom: 1px solid #eef3f8;\n}\n\n.create-job-candidate-search .input-group-text {\n  color: #1a87cb;\n  background: #fff;\n  border-color: #d7e3ef;\n}\n\n.create-job-candidate-search .form-control {\n  border-color: #d7e3ef;\n  font-size: 13px;\n}\n\n.create-job-candidate-list {\n  max-height: 560px;\n  overflow-y: auto;\n  padding: 8px;\n  background: #f8fafc;\n}\n\n.create-job-candidate-item {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  margin-bottom: 8px;\n  border: 1px solid #e1e8f0;\n  border-radius: 8px;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease, background 0.18s ease;\n}\n\n.create-job-candidate-item:hover,\n.create-job-candidate-item:focus {\n  border-color: #1a87cb;\n  background: #f3f9ff;\n  box-shadow: 0 8px 18px rgba(26, 135, 203, 0.12);\n  transform: translateY(-1px);\n  outline: none;\n}\n\n.create-job-candidate-item.is-selected {\n  border-color: #1a87cb;\n  background: #eaf6ff;\n  box-shadow: inset 4px 0 0 #1a87cb, 0 8px 18px rgba(26, 135, 203, 0.12);\n}\n\n.create-job-candidate-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: #fff;\n  background: #1a87cb;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.create-job-candidate-summary {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.create-job-candidate-name {\n  color: #172033;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.create-job-candidate-meta {\n  color: #6c757d;\n  font-size: 12px;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.create-job-candidate-preview {\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.04);\n}\n\n.create-job-candidate-preview-header {\n  padding: 14px 16px;\n  background: #f8fbff;\n  border-bottom: 1px solid #e6edf8;\n}\n\n.create-job-candidate-preview-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: #145b84;\n  background: #e6f3ff;\n  border: 1px solid #b9ddf4;\n  font-weight: 700;\n}\n\n.create-job-candidate-preview-meta {\n  color: #6c757d;\n  font-size: 13px;\n  overflow-wrap: anywhere;\n}\n\n.create-job-candidate-detail-card {\n  background: #fff;\n}\n\n.create-job-candidate-detail-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e6edf8;\n  background: #fff;\n}\n\n.create-job-candidate-detail-tabs .btn {\n  margin: 0;\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n.create-job-candidate-detail-body {\n  padding: 16px;\n}\n\n.create-job-candidate-detail-body .badge {\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px 9px;\n  white-space: normal;\n  text-align: left;\n}\n\n.create-job-candidate-detail-body iframe {\n  min-height: 620px;\n}\n\n.ats-candidate-detail-side {\n  padding: 1rem;\n  border-right: 1px solid #e2e8f0;\n  overflow: hidden;\n  height: 100%;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ats-candidate-detail-switch {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding: 4px;\n  border: 1px solid #d9e4f5;\n  border-radius: 8px;\n  background: #f8fbff;\n  flex: 0 0 auto;\n}\n\n.ats-candidate-detail-switch button {\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #475569;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.ats-candidate-detail-switch button.active {\n  background: #1a87cb;\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(26, 135, 203, 0.18);\n}\n\n.ats-candidate-detail-content {\n  overflow-y: auto;\n  padding-right: 4px;\n  min-height: 0;\n}\n\n.ats-candidate-detail-fields {\n  display: grid;\n  gap: 8px;\n}\n\n.ats-candidate-detail-field {\n  display: grid;\n  grid-template-columns: 24px 1fr;\n  gap: 8px;\n  align-items: flex-start;\n  padding: 9px 10px;\n  border: 1px solid #edf2f7;\n  border-radius: 8px;\n  background: #fbfdff;\n}\n\n.ats-candidate-detail-field i {\n  color: #1a87cb;\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.candidate-modal .candidate-contact-icon,\n.candidate-modal .candidate-contact-icon * {\n  color: #4f46e5 !important;\n  stroke: #4f46e5 !important;\n}\n\n.ats-candidate-detail-field span {\n  display: block;\n  color: #64748b;\n  font-size: 11px;\n  line-height: 1.2;\n  margin-bottom: 2px;\n}\n\n.ats-candidate-detail-field strong {\n  display: block;\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.expander-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  font-size: 50px;\n  font-weight: bold;\n  user-select: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.expander-bubble:hover {\n  background-color: #e0e0e0;\n  border-radius: 50%;\n  background-color: #f4f4f4;\n  border: 1px solid #d0d0d0;\n}\n\n.CDV_Container {\n  position: relative;\n  width: 70px;\n  height: 70px;\n  border-radius: 12px;\n}\n\n.CDV_Icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n/* #JobOrder_DataTableView .rdt_Table {\n    min-width: 100%;\n} */\n\n#CandidateTest_DataTableView .rdt_Table {\n  /* min-width: 190%; */\n  /* border: 2px solid red; */\n}\n.closeBtn,\n.addBtn {\n  padding: 8px 18px;\n  margin-bottom: 8px;\n  /* font-size: 16px; */\n  font-weight: 700;\n  background: var(--green-gradient);\n  /* box-shadow: 5px 5px 10px var(--very-dark-elephant-gray); */\n  /* text-transform: uppercase; */\n  color: var(--white) !important;\n  /* border: 0; */\n  /* font-family: 'Mukta', sans-serif; */\n}\n\n.addBtn:hover {\n  box-shadow: -1px 1px 5px 5px var(--box-shadow-color);\n}\n.blueBtn {\n  background: var(--blue-gradient-right) !important;\n  color: var(--white) !important;\n  font-weight: 700;\n  margin: 10px;\n}\n.talent-scan-view-result-btn {\n  min-width: 82px;\n  height: 34px;\n  margin: 0;\n  white-space: nowrap;\n  line-height: 1.2;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n.talent-scan-view-result-btn:hover,\n.talent-scan-view-result-btn:focus {\n  font-size: 15px;\n}\n.searchIconBtn {\n  background: var(--blue-gradient-right) !important;\n  color: var(--white) !important;\n  font-weight: 700;\n}\n\n.candidate-name-with-initials {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  min-height: 44px;\n  padding: 4px 0;\n}\n\n.candidate-name-initials {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  flex: 0 0 30px;\n  margin-top: 0;\n  padding: 0;\n  box-sizing: border-box;\n  border-radius: 50%;\n  background: #f3e8ff;\n  color: #7e22ce;\n  border: 0;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0;\n  text-decoration: none;\n}\n\n.candidate-name-with-initials > span:last-child {\n  flex: 1 1 auto;\n  min-width: 0;\n  line-height: 1.25;\n  white-space: normal;\n  overflow-wrap: break-word;\n  font-size: 14px;\n}\n\n.expander-bubble {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  font-size: 50px;\n  font-weight: bold;\n  user-select: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.expander-bubble:hover {\n  background-color: #e0e0e0;\n  border-radius: 50%;\n  background-color: #f4f4f4;\n  border: 1px solid #d0d0d0;\n}\n#JobOrderTableView .rdt_TableCol:nth-child(1),\n#JobOrderTableView .rdt_TableCol:nth-child(3),\n#JobOrderTableView .rdt_TableCol:nth-child(5) {\n  justify-content: initial;\n  text-align: center;\n}\n#JobOrderTableView .sc-hJRrWL .rdt_TableCell,\n#JobOrderTableView .sc-hJRrWL .rdt_TableCell span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#JobOrderTableView,\n#JobOrderTableView .rdt_Table,\n#JobOrderTableView .rdt_TableHead,\n#JobOrderTableView .rdt_TableBody,\n#JobOrderTableView .rdt_TableRow {\n  width: 100% !important;\n}\n\n#JobOrderTableView .rdt_Table,\n#JobOrderTableView .rdt_TableBody {\n  overflow-x: hidden !important;\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol {\n  padding: 8px 8px !important;\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol,\n#JobOrderTableView .rdt_TableHead .rdt_TableCol > div {\n  min-width: 0;\n  justify-content: center;\n  overflow: visible;\n  white-space: normal;\n}\n\n#JobOrderTableView .rdt_TableHead .rdt_TableCol .fs-6 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 100%;\n  font-size: 14px !important;\n  line-height: 1.2;\n  text-align: center;\n  white-space: normal;\n}\n\n#JobOrderTableView .addCandidateHeaderBtn {\n  width: 100%;\n  min-width: 0;\n  padding: 0 !important;\n  justify-content: center;\n  white-space: normal;\n  line-height: 1.2;\n}\n\n#JobOrderTableView .addCandidateHeaderBtn .ms-1 {\n  margin-left: 0 !important;\n}\n\n#JobOrderTableView .job-order-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 28px;\n  width: 100%;\n}\n\n#JobOrderTableView .job-order-actions-cell .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0 !important;\n}\n/* #JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM{\n        padding-left: 8px;\n    padding-right: 4px;\n    border-right: 1px solid var(--border-lines);\n    border-bottom: 1px solid var(--border-lines);\n} */\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell {\n  border-right: 1px solid var(--border-lines);\n  border-bottom: 1px solid var(--border-lines);\n  /* border-right: 1px solid blue;\n  border-bottom: 1px solid blue; */\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell span {\n  /* width: 90%; */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#JobOrderTableView .sc-hJRrWL .rdt_TableHeadRow .sc-hKMtZM:first-child {\n  border-left: 1px solid var(--border-lines);\n}\n\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11), */\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10), */\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(12),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(11),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(10),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2){\n  justify-content: center;\n}\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4) {\n  font-weight: 500;\n}\n\n/* #JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) span {\n  font-weight: 500;\n  background-color: #ebe9e9;\n  border-radius: 0.375rem;\n} */\n\n#JobOrderTableView .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) {\n  font-weight: 500;\n}\n\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5),\n#MailTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(6),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(8),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(15),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(17),\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(13), */\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(16),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(9) {\n  justify-content: center;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol:nth-child(5) {\n  justify-content: center;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(16),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(8),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(13),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(14),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(17),\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(15), */\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(7),\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6) {\n  justify-content: center;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) {\n  justify-content: start !important;\n}\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div {\n  width: 95%;\n  /* border: 2px solid red; */\n}\n\n/* \n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2) > div > span {\n  border: 2px solid red;\n} */\n\n#CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3) div span {\n  width: 180px;\n}\n\n#CalendarScheduled_TableView tbody tr td:nth-child(2) {\n  text-align: center !important;\n}\n\n/* #CandidateTest_DataTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(9) {\n  border: 2px solid red;\n} */\n/* MobilePhoneContaier */\n\n/* #CalendarScheduled_TableView tbody tr td:nth-child(4) {\n  border: 2px solid red;\n  white-space: nowrap;\n  width: 150px !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n} */\n\n#CandidateTest_DataTableView {\n  /* Chandu */\n}\n\n#CandidateTest_DataTableView .rdt_TableHeadRow {\n  min-height: 52px;\n}\n\n#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol {\n  align-items: center;\n  justify-content: center;\n  padding: 8px 8px !important;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_TableHead .rdt_TableCol > div {\n  min-width: 0;\n  justify-content: center;\n  white-space: normal;\n}\n\n#CandidateTest_DataTableView .ColumnTitle,\n#CandidateTest_DataTableView .font_15 {\n  font-size: 14px !important;\n  line-height: 1.15;\n  text-align: center;\n  white-space: normal;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableRow {\n  min-height: 40px;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell {\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 5px 8px !important;\n  text-align: center;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell > div {\n  min-width: 0;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(2),\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(3),\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(4) {\n  justify-content: flex-start;\n  text-align: left;\n}\n\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(9) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(10) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(11) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(12) > div,\n#CandidateTest_DataTableView .rdt_TableBody .rdt_TableCell:nth-child(13) > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n#CandidateTest_DataTableView .job-candidate-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  width: 100%;\n}\n\n#CandidateTest_DataTableView .job-candidate-actions-cell .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.candidate-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n}\n.candidate-modal .modal-header {\n  border-bottom: 1px solid #e9ecef;\n}\n\n.bg-light-subtle {\n  background-color: #f8f9fa !important;\n}\n\n.candidate-modal .border {\n  border-color: #dee2e6 !important;\n}\n\n.candidate-modal strong {\n  /* min-width: 160px; */\n  display: inline-block;\n}\n\n.candidate-modal .badge {\n  font-size: 0.85rem;\n  padding: 0.4em 0.8em;\n  border-radius: 12px;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.modal-content {\n  background: white;\n  /* padding: 20px; */\n  border-radius: 8px;\n  width: 400px;\n  /* max-width: 90%; */\n  border: 0px !important;\n}\n.modal-content h3 {\n  margin-top: 0;\n}\n.modal-content textarea {\n  width: 100%;\n  margin: 10px 0;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.modal-buttons button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.modal-buttons button:first-child {\n  background: #ccc;\n}\n.modal-buttons button:last-child {\n  background: #3b82f6;\n  color: white;\n}\n\n#ExistingCandidate_MultiSel .searchWrapper {\n  display: flex;\n  overflow-x: auto;\n  padding: 0.1375rem 0.75rem !important;\n  border-radius: 0.375rem !important;\n  font-size: 0.875rem;\n  height: 34px;\n}\n\n#ExistingCandidate_MultiSel .chip {\n  position: absolute;\n  left: 10px;\n  cursor: pointer;\n}\n\n#ExistingCandidate_MultiSel input::placeholder {\n  position: absolute;\n  bottom: 1px;\n  left: 0px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--secondary-black);\n}\n\n.JobTimeLineContainer {\n  position: relative;\n  border-left: 2px solid #1a87cb;\n}\n\n.JobTimeLineBlock {\n  position: relative;\n}\n\n.JobTimeLineBlock::before {\n  position: absolute;\n  content: \"\";\n  width: 20px;\n  height: 20px;\n  background-color: #1a87cb;\n  border-radius: 50%;\n}\n.JobTimeLineBlock::after {\n  position: absolute;\n  top: 8px;\n  /* right: 98%; */\n  right: 97.7%;\n  content: \"\";\n  width: 18px;\n  height: 2px;\n  border: 2px solid #1a87cb;\n}\n\n.CandyTimeLine_ActionType,\n.JobTimeLine_ActionType {\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.CandyTimeLine_CreaedBy,\n.CandyTimeLine_ActionDateTime,\n.JobTimeLine_CreaedBy,\n.JobTimeLine_ActionDateTime {\n  font-weight: 500;\n  font-size: 0.75rem !important;\n  color: #b1b0b0;\n}\n\n.CandyTimeLine_Actioned_By,\n.JobTimeLine_Actioned_By {\n  font-weight: 400;\n  font-size: 0.75rem !important;\n}\n\n.TimeStamp {\n  position: absolute;\n  right: 0;\n  top: 0;\n  text-align: center;\n  background-color: #1a87cb;\n  color: #fff;\n}\n\n#JobOrderTableView header {\n  min-height: 1px;\n}\n\n.bg_blue {\n  background-color: #1a87cb;\n}\n.skill-tag {\n  background-color: #e9ecef;\n  padding: 0.35rem 0.75rem;\n  border-radius: 8px;\n  display: inline-block;\n  margin-right: 0.5rem;\n  margin-bottom: 0.4rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n.skill-box {\n  border: 1px solid #dee2e6;\n  padding: 0.9rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  background-color: #fdfdfd;\n}\n\ninput::-ms-reveal {\n  display: none;\n}\n.section-title {\n  color: #0e527d;\n  font-weight: 600;\n}\n.calendar-container {\n  height: 650px;\n}\n.calendar-cell {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  padding: 3px;\n  border-right: 1px solid #ddd;\n}\n.event-block {\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  padding: 6px;\n  border-radius: 4px;\n  margin-top: 20px;\n  height: 80px;\n  overflow-y: auto;\n}\n.event-item {\n  background: white;\n  border: 1px solid #b6d4fe;\n  padding: 4px;\n  margin-bottom: 4px;\n  border-radius: 3px;\n}\n\n.event-item div {\n  font-size: 12px;\n}\n.event-join-link {\n  font-size: 12px;\n  color: #0d6efd;\n}\n.event-no-link {\n  font-size: 11px;\n  color: #888;\n}\n\n/* .event-more-btn {\n  font-size: 11px !important;\n  padding: 0 !important;\n  text-decoration: underline;\n} */\n.event-box {\n  max-height: 80px;\n  overflow-y: auto;\n}\n.rbc-day-cell {\n  padding: 4px;\n}\n\n.rbc-time-view .rbc-row {\n  min-height: initial;\n  height: 80px;\n  overflow-y: scroll;\n}\n\n.rbc-btn-group > button:nth-child(2), /* Week */\n.rbc-btn-group > button:nth-child(3)  /* Day */ {\n  display: none !important;\n}\n/* Calendar container height */\n.calendar-container {\n  height: 80vh;\n}\n\n/* Enable scrolling in Week & Day view */\n.rbc-time-view,\n.rbc-time-content {\n  overflow-y: auto !important;\n}\n\n/* Fix pointer events */\n.calendar-cell,\n.rbc-date-cell,\n.rbc-event,\n.rbc-timeslot-group,\n.rbc-time-slot {\n  pointer-events: auto !important;\n}\n\n.rbc-row-segment {\n  display: none;\n}\n\n#ScreeningConfigTab .p-tabview-nav {\n  display: none;\n}\n\n#CreateJobOrderTabs .p-tabview-nav-link {\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n#CreateJobOrderTabs .p-tabview-nav {\n  margin-top: 8px;\n  margin-bottom: 4px !important;\n}\n\n.create-job-order-page {\n  min-height: calc(100vh - 80px);\n  max-width: 100%;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n#CreateJobOrderTabs > .p-tabview-nav-container {\n  position: sticky;\n  top: 69px;\n  z-index: 20;\n  background: #fff;\n  padding-top: 4px;\n}\n\n#CreateJobOrderTabs > .p-tabview-panels {\n  overflow: visible;\n}\n\n#SkillsAndQuestionsBlock .p-accordion-header-text {\n  color: #1a87cb;\n}\n/* Remove hover background */\n.p-dropdown:not(.p-disabled):hover {\n  box-shadow: none !important;\n  border-color: #ced4da !important;\n}\n\n/* Remove blue focus outline */\n.p-dropdown:focus,\n.p-dropdown:focus-visible,\n.p-dropdown.p-focus {\n  box-shadow: none !important;\n  outline: none !important;\n  border-color: #ced4da !important;\n}\n.p-multiselect .p-multiselect-label {\n  transition: none;\n}\n.p-dropdown-label.p-inputtext.p-placeholder:hover {\n  border-color: inherit !important;\n  box-shadow: none !important;\n  cursor: pointer !important;\n}\n.p-dropdown-label.p-inputtext.p-placeholder {\n  color: black !important ;\n}\n.p-dropdown:not(.p-disabled):hover .p-dropdown-label.p-inputtext.p-placeholder {\n  color: white !important;\n}\n\n/* Default icon color = black */\n.p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon {\n  color: black !important;\n}\n\n/* On hover of the dropdown, icon color = white */\n.p-dropdown:not(.p-disabled):hover\n  .p-dropdown-trigger\n  .p-dropdown-trigger-icon {\n  color: white !important;\n}\n\n#AccessPrivileges_UserTable .rdt_TableCell input[type=\"checkbox\"] {\n  margin: 0 auto;\n  display: block;\n}\n#AccessPrivileges_UserTable .rdt_TableCol_Sortable {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable .sc-jwIPbr,\n#AccessPrivileges_UserTable .bAhklE {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable .rdt_TableCol_Sortable .rdt_TableSortLabel {\n  display: inline-block;\n  margin: 0 auto;\n}\n\n#RoleDropdown div svg,\n#RoleDropdown div,\n#RoleDropdown span {\n  color: #000;\n  background: #e0e0ea !important;\n}\n\n#SubTypeDropdown div svg,\n#SubTypeDropdown span,\n#PriorityDropdown div svg,\n#PriorityDropdown span {\n  color: #000 !important;\n}\n/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol {\n  border: 2px solid red;\n} */\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(10),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(10),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(12),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#MailTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1) {\n  /* border: 2px solid red; */\n  justify-content: center;\n  border-right: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {\n  border-left: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(5),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(4),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(1) {\n  border-top: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(6) {\n  border-right: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  border-left: 1px solid #e0e0e0;\n}\n\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(6),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(5),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(4),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(3),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(2),\n#MailTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  border-right: 1px solid #e0e0e0;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  text-align: center;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AccessPrivileges_UserTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  width: 90%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  /* padding-left: 20px; */\n}\n\n/* #AccessPrivileges_UserTable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell{\n  border: 2px solid blue;\n} */\n\n#UserManagement_TableView .p-dropdown:not(.p-disabled):hover,\n#UserManagement_TableView .p-dropdown:not(.p-disabled):hover {\n  background-color: transparent !important;\n  color: #000;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown span,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown span,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span,\n#LookupCustomize .p-paginator-bottom .p-dropdown span,\n#JobDatatable .p-paginator-bottom .p-dropdown span,\n#RolesList .p-paginator-bottom .p-dropdown span,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown span,\n#RecruiterReports_TableView .p-paginator-bottom .p-dropdown span,\n#JobTableView .p-paginator-bottom .p-dropdown span,\n#CandidateInfo .p-paginator-bottom .p-dropdown span,\n#ArchiveReasonTableView .p-paginator-bottom .p-dropdown span,\n#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown span,\n#PlacementReportTable .p-paginator-bottom .p-dropdown span,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown span {\n  background-color: white;\n  border-left: 1px solid #ddd;\n  border-top: 1px solid #ddd;\n  border-bottom: 1px solid #ddd;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown div,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown div,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown div,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown div,\n#LookupCustomize .p-paginator-bottom .p-dropdown div,\n#RolesList .p-paginator-bottom .p-dropdown div,\n#JobDatatable .p-paginator-bottom .p-dropdown div,\n#MyPlaceMentReportTable .p-paginator-bottom .p-dropdown div,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown div,\n#PlacementReportTable .p-paginator-bottom .p-dropdown div,\n#JobTableView .p-paginator-bottom .p-dropdown div,\n#CandidateInfo .p-paginator-bottom .p-dropdown div,\n#ArchiveReasonTableView .p-paginator-bottom .p-dropdown div,\n#RecruiterReports_TableView .p-paginator-bottom .p-dropdown div,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown div {\n  border: 1px solid #ddd;\n  background-color: white;\n  color: black;\n  border-radius: 2px;\n}\n\n#All_Employees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#AllEmployees_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#ActiveJobSummaryReport .p-paginator-bottom div .p-dropdown-trigger svg,\n#RecruiterPerformanceReport .p-paginator-bottom div .p-dropdown-trigger svg,\n#LookupCustomize .p-paginator-bottom div .p-dropdown-trigger svg,\n#RolesList .p-paginator-bottom div .p-dropdown-trigger svg,\n#JobDatatable .p-paginator-bottom div .p-dropdown-trigger svg,\n#JobTableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#MyPlaceMentReportTable .p-paginator-bottom div .p-dropdown-trigger svg,\n#PlacementReportTable .p-paginator-bottom div .p-dropdown-trigger svg,\n#RecruiterReports_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#AllCandidates_TableView .p-paginator-bottom div .p-dropdown-trigger svg,\n#UserManagement_TableView .p-paginator-bottom div .p-dropdown-trigger svg {\n  color: black !important;\n  background-color: white;\n}\n\n#All_Employees_TableView .p-paginator-bottom .p-dropdown span:hover,\n#AllEmployees_TableView .p-paginator-bottom .p-dropdown span:hover,\n#ActiveJobSummaryReport .p-paginator-bottom .p-dropdown span:hover,\n#RecruiterPerformanceReport .p-paginator-bottom .p-dropdown span:hover,\n#LookupCustomize .p-paginator-bottom .p-dropdown span:hover,\n#RolesList .p-paginator-bottom .p-dropdown span:hover,\n#JobDatatable .p-paginator-bottom .p-dropdown span:hover,\n#AllCandidates_TableView .p-paginator-bottom .p-dropdown span:hover,\n#UserManagement_TableView .p-paginator-bottom .p-dropdown span:hover {\n  background-color: white;\n  color: black;\n}\n\n.contacts-header-box .row {\n  row-gap: 12px;\n}\n\n.contacts-header-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  width: 100%;\n}\n\n.contacts-company-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.contacts-company-filter label {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.contacts-company-select {\n  width: 200px;\n}\n\n.contacts-company-control,\n.contacts-search-input,\n.contacts-search-btn {\n  height: 38px;\n}\n\n.contacts-company-control {\n  font-size: 14px;\n}\n\n.contacts-search-filter {\n  width: 260px;\n}\n\n.contacts-search-group {\n  flex-wrap: nowrap;\n}\n\n.contacts-search-input {\n  min-width: 0;\n  font-size: 14px !important;\n}\n\n.contacts-search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  padding: 0;\n}\n\n@media (max-width: 991.98px) {\n  .contacts-header-actions {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n}\n\n.roles-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.roles-header-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.roles-company-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 200px;\n}\n\n.roles-company-filter label {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.roles-company-control,\n.roles-add-action .p-button {\n  height: 38px;\n}\n\n.roles-company-control {\n  font-size: 14px;\n}\n\n.roles-add-action .p-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 767.98px) {\n  .roles-header-row,\n  .roles-header-actions {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n.user-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  margin-bottom: 14px;\n}\n\n.user-header-actions {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.user-company-filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 200px;\n}\n\n.user-company-filter label {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n}\n\n.user-company-control,\n.user-search-input,\n.user-search-btn {\n  height: 38px;\n}\n\n.user-company-control {\n  font-size: 14px;\n}\n\n.user-search-filter {\n  width: 260px;\n}\n\n.user-search-group {\n  flex-wrap: nowrap;\n}\n\n.user-search-input {\n  min-width: 0;\n  font-size: 14px !important;\n}\n\n.user-search-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  padding: 0;\n}\n\n@media (max-width: 767.98px) {\n  .user-header-row,\n  .user-header-actions {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n#CandidateFinishTable table thead tr th:nth-child(5) {\n  text-align: center;\n}\n\n#CandidateFinishTable table tbody tr td:nth-child(5) {\n  text-align: center;\n}\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  font-size: 0.85rem;\n}\n\n\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#AllCandidates_TableView table tr td:nth-child(7),\n#AllCandidates_TableView table tr td:nth-child(6),\n#AllCandidates_TableView table tr td:nth-child(5),\n#AllCandidates_TableView table tr td:nth-child(4),\n#AllCandidates_TableView table tr td:nth-child(3),\n#AllCandidates_TableView table tr td:nth-child(2),\n#AllCandidates_TableView table tr td:nth-child(1) {\n  width: 150px !important;\n}\n\n.JobCreateBy_AllCandidates,\n.JobName_AllCandidates,\n.JobEmail_AllCandidates,\n.JobTitle_AllCandidates {\n  width: 140px !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView #AllCandidates_TableView .p-datatable-wrapper {\n  overflow-x: hidden !important;\n}\n\n#CandidateList_CardView #AllCandidates_TableView table {\n  width: 100% !important;\n  table-layout: fixed;\n}\n\n#AllCandidates_TableView table tr th:nth-child(1),\n#AllCandidates_TableView table tr td:nth-child(1) {\n  width: 44px !important;\n  min-width: 56px !important;\n  max-width: 44px !important;\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n  text-align: center !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(6),\n#AllCandidates_TableView table tr td:nth-child(6) {\n  width: 230px !important;\n  min-width: 230px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(2),\n#AllCandidates_TableView table tr td:nth-child(2) {\n  width: 200px !important;\n  min-width: 200px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(3),\n#AllCandidates_TableView table tr td:nth-child(3) {\n  width: 185px !important;\n  min-width: 185px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(4),\n#AllCandidates_TableView table tr td:nth-child(4) {\n  width: 145px !important;\n  min-width: 145px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(5),\n#AllCandidates_TableView table tr td:nth-child(5) {\n  width: 95px !important;\n  min-width: 95px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(8),\n#AllCandidates_TableView table tr td:nth-child(8) {\n  width: 190px !important;\n  min-width: 190px !important;\n}\n\n#AllCandidates_TableView table tr th:nth-child(9),\n#AllCandidates_TableView table tr td:nth-child(9) {\n  width: 155px !important;\n  min-width: 155px !important;\n}\n\n#CandidateList_CardView .JobName_AllCandidates,\n#CandidateList_CardView .JobTitle_AllCandidates,\n#CandidateList_CardView .JobCreateBy_AllCandidates {\n  width: auto !important;\n  max-width: 100%;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n#CandidateList_CardView .JobName_AllCandidates {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .JobName_AllCandidates > span:first-child {\n  flex: 0 0 30px;\n}\n\n#CandidateList_CardView .JobName_AllCandidates > span:last-child {\n  display: inline-block;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .candidate-name-with-initials > span:last-child {\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .JobEmail_AllCandidates,\n#CandidateList_CardView .JobPhone_AllCandidates {\n  width: 100% !important;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .JobEmail_AllCandidates span,\n#CandidateList_CardView .JobPhone_AllCandidates span {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .JobTitle_AllCandidates span,\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {\n  display: block;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:first-child {\n  margin-bottom: 4px;\n}\n\n#CandidateList_CardView .JobCreateBy_AllCandidates > div:last-child {\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-cell {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 28px;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  min-height: 34px;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-cell.no-history {\n  display: flex;\n  justify-content: center;\n}\n\n#CandidateList_CardView .candidate-pipeline-stage-text {\n  display: block;\n  min-width: 0;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.25;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#CandidateList_CardView .candidate-pipeline-history-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  min-width: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  color: #111827;\n  background: #f8fafc;\n  box-shadow: none;\n}\n\n#CandidateList_CardView .candidate-pipeline-history-btn svg {\n  width: 14px;\n  height: 14px;\n}\n\n#CandidateList_CardView .CandidateListTableView .p-radiobutton,\n#CandidateList_CardView .CandidateListTableView .p-radiobutton .p-radiobutton-box {\n  width: 18px;\n  height: 18px;\n}\n\n#CandidateList_CardView .candidate-actions-main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n}\n\n#CandidateList_CardView .candidate-action-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  padding: 0 !important;\n  margin: 0;\n  border-radius: 6px;\n  line-height: 1;\n}\n\n#CandidateList_CardView .candidate-action-icon-btn svg,\n#CandidateList_CardView .candidate-action-icon-btn i {\n  display: block;\n  margin: 0;\n  font-size: 14px;\n}\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#JobOrderTableView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #e6f3ff;\n}\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n#CandidateTest_DataTableView .rdt_Table .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  background-color: #f8f8f8;\n}\n#JobOrderTableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#CandidateTest_TableView .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#UserManagement_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  span {\n  font-size: 0.85rem;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#TelephonicTest_Table .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#TalentScanResultView .rdt_Table .rdt_TableHead .rdt_TableHeadRow .rdt_TableCol,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  border-right: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n  background-color: #e6f3ff;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:first-child {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#ExtensionLogs_Datatable .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#TelephonicTest_Table .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell {\n  border-right: 1px solid #e0e0e0;\n}\n\n/* #CandidateViewSummaryTable .rdt_Table .rdt_TableBody,\n#CandidateViewSummaryTable .rdt_Table .rdt_TableHead {\n  border-left: 1px solid #e0e0e0;\n} */\n\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell,\n#CandidateViewSummaryTable\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol {\n  text-align: center;\n  justify-content: center;\n}\n\n/* #CandidateViewSummaryTable .rdt_Table {\n  border: 1px solid #e0e0e0;\n  \n} */\n\n#CandidateViewSummaryTable .rdt_ExpanderRow {\n  border-left: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable .rdt_Table .rdt_TableHead .bGNKtt:first-child,\n#JobOrderTableView .rdt_Table .rdt_TableHead .bGNKtt:first-child {\n  border-right: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  border-top: 1px solid #e0e0e0;\n}\n\n#CandidateViewSummaryTable .rdt_Table .rdt_TableRow .gOAnHZ:first-child,\n#JobOrderTableView .rdt_Table .rdt_TableRow .gOAnHZ:first-child {\n  border-right: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n  /* border-right: 2px solid red; */\n}\n\n#TalentScanResultView.rdt_Table .rdt_TableRow div:first-child {\n  border-right: 2px solid blue;\n}\n\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#CandidateTest_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#TalentScanResultView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(2),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(4),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(6),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#AllLoginActivitysCandy_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(9),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(8),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(7),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(5),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(3),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableHead\n  .rdt_TableHeadRow\n  .rdt_TableCol:nth-child(1),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#CandidateTest_DataTableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(12),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(11),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(2),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(3),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(4),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(5),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(6),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(7),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(8),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(9),\n#TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(10),\n#AllReferralCandidates_TableView\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell:nth-child(1) {\n  justify-content: center;\n}\n\n.font_12 {\n  font-size: 12px;\n}\n\n.font_15,\n.ColumnTitle {\n  font-size: 0.85rem;\n}\n\n#CandidateApprovalTable table thead tr th {\n  text-align: center;\n}\n\n#CandidateApprovalTable table tbody tr td:nth-child(2) div,\n#CandidateApprovalTable table tbody tr td:nth-child(4) div,\n#CandidateApprovalTable table tbody tr td:nth-child(3) div {\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n/* #UserManagement_TableView table tbody tr td:nth-child(4),\n#UserManagement_TableView table tbody tr td:nth-child(3),\n#UserManagement_TableView table tbody tr td:nth-child(2), */\n/* #CandidateApprovalTable table tbody tr td:nth-child(3), */\n/* #CandidateApprovalTable table tbody tr td:nth-child(2) {\n  text-align: center;\n   \n} */\n#VitelMeetLink table tbody tr td:nth-child(1),\n#VitelMeetLink table tbody tr td:nth-child(2),\n#VitelMeetLink table tbody tr td:nth-child(3),\n#VitelMeetLink table tbody tr td:nth-child(4),\n#UserManagement_TableView table tbody tr td:nth-child(1),\n#UserManagement_TableView table tbody tr td:nth-child(2),\n#UserManagement_TableView table tbody tr td:nth-child(3),\n#UserManagement_TableView table tbody tr td:nth-child(4),\n#UserManagement_TableView table tbody tr td:nth-child(5) {\n  text-align: center !important;\n  border-right: 1px solid #e0e0e0;\n}\n\n#UserManagement_TableView table tbody tr td:nth-child(5) div {\n  justify-content: center;\n}\n\n#UserManagement_TableView table thead tr th div span {\n  width: 100%;\n  text-align: center !important;\n}\n\n#CandidateTest_DataTableView .rdt_Table {\n  border-top: 1px solid #e0e0e0;\n  border-left: 1px solid #e0e0e0;\n}\n\n#All_Employees_TableView table tbody tr td {\n  border-right: 1px solid #e0e0e0;\n}\n\n#All_Employees_TableView table tbody tr td span {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(3) {\n  width: 150px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(2) {\n  width: 150px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(3) span,\n#All_Employees_TableView table tbody tr td:nth-child(2) span {\n  display: block;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* #All_Employees_TableView table thead tr th:nth-child(3) div,\n */\n\n#VitelMeetLink table thead tr th:nth-child(1) div,\n#VitelMeetLink table thead tr th:nth-child(2) div,\n#VitelMeetLink table thead tr th:nth-child(3) div,\n#VitelMeetLink table thead tr th:nth-child(4) div,\n#All_Employees_TableView table thead tr th:nth-child(6) div,\n#All_Employees_TableView table thead tr th:nth-child(5) div,\n#All_Employees_TableView table thead tr th:nth-child(4) div,\n#All_Employees_TableView table thead tr th:nth-child(2) div,\n#All_Employees_TableView table thead tr th:nth-child(1) div {\n  justify-content: center;\n}\n#recentAactivityTable table thead tr th:nth-child(1) div,\n#recentAactivityTable table thead tr th:nth-child(2) div,\n#recentAactivityTable table thead tr th:nth-child(3) div,\n#recentAactivityTable table thead tr th:nth-child(4) div,\n\n#Smtp_table table thead tr th:nth-child(1) div,\n#Smtp_table table thead tr th:nth-child(2) div,\n#Smtp_table table thead tr th:nth-child(3) div,\n#Smtp_table table thead tr th:nth-child(4) div,\n#Smtp_table table thead tr th:nth-child(5) div,\n#Smtp_table table thead tr th:nth-child(6) div{\n  /* text-align: center !important; */\n  /* text-align: center !important; */\n  justify-content: center;\n}\n\n#recentAactivityTable table thead tr th:nth-child(1),\n#recentAactivityTable table tbody tr td:nth-child(2),\n#recentAactivityTable table tbody tr td:nth-child(3),\n#recentAactivityTable table tbody tr td:nth-child(4),\n#recentAactivityTable table tbody tr td:nth-child(5),\n#Smtp_table table tbody tr td:nth-child(1),\n#Smtp_table table tbody tr td:nth-child(2),\n#Smtp_table table tbody tr td:nth-child(3),\n#Smtp_table table tbody tr td:nth-child(4),\n#Smtp_table table tbody tr td:nth-child(5),\n#Smtp_table table tbody tr td:nth-child(6){\n  text-align: center !important;\n  border-left: 1px solid #e0e0e0;\n}\n\n#Smtp_table table tbody tr td:nth-child(6) div {\n  justify-content: space-evenly;\n}\n#All_Employees_TableView table tbody tr td:nth-child(5),\n#All_Employees_TableView table tbody tr td:nth-child(4),\n#All_Employees_TableView table tbody tr td:nth-child(2),\n#All_Employees_TableView table tbody tr td:nth-child(1) {\n  text-align: center !important;\n}\n/* Modal */\n.notification-modal .modal-content {\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* Header */\n.notification-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 12px 16px;\n}\n\n/* Body */\n.notification-body {\n  max-height: 420px;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n/* Notification Item */\n.notification-item {\n  padding: 10px;\n  border-radius: 8px;\n  margin-bottom: 6px;\n  transition: background 0.2s ease;\n}\n\n.notification-item.unread {\n  background: #f1f7ff;\n}\n\n.notification-item.read {\n  background: #ffffff;\n  opacity: 0.8;\n}\n\n.notification-item:hover {\n  background: #eef4ff;\n}\n\n/* Icon */\n.notification-icon {\n  width: 40px;\n  height: 40px;\n  background: #e7f0ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0d6efd;\n  font-size: 16px;\n}\n\n/* Content */\n.notification-content {\n  flex: 1;\n  padding-left: 12px;\n}\n\n.notification-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.notification-message {\n  font-size: 13px;\n  color: #495057;\n  margin-top: 2px;\n}\n\n/* Footer */\n.notification-footer {\n  margin-top: 6px;\n  font-size: 11px;\n  color: #6c757d;\n}\n\n/* Date */\n.notification-date {\n  font-size: 11px;\n}\n\n/* Mark Read Button */\n.mark-read-btn {\n  background: none;\n  border: none;\n  color: #0d6efd;\n  font-size: 11px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.mark-read-btn:hover {\n  text-decoration: underline;\n}\n\n/* Empty State */\n.no-notification {\n  text-align: center;\n  padding: 30px;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n/* #All_Employees_TableView table thead tr th:nth-child(2) {\n  border: 2px solid red;\n  width: 120px;\n}\n\n#All_Employees_TableView table tbody tr td:nth-child(2) span {\n  border: 2px solid red;\n  width: 120px;\n} */\n\n.CandidateAprRejReason {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 200px;\n}\n\n#AdminModule_Tabs .p-tabview-panels {\n  display: none;\n}\n\n#PreviewJobPortalCards ul {\n}\n\n#All_Notifications_Modal .btn-close {\n  margin-left: 3px;\n  filter: invert(1);\n  opacity: 1;\n}\n.tab-btn {\n  background: none;\n  border: none;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #6b7280;\n  position: relative;\n  cursor: pointer;\n}\n\n.tab-btn.active {\n  color: #3a85f7;\n  font-weight: 600;\n}\n\n.tab-btn.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #4c8cec;\n  border-radius: 2px;\n}\n\n/* #RecentOpenJobs_TableView table tr td { \n  border: 2px solid red;\n   \n} */\n#RecentOpenJobs_TableView table tbody tr td {\n  border-right: 1px solid #ddd;\n}\n\n#RecentOpenJobs_TableView table tbody tr td:last-child {\n  border-right: initial;\n}\n\n#RecentOpenJobs_TableView table tr td:nth-child(10) span,\n#RecentOpenJobs_TableView table tr td:nth-child(9) span,\n#RecentOpenJobs_TableView table tr td:nth-child(6) span,\n#RecentOpenJobs_TableView table tr td:nth-child(5) span,\n#RecentOpenJobs_TableView table tr td:nth-child(2) span {\n  display: inline-block;\n  width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n#RecentOpenJobs_TableView table tr th:nth-child(12) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(11) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(10) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(9) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(8) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(7) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(6) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(5) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(4) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(3) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(2) span:first-child,\n#RecentOpenJobs_TableView table tr th:nth-child(1) span:first-child {\n  width: 100%;\n  justify-content: center !important;\n  display: inline-block;\n  text-align: center;\n}\n\n#RecentOpenJobs_TableView table tr td:nth-child(12),\n#RecentOpenJobs_TableView table tr td:nth-child(11),\n#RecentOpenJobs_TableView table tr td:nth-child(7),\n#RecentOpenJobs_TableView table tr td:nth-child(4),\n#RecentOpenJobs_TableView table tr td:nth-child(3),\n#RecentOpenJobs_TableView table tr td:nth-child(1) {\n  text-align: center !important;\n}\n/* \nwhite-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n */\n#JObInfoModal .btn-close {\n  /* border: 2px solid red; */\n  /* display: none; */\n}\n#BulkUploadModal .btn-close {\n  border: 2px solid red;\n  display: none;\n}\n/* highlight today's cell */\n/* .rbc-month-view .rbc-day-bg.today-highlight {\n  background-color: #eaf6ff; /* light blue */\n/* }  */\n.today-highlight {\n  /* border: 2px solid #0d6efd; */\n  background-color: #eaf6ff;\n  /* border-radius: 6px;   */\n}\n\n.Selected_BgColor {\n  /* background-color: lightblue; */\n  background-color: #e0f2f7;\n}\n#AllEmployees_TableView table th:nth-child(1),\n#AllEmployees_TableView table th:nth-child(2),\n#AllEmployees_TableView table th:nth-child(3),\n#AllEmployees_TableView table th:nth-child(4),\n#AllEmployees_TableView table th:nth-child(5) {\n  width: 260px;\n}\n/* #AllEmployees_TableView table tbody td:nth-child(3) span, */\n#AllEmployees_TableView\n  table\n  tbody\n  td:nth-child(2)\n  #AllEmployees_TableView\n  table\n  tbody\n  td:nth-child(5) {\n  border: 2px solid red;\n  width: 200px;\n}\n.sun-editor-wrapper .sun-editor {\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n}\n\n.sun-editor-wrapper.sun-error .sun-editor {\n  border: 2px solid #dc3545 !important;\n}\n\n.RecruiterNamesListContainer {\n  height: 50vh;\n  overflow: auto;\n}\n#SectioScoreDatatable table tbody td:nth-child(1),\n#SectioScoreDatatable table tbody td:nth-child(2),\n#SectioScoreDatatable table tbody td:nth-child(3),\n#SectioScoreDatatable table tbody td:nth-child(4),\n#SectioScoreDatatable table tbody td:nth-child(5),\n#SectioScoreDatatable table tbody td:nth-child(6) {\n  text-align: center !important;\n  border-right: 1px solid #eaf6ff;\n}\n#SectioScoreDatatable table th:nth-child(1) div,\n#SectioScoreDatatable table th:nth-child(2) div,\n#SectioScoreDatatable table th:nth-child(3) div,\n#SectioScoreDatatable table th:nth-child(4) div,\n#SectioScoreDatatable table th:nth-child(5) div,\n#SectioScoreDatatable table th:nth-child(6) div {\n  justify-content: center !important;\n}\n\n/* #LinkCandidates_DataTableView table tbody {\n  height: 60vh;\n  overflow: auto;\n} */\n#ArchiveReasonTableView table tr td:nth-child(10) div {\n  width: 150px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(4) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(3) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#LinkCandidates_DataTableView table tr td:nth-child(2) {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.MobilePhoneContaier {\n  display: inline-block;\n  /* width: 80px !important; */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#RecruiterReports_TableView table thead tr th:nth-child(6) div,\n#RecruiterReports_TableView table thead tr th:nth-child(5) div,\n#RecruiterReports_TableView table thead tr th:nth-child(4) div,\n#MyPipelineReportTable table thead tr th:nth-child(6) div,\n#MyPipelineReportTable table thead tr th:nth-child(5) div,\n#MyPipelineReportTable table thead tr th:nth-child(4) div,\n#MyPipelineReportTable table thead tr th:nth-child(3) div,\n#MyPipelineReportTable table thead tr th:nth-child(2) div,\n#MyPipelineReportTable table thead tr th:nth-child(1) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(11) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(10) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(9) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(8) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(7) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(6) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(5) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(4) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(3) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(2) div,\n#RecruiterPerformanceReport table thead tr th:nth-child(1) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(9) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(8) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(7) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(6) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(5) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(4) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(3) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(2) div,\n#MyPlaceMentReportTable table thead tr th:nth-child(1) div,\n#JobTableView table thead tr th:nth-child(1) div,\n#JobTableView table thead tr th:nth-child(2) div,\n#JobTableView table thead tr th:nth-child(3) div,\n#JobTableView table thead tr th:nth-child(1) div,\n#CandidateInfo table thead tr th:nth-child(2) div,\n#CandidateInfo table thead tr th:nth-child(3) div,\n#CandidateInfo table thead tr th:nth-child(4) div,\n#ArchiveReasonTableView table thead tr th:nth-child(1) div,\n#ArchiveReasonTableView table thead tr th:nth-child(2) div,\n#ArchiveReasonTableView table thead tr th:nth-child(3) div,\n#ArchiveReasonTableView table thead tr th:nth-child(4) div,\n#ArchiveReasonTableView table thead tr th:nth-child(5) div,\n#ArchiveReasonTableView table thead tr th:nth-child(6) div,\n#ArchiveReasonTableView table thead tr th:nth-child(7) div,\n#ArchiveReasonTableView table thead tr th:nth-child(8) div,\n#ArchiveReasonTableView table thead tr th:nth-child(9) div,\n#ArchiveReasonTableView table thead tr th:nth-child(10) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(11) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(12) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(10) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(9) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(8) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(7) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(6) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(5) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(4) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(3) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(2) div,\n#ActiveJobSummaryReport table thead tr th:nth-child(1) div,\n#RecruiterReports_TableView table thead tr th:nth-child(3) div,\n#RecruiterReports_TableView table thead tr th:nth-child(2) div,\n#RecruiterReports_TableView table thead tr th:nth-child(1) div,\n#RolesList table thead tr th:nth-child(1) div,\n#RolesList table thead tr th:nth-child(2) div,\n#RolesList table thead tr th:nth-child(3) div,\n#RolesList table thead tr th:nth-child(4) div {\n  justify-content: center;\n  border-right: 1px solid #eaf6ff;\n}\n\n#RecruiterReports_TableView table tbody tr td:nth-child(15),\n#RecruiterReports_TableView table tbody tr td:nth-child(14),\n#RecruiterReports_TableView table tbody tr td:nth-child(13),\n#RecruiterReports_TableView table tbody tr td:nth-child(12),\n#RecruiterReports_TableView table tbody tr td:nth-child(11),\n#RecruiterReports_TableView table tbody tr td:nth-child(10),\n#RecruiterReports_TableView table tbody tr td:nth-child(9),\n#RecruiterReports_TableView table tbody tr td:nth-child(8),\n#RecruiterReports_TableView table tbody tr td:nth-child(7),\n#RecruiterReports_TableView table tbody tr td:nth-child(6),\n#RecruiterReports_TableView table tbody tr td:nth-child(5),\n#RecruiterReports_TableView table tbody tr td:nth-child(4),\n#RecruiterReports_TableView table tbody tr td:nth-child(3),\n#RecruiterReports_TableView table tbody tr td:nth-child(2),\n#RecruiterReports_TableView table tbody tr td:nth-child(1),\n#JobTableView table tbody tr td:nth-child(3),\n#JobTableView table tbody tr td:nth-child(2),\n#JobTableView table tbody tr td:nth-child(1),\n#CandidateInfo table tbody tr td:nth-child(1),\n#CandidateInfo table tbody tr td:nth-child(2),\n#CandidateInfo table tbody tr td:nth-child(3),\n#CandidateInfo table tbody tr td:nth-child(4),\n#ArchiveReasonTableView table tbody tr td:nth-child(1),\n#ArchiveReasonTableView table tbody tr td:nth-child(2),\n#ArchiveReasonTableView table tbody tr td:nth-child(3),\n#ArchiveReasonTableView table tbody tr td:nth-child(4),\n#ArchiveReasonTableView table tbody tr td:nth-child(5),\n#ArchiveReasonTableView table tbody tr td:nth-child(6),\n#ArchiveReasonTableView table tbody tr td:nth-child(7),\n#ArchiveReasonTableView table tbody tr td:nth-child(8),\n#ArchiveReasonTableView table tbody tr td:nth-child(9),\n#ArchiveReasonTableView table tbody tr td:nth-child(10),\n#ArchiveReasonTableView table tbody tr td:nth-child(11),\n#RecruiterReports_TableView table tbody tr td:nth-child(2),\n#RecruiterPerformanceReport table tbody tr td:nth-child(14),\n#RecruiterPerformanceReport table tbody tr td:nth-child(13),\n#RecruiterPerformanceReport table tbody tr td:nth-child(12),\n#RecruiterPerformanceReport table tbody tr td:nth-child(11),\n#RecruiterPerformanceReport table tbody tr td:nth-child(10),\n#RecruiterPerformanceReport table tbody tr td:nth-child(9),\n#RecruiterPerformanceReport table tbody tr td:nth-child(8),\n#RecruiterPerformanceReport table tbody tr td:nth-child(7),\n#RecruiterPerformanceReport table tbody tr td:nth-child(6),\n#RecruiterPerformanceReport table tbody tr td:nth-child(5),\n#RecruiterPerformanceReport table tbody tr td:nth-child(4),\n#RecruiterPerformanceReport table tbody tr td:nth-child(3),\n#RecruiterPerformanceReport table tbody tr td:nth-child(2),\n#RecruiterPerformanceReport table tbody tr td:nth-child(1),\n#ActiveJobSummaryReport table tbody tr td:nth-child(12),\n#ActiveJobSummaryReport table tbody tr td:nth-child(11),\n#ActiveJobSummaryReport table tbody tr td:nth-child(10),\n#ActiveJobSummaryReport table tbody tr td:nth-child(9),\n#ActiveJobSummaryReport table tbody tr td:nth-child(8),\n#ActiveJobSummaryReport table tbody tr td:nth-child(7),\n#ActiveJobSummaryReport table tbody tr td:nth-child(6),\n#ActiveJobSummaryReport table tbody tr td:nth-child(5),\n#ActiveJobSummaryReport table tbody tr td:nth-child(4),\n#ActiveJobSummaryReport table tbody tr td:nth-child(3),\n#ActiveJobSummaryReport table tbody tr td:nth-child(2),\n#ActiveJobSummaryReport table tbody tr td:nth-child(1),\n#TimeToHireReport table tbody tr td:nth-child(13),\n#TimeToHireReport table tbody tr td:nth-child(12),\n#TimeToHireReport table tbody tr td:nth-child(11),\n#TimeToHireReport table tbody tr td:nth-child(10),\n#TimeToHireReport table tbody tr td:nth-child(9),\n#TimeToHireReport table tbody tr td:nth-child(8),\n#TimeToHireReport table tbody tr td:nth-child(7),\n#TimeToHireReport table tbody tr td:nth-child(6),\n#TimeToHireReport table tbody tr td:nth-child(5),\n#TimeToHireReport table tbody tr td:nth-child(4),\n#TimeToHireReport table tbody tr td:nth-child(3),\n#TimeToHireReport table tbody tr td:nth-child(2),\n#TimeToHireReport table tbody tr td:nth-child(1),\n#PlacementReportTable table tbody tr td:nth-child(7),\n#PlacementReportTable table tbody tr td:nth-child(6),\n#PlacementReportTable table tbody tr td:nth-child(5),\n#PlacementReportTable table tbody tr td:nth-child(4),\n#PlacementReportTable table tbody tr td:nth-child(3),\n#PlacementReportTable table tbody tr td:nth-child(2),\n#PlacementReportTable table tbody tr td:nth-child(1),\n#MyPlaceMentReportTable table tbody tr td:nth-child(9),\n#MyPlaceMentReportTable table tbody tr td:nth-child(8),\n#MyPlaceMentReportTable table tbody tr td:nth-child(7),\n#MyPlaceMentReportTable table tbody tr td:nth-child(6),\n#MyPlaceMentReportTable table tbody tr td:nth-child(5),\n#MyPlaceMentReportTable table tbody tr td:nth-child(4),\n#MyPlaceMentReportTable table tbody tr td:nth-child(3),\n#MyPlaceMentReportTable table tbody tr td:nth-child(2),\n#MyPlaceMentReportTable table tbody tr td:nth-child(1),\n#AllEmployees_TableView table tbody tr td:nth-child(10),\n#AllEmployees_TableView table tbody tr td:nth-child(9),\n#AllEmployees_TableView table tbody tr td:nth-child(7),\n#MyPipelineReportTable table tbody tr td:nth-child(7),\n#MyPipelineReportTable table tbody tr td:nth-child(6),\n#MyPipelineReportTable table tbody tr td:nth-child(5),\n#MyPipelineReportTable table tbody tr td:nth-child(4),\n#MyPipelineReportTable table tbody tr td:nth-child(3),\n#MyPipelineReportTable table tbody tr td:nth-child(2),\n#MyPipelineReportTable table tbody tr td:nth-child(1),\n#RolesList table tbody tr td:nth-child(1),\n#RolesList table tbody tr td:nth-child(2),\n#RolesList table tbody tr td:nth-child(3),\n#RolesList table tbody tr td:nth-child(4) {\n  text-align: center !important;\n  border-right: 1px solid #dbe1e6;\n}\n#RecruiterReports_TableView table tbody tr td:nth-child(2) div {\n  width: 240px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n#ExtensionLogs_Datatable\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  div\n  #TelephonicTest_Table\n  .rdt_Table\n  .rdt_TableBody\n  .rdt_TableRow\n  .rdt_TableCell\n  div {\n  font-size: 14px;\n}\n\n/* ========== Candidate View Modal - Clean UI ========== */\n.cv-modal .modal-content {\n  border: none;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);\n}\n\n.cv-modal .modal-body {\n  max-height: 85vh;\n  overflow-y: auto;\n  padding: 0 !important;\n}\n\n/* Profile Header */\n.cv-profile-header {\n  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 100%);\n  padding: 2rem 2rem 1.8rem;\n  text-align: center;\n  position: relative;\n}\n\n.cv-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cv-close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.cv-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.2);\n  border: 3px solid rgba(255, 255, 255, 0.4);\n  color: #fff;\n  font-size: 1.5rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 0.75rem;\n  letter-spacing: 2px;\n}\n\n.cv-profile-name {\n  color: #fff;\n  font-size: 1.4rem;\n  font-weight: 600;\n  margin-bottom: 0.3rem;\n}\n\n.cv-profile-company {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.9rem;\n  margin-bottom: 0.2rem;\n}\n\n.cv-profile-exp {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n/* Sections */\n.cv-section {\n  padding: 1.25rem 1.75rem;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.cv-section--last {\n  border-bottom: none;\n  padding-bottom: 1.75rem;\n}\n\n.cv-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: #0e527d;\n  margin-bottom: 1rem;\n}\n\n/* Info Items */\n.cv-info-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.65rem 0.85rem;\n  border-radius: 10px;\n  background: #f8fafb;\n  transition: background 0.2s;\n}\n\n.cv-info-item:hover {\n  background: #eef4f8;\n}\n\n.cv-info-icon {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n}\n\n.cv-info-label {\n  font-size: 0.75rem;\n  color: #8a9bae;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n\n.cv-info-value {\n  font-size: 0.95rem;\n  color: #212529;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n/* Skills Section */\n.cv-skills-section {\n  margin-bottom: 0.85rem;\n}\n\n.cv-skills-section:last-child {\n  margin-bottom: 0;\n}\n\n.cv-skills-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #8a9bae;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 0.4rem;\n}\n\n.cv-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.cv-skill-badge {\n  padding: 0.3rem 0.7rem;\n  border-radius: 20px;\n  font-size: 0.82rem;\n  font-weight: 500;\n  display: inline-block;\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.cv-skill-badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.cv-skill-badge--primary {\n  background: #e3f2fd;\n  color: #0d47a1;\n  border: 1px solid #bbdefb;\n}\n\n.cv-skill-badge--secondary {\n  background: #e8f5e9;\n  color: #1b5e20;\n  border: 1px solid #c8e6c9;\n}\n\n.cv-skill-badge--other {\n  background: #fff3e0;\n  color: #e65100;\n  border: 1px solid #ffe0b2;\n}\n\n/* Resume Button */\n.cv-resume-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.6rem 1.25rem;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-decoration: none;\n  transition: opacity 0.2s, transform 0.15s;\n}\n\n.cv-resume-btn:hover {\n  opacity: 0.9;\n  transform: translateY(-1px);\n  color: #fff;\n  text-decoration: none;\n}\n\n.cv-resume-ext {\n  background: rgba(255, 255, 255, 0.2);\n  padding: 0.15rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  margin-left: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n/* ========== Candidates Page - Premium UI ========== */\n\n/* Hero Banner */\n.cd-hero {\n  background: linear-gradient(135deg, #0e527d 0%, #1a87cb 50%, #46a4cf 100%);\n  border-radius: 16px;\n  padding: 1.5rem 2rem;\n  margin-bottom: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.cd-hero::before {\n  content: \"\";\n  position: absolute;\n  top: -40%;\n  right: -5%;\n  width: 250px;\n  height: 250px;\n  background: rgba(255, 255, 255, 0.06);\n  border-radius: 50%;\n}\n\n.cd-hero::after {\n  content: \"\";\n  position: absolute;\n  bottom: -60%;\n  right: 10%;\n  width: 180px;\n  height: 180px;\n  background: rgba(255, 255, 255, 0.04);\n  border-radius: 50%;\n}\n\n.cd-hero-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1;\n}\n\n.cd-hero-title {\n  color: #fff;\n  font-size: 1.6rem;\n  font-weight: 700;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.cd-hero-subtitle {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 0.85rem;\n  margin: 0.2rem 0 0;\n}\n\n.cd-hero-right {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.cd-hero-stat {\n  text-align: center;\n}\n\n.cd-hero-stat-number {\n  display: block;\n  color: #fff;\n  font-size: 1.75rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.cd-hero-stat-label {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-weight: 600;\n}\n\n/* Controls Bar */\n.cd-controls {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);\n  border: 1px solid #f0f0f0;\n}\n\n.cd-controls-top {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid #f5f5f5;\n}\n\n.cd-search-wrapper {\n  flex: 1;\n  max-width: 400px;\n  position: relative;\n}\n\n.cd-search-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 0.85rem;\n  z-index: 2;\n}\n\n.cd-search-wrapper .cd-search-input {\n  padding-left: 36px !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 10px !important;\n  height: 40px;\n  font-size: 0.88rem;\n  background: #f9fafb !important;\n  transition: all 0.2s;\n}\n\n.cd-search-wrapper .cd-search-input:focus {\n  border-color: #1a87cb !important;\n  background: #fff !important;\n  box-shadow: 0 0 0 3px rgba(26, 135, 203, 0.1) !important;\n}\n\n.cd-search-clear {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  font-size: 11px;\n  z-index: 2;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cd-search-clear:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.cd-controls-right-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-left: auto;\n}\n\n.cd-company-select {\n  width: 185px;\n}\n\n/* Filter Chips */\n.cd-controls-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.cd-filters {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cd-filter-chip-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.cd-filter-chip {\n  display: flex;\n  align-items: center;\n  background: #f4f7fa;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 0;\n  overflow: hidden;\n  transition: border-color 0.2s;\n}\n\n.cd-filter-chip:focus-within {\n  border-color: #1a87cb;\n  box-shadow: 0 0 0 2px rgba(26, 135, 203, 0.1);\n}\n\n.cd-filter-chip-icon {\n  padding: 0 0.6rem;\n  color: #6b7280;\n  font-size: 0.8rem;\n  border-right: 1px solid #e5e7eb;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  background: #eef1f5;\n}\n\n.cd-filter-chip-select {\n  border: none !important;\n  background: transparent !important;\n  font-size: 0.84rem;\n  color: #374151;\n  padding: 0.35rem 1.75rem 0.35rem 0.6rem;\n  cursor: pointer;\n  outline: none;\n  min-width: 120px;\n  appearance: auto;\n}\n\n.cd-clear-filters {\n  display: flex;\n  align-items: center;\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.cd-clear-filters:hover {\n  background: #fee2e2;\n  border-color: #f87171;\n}\n\n/* Action Buttons */\n.cd-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.cd-action-btn {\n  border-radius: 8px !important;\n  font-size: 0.82rem !important;\n  font-weight: 600 !important;\n  padding: 0.42rem 0.85rem !important;\n  transition: all 0.2s !important;\n  white-space: nowrap;\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 0.15rem;\n}\n\n.cd-action-btn--outline {\n  background: #fff !important;\n  color: #374151 !important;\n  border: 1px solid #d1d5db !important;\n}\n\n.cd-action-btn--outline:hover {\n  background: #f9fafb !important;\n  border-color: #9ca3af !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n.cd-action-btn--outline:disabled {\n  opacity: 0.5 !important;\n  transform: none !important;\n}\n\n.cd-action-btn--primary {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  color: #fff !important;\n  border: none !important;\n  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.25);\n}\n\n.cd-action-btn--primary:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(14, 82, 125, 0.35) !important;\n}\n\n/* Data Card */\n.cd-data-card {\n  border: none !important;\n  border-radius: 14px !important;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04) !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  background: #fff !important;\n  border: 1px solid #f0f0f0 !important;\n}\n\n.cd-table-wrapper {\n  overflow: hidden;\n}\n\n.cd-loading-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 250px;\n  background: #fafbfc;\n}\n\n/* ===== DataTable Cell Styles ===== */\n\n/* Name Cell - Avatar + Name + Email */\n.cd-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n}\n\n.cd-name-avatar {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #0e527d, #1a87cb);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 1px;\n}\n\n.cd-name-text {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 0.88rem;\n  line-height: 1.3;\n  max-width: 160px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cd-name-email {\n  font-size: 0.73rem;\n  color: #94a3b8;\n  max-width: 160px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Job Tag */\n.cd-job-tag {\n  background: #eff6ff;\n  color: #1d4ed8;\n  padding: 0.25rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  display: inline-block;\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: 1px solid #dbeafe;\n}\n\n/* Phone */\n.cd-phone-cell {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.cd-phone-icon {\n  color: #10b981;\n  font-size: 0.7rem;\n}\n\n/* Source Badge */\n.cd-source-badge {\n  background: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* Cell Primary / Meta */\n.cd-cell-primary {\n  font-weight: 600;\n  color: #1e293b;\n  font-size: 0.85rem;\n}\n\n.cd-cell-meta {\n  font-size: 0.7rem;\n  color: #94a3b8;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n}\n\n/* Pipeline Badge */\n.cd-pipeline-badge {\n  background: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fde68a;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* HRMS Badge */\n.cd-hrms-badge {\n  background: #fae8ff;\n  color: #86198f;\n  border: 1px solid #f0abfc;\n  padding: 0.2rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* Talent Scan Button */\n.cd-scan-btn {\n  border: none;\n  border-radius: 8px;\n  padding: 0.3rem 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.2s;\n}\n\n.cd-scan-btn--ready {\n  background: #ecfdf5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.cd-scan-btn--ready:hover {\n  background: #d1fae5;\n  transform: translateY(-1px);\n}\n\n.cd-scan-btn--pending {\n  background: #f1f5f9;\n  color: #94a3b8;\n  border: 1px solid #e2e8f0;\n  cursor: not-allowed;\n}\n\n/* Actions Cell */\n.cd-actions-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.cd-actions-main {\n  display: flex;\n  gap: 0.3rem;\n}\n\n.cd-icon-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 0.82rem;\n  transition: all 0.2s;\n  color: #64748b;\n}\n\n.cd-icon-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.cd-icon-btn--edit:hover {\n  background: #eff6ff;\n  color: #2563eb;\n  border-color: #bfdbfe;\n}\n\n.cd-icon-btn--view:hover {\n  background: #f0fdf4;\n  color: #16a34a;\n  border-color: #bbf7d0;\n}\n\n.cd-icon-btn--logs:hover {\n  background: #fefce8;\n  color: #ca8a04;\n  border-color: #fde68a;\n}\n\n/* Approval Buttons */\n.cd-actions-approval {\n  display: flex;\n  gap: 0.25rem;\n}\n\n.cd-approval-btn {\n  border: none;\n  border-radius: 6px;\n  padding: 0.2rem 0.5rem;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  transition: all 0.15s;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.cd-approval-btn--approve {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.cd-approval-btn--approve:hover {\n  background: #bbf7d0;\n}\n\n.cd-approval-btn--reject {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.cd-approval-btn--reject:hover {\n  background: #fecaca;\n}\n\n.cd-approval-btn--info {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.cd-approval-btn--info:hover {\n  background: #bae6fd;\n}\n\n/* Empty State */\n.cd-empty-state {\n  text-align: center;\n  padding: 3rem 1rem;\n}\n\n.cd-empty-icon {\n  font-size: 2.5rem;\n  color: #cbd5e1;\n  margin-bottom: 0.75rem;\n  display: block;\n}\n\n.cd-empty-text {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #475569;\n  margin: 0;\n}\n\n.cd-empty-sub {\n  font-size: 0.85rem;\n  color: #94a3b8;\n  margin: 0.25rem 0 0;\n}\n\n/* ===== DataTable Overrides ===== */\n#CandidateList_CardView .cd-datatable .p-datatable-thead > tr > th {\n  background: #f8fafc !important;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.7px;\n  border-bottom: 2px solid #e2e8f0 !important;\n  border-top: none !important;\n  padding: 0.9rem 0.75rem;\n  white-space: nowrap;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr {\n  transition: all 0.15s ease;\n  border-left: 3px solid transparent;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:nth-child(even) {\n  background: #fafbfc;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr:hover {\n  background: #eff6ff !important;\n  border-left-color: #1a87cb;\n}\n\n#CandidateList_CardView .cd-datatable .p-datatable-tbody > tr > td {\n  padding: 0.7rem 0.75rem;\n  font-size: 0.86rem;\n  color: #374151;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: middle;\n}\n\n/* Paginator */\n#CandidateList_CardView .cd-datatable .p-paginator {\n  border: none !important;\n  background: #f8fafc !important;\n  padding: 0.75rem 1rem !important;\n  border-top: 2px solid #e2e8f0 !important;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page {\n  border-radius: 8px;\n  min-width: 34px;\n  height: 34px;\n  margin: 0 2px;\n  font-weight: 600;\n  font-size: 0.82rem;\n  transition: all 0.15s;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page.p-highlight {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  border-color: transparent !important;\n  color: #fff !important;\n  box-shadow: 0 2px 8px rgba(14, 82, 125, 0.3);\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-paginator\n  .p-paginator-pages\n  .p-paginator-page:not(.p-highlight):hover {\n  background: #eff6ff !important;\n}\n\n/* Checkbox */\n#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box {\n  border-radius: 6px;\n  border: 2px solid #cbd5e1;\n  width: 20px;\n  height: 20px;\n  transition: all 0.15s;\n}\n\n#CandidateList_CardView .cd-datatable .p-checkbox .p-checkbox-box.p-highlight {\n  background: linear-gradient(135deg, #0e527d, #1a87cb) !important;\n  border-color: #0e527d !important;\n}\n\n/* Scrollbar */\n#CandidateList_CardView .cd-datatable .p-datatable-wrapper::-webkit-scrollbar {\n  height: 6px;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n#CandidateList_CardView\n  .cd-datatable\n  .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .cd-hero-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  .cd-hero-right {\n    align-self: flex-start;\n  }\n  .cd-controls-top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .cd-search-wrapper {\n    max-width: 100%;\n  }\n  .cd-controls-right-group {\n    margin-left: 0;\n  }\n  .cd-controls-bottom {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .cd-actions {\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 576px) {\n  .cd-hero {\n    padding: 1.25rem;\n    border-radius: 12px;\n  }\n  .cd-hero-title {\n    font-size: 1.25rem;\n  }\n  .cd-filter-chip-group {\n    flex-direction: column;\n  }\n  .cd-actions {\n    flex-direction: column;\n  }\n  .cd-action-btn {\n    width: 100% !important;\n    justify-content: center !important;\n  }\n}\n\n#SecondScreeningContainer {\n  height: 500px;\n  overflow-y: scroll;\n}\n\n/* Telephonic Test Table Sticky Columns Starting */\n#TelephonicTest_Table {\n  position: relative;\n}\n\n#TelephonicTest_Table .rdt_Table,\n#TelephonicTest_Table .sc-fLlhyt {\n  position: relative;\n}\n\n#TelephonicTest_Table .rdt_TableBody {\n  position: sticky;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(1) {\n  position: sticky;\n  left: 0;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(2) {\n  position: sticky;\n  left: 180px;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableCol:nth-child(3) {\n  position: sticky;\n  left: 380px;\n  top: 0;\n  z-index: 1008;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n  position: sticky;\n  left: 0;\n  top: 0;\n  background-color: var(--white);\n  z-index: 1;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n  position: sticky;\n  left: 180px;\n  top: 0;\n  z-index: 1;\n}\n\n#TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n  position: sticky;\n  left: 380px;\n  top: 0;\n  z-index: 1;\n  justify-content: initial;\n}\n\n#TelephonicTest_Table .rdt_TableRow:nth-child(even) .rdt_TableCell {\n  background-color: var(--white);\n}\n\n#TelephonicTest_Table .rdt_TableRow:nth-child(odd) .rdt_TableCell {\n  background-color: var(--table-row-bg-light-grey);\n}\n\n@media screen and (min-width: 100px) and (max-width: 991px) {\n  #TelephonicTest_Table .rdt_TableBody {\n    position: relative;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(1) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(2) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableCol:nth-child(3) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n\n  #TelephonicTest_Table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n    position: relative;\n    left: initial;\n    top: initial;\n  }\n}\n/* /Telephonic Test Table Sticky Columns Ending */\n\n#SkillLevelConfiguration_TableView .rdt_Table .rdt_TableBody .rdt_TableRow {\n  /* border: 2px solid white; */\n  /* margin-bottom: 8px;\n  margin-top: 8px; */\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n/* ── Bulk Outreach Modal ─────────────────────────────────────── */\n.bo-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n}\n.bo-modal .modal-header {\n  padding: 20px 24px 0;\n  border: none;\n}\n.bo-modal .modal-body {\n  padding: 0 24px 14px;\n  background: linear-gradient(180deg, #f8fbff 0%, #f4f8ff 100%);\n}\n.bo-modal .modal-footer {\n  padding: 18px 24px 22px;\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n.bo-modal .modal-content {\n  border: 0;\n  border-radius: 22px;\n  overflow: hidden;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);\n}\n.bo-modal .modal-header {\n  padding: 22px 24px 10px;\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n}\n\n.sent-email-modal .modal-content {\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);\n}\n\n.sent-email-modal-header {\n  padding: 18px 22px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.sent-email-modal-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1e293b;\n  line-height: 1.4;\n}\n\n.sent-email-modal-body {\n  padding: 16px;\n  max-height: 78vh;\n  overflow-y: auto;\n  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);\n}\n\n.sent-email-modal-footer {\n  border-top: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.sent-email-preview-shell {\n  width: 100%;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  background: #f8fafc;\n}\n\n.email-body-content {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 32px;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.email-body-content img {\n  max-width: 100% !important;\n  height: auto !important;\n}\n\n.email-body-content table {\n  max-width: 100% !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.email-body-content td,\n.email-body-content th {\n  word-break: break-word;\n  vertical-align: top;\n}\n\n.email-body-content a {\n  color: #2563eb;\n}\n\n.email-body-content p,\n.email-body-content div,\n.email-body-content li,\n.email-body-content span {\n  line-height: 1.55;\n}\n\n.email-body-content ul,\n.email-body-content ol {\n  padding-left: 24px;\n  margin-bottom: 1rem;\n}\n\n.email-body-content * {\n  max-width: 100%;\n}\n\n.email-body-content > * {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.email-body-content > table,\n.email-body-content > div,\n.email-body-content > section {\n  width: 100%;\n}\n.bo-tabs {\n  display: flex;\n  gap: 10px;\n  margin: 14px 0 22px;\n  border-bottom: 0;\n}\n.bo-tab {\n  flex: 1;\n  text-align: center;\n  padding: 11px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #64748b;\n  border: 1px solid #dbe7f5;\n  border-radius: 12px;\n  background: #ffffff;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n.bo-tab.active {\n  color: #1d4ed8;\n  border-color: #bfdbfe;\n  background: #eff6ff;\n  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);\n}\n.bo-tab.done {\n  color: #15803d;\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n.bo-channel-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  background: #fff;\n  font-size: 0;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.15s ease;\n}\n.bo-channel-btn::after {\n  content: \"Email\";\n  font-size: 13px;\n  line-height: 1;\n}\n.bo-channel-btn.wp::after {\n  content: \"WhatsApp\";\n}\n.bo-channel-btn.active {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #2563eb;\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.12);\n}\n.bo-channel-btn.active.wp {\n  border-color: #16a34a;\n  background: #f0fdf4;\n  color: #16a34a;\n  box-shadow: 0 6px 18px rgba(22, 163, 74, 0.12);\n}\n.bo-channel-btn svg {\n  font-size: 15px;\n  flex-shrink: 0;\n}\n.bo-channel-btn input {\n  flex-shrink: 0;\n}\n\n.bo-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n.bo-input {\n  width: 100%;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 11px 14px;\n  font-size: 14px;\n  background: #ffffff;\n  color: #0f172a;\n  outline: none;\n  transition: 0.15s ease;\n}\n.bo-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);\n}\n.bo-textarea {\n  resize: vertical;\n  min-height: 190px;\n  font-family: inherit;\n}\n.bo-input-subject {\n  min-height: 48px;\n  border-width: 1.5px;\n  font-weight: 600;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n}\n.bo-input-message {\n  min-height: 220px;\n  line-height: 1.65;\n  border-width: 1.5px;\n  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 100%);\n}\n.bo-input-subject::placeholder,\n.bo-input-message::placeholder {\n  color: #94a3b8;\n}\n.bo-review-list {\n  height: auto;\n  min-height: 0;\n  max-height: 320px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.bo-review-list::-webkit-scrollbar {\n  width: 8px;\n}\n.bo-review-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 999px;\n}\n.bo-review-list::-webkit-scrollbar-track {\n  background: #f8fafc;\n}\n.bo-panel {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n.bo-section-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.bo-section-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #2563eb;\n  box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.08);\n  flex-shrink: 0;\n}\n.bo-section-title {\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n  color: #0f172a;\n}\n.bo-section-subtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.bo-vars {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n.bo-var {\n  background: #f1f5f9;\n  color: #475569;\n  border-radius: 6px;\n  padding: 3px 10px;\n  font-size: 12px;\n  font-family: monospace;\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n  transition: 0.15s;\n}\n.bo-var:hover {\n  background: #e2e8f0;\n}\n\n.bo-hint {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #9a3412;\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  margin-top: 16px;\n}\n\n.bo-alert {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #1d4ed8;\n  margin-bottom: 18px;\n}\n\n.bo-info-row {\n  display: flex;\n  align-items: baseline;\n  padding: 6px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 14px;\n}\n.bo-info-row:last-child {\n  border: none;\n}\n.bo-info-label {\n  width: 110px;\n  color: #64748b;\n  font-size: 13px;\n  flex-shrink: 0;\n}\n\n.bo-card {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px 20px;\n  height: 300px;\n  overflow: auto;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n.bo-card-1 {\n  background: #ffffff;\n  border: 1px solid #d9e4f5;\n  border-radius: 18px;\n  padding: 18px 20px;\n  /* height: 300px; */\n  /* overflow: auto; */\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);\n}\n\n.bo-candidate-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n.bo-candidate-item:last-child {\n  border: none;\n}\n.bo-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.bo-check-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  font-size: 14px;\n  cursor: pointer;\n}\n.bo-check-row input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2563eb;\n  cursor: pointer;\n}\n\n.bo-btn-primary {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.15s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.2);\n}\n.bo-btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.24);\n}\n.bo-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.bo-btn-secondary {\n  background: #fff;\n  color: #374151;\n  border: 1px solid #d6deeb;\n  border-radius: 12px;\n  padding: 10px 22px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: 0.15s ease;\n}\n.bo-btn-secondary:hover {\n  background: #f8fafc;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n@media (max-width: 767px) {\n  .bo-tabs {\n    flex-direction: column;\n  }\n  .bo-modal .modal-body {\n    padding: 0 16px 14px;\n  }\n  .bo-modal .modal-footer {\n    padding: 16px;\n    flex-direction: column;\n    gap: 12px;\n  }\n  .bo-card,\n  .bo-card-1,\n  .bo-panel {\n    padding: 16px;\n  }\n}\n.cs-root {\n  min-height: 100vh;\n  background: #eef0f5;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 32px 16px 48px;\n    font-family: 'DM Sans', sans-serif;\n}\n\n.cs-card {\n  background: #fff;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 420px;\n    box-shadow: 0 8px 40px rgba(0,0,0,0.10);\n  overflow: hidden;\n}\n\n/* ── Header Banner ── */\n.cs-header {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 60%, #6366f1 100%);\n  padding: 28px 24px 32px;\n  position: relative;\n  overflow: hidden;\n}\n.cs-header::before {\n  content: \"\";\n  position: absolute;\n  top: -40px;\n  right: -40px;\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.07);\n}\n.cs-header::after {\n  content: \"\";\n  position: absolute;\n  bottom: -30px;\n  left: -20px;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.05);\n}\n.cs-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n.cs-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.cs-logo {\n  width: 40px;\n  height: 40px;\n  background: rgba(255, 255, 255, 0.18);\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n.cs-company-name {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n.cs-company-sub {\n  color: rgba(255, 255, 255, 0.65);\n  font-size: 11px;\n  font-weight: 400;\n}\n.cs-expires {\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n.cs-job-title {\n  font-family: \"Fraunces\", serif;\n  font-size: 26px;\n  font-weight: 900;\n  color: #fff;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n.cs-greeting {\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.cs-greeting strong {\n  color: #fff;\n  font-weight: 600;\n}\n\n/* ── Body ── */\n.cs-body {\n  padding: 24px;\n}\n\n/* Info grid */\n.cs-info-grid {\n  display: grid;\n  /* grid-template-columns: 2fr 2fr; */\n  gap: 10px;\n  margin-bottom: 22px;\n}\n.cs-info-box {\n  background: #f7f8fc;\n  border: 1px solid #ebebf0;\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n.cs-info-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  color: #9399a6;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.cs-info-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1d23;\n  line-height: 1.3;\n}\n\n/* Section label */\n.cs-section-label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #9399a6;\n  margin-bottom: 10px;\n}\n\n/* About the role */\n.cs-about {\n  margin-bottom: 22px;\n}\n.cs-about-text {\n  font-size: 13.5px;\n  color: #444b5a;\n  line-height: 1.65;\n  margin-bottom: 10px;\n}\n.cs-bullet {\n  font-size: 13px;\n  color: #555e6e;\n  line-height: 1.6;\n  padding-left: 14px;\n  position: relative;\n}\n.cs-bullet::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #7c3aed;\n  font-weight: 700;\n}\n\n/* Skills */\n.cs-skills {\n  margin-bottom: 22px;\n}\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.cs-skill-chip {\n  background: #f0f0f8;\n  border: 1px solid #ddddf5;\n  color: #3d3d8f;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 12px;\n  border-radius: 20px;\n}\n\n/* Interview process */\n.cs-process {\n  margin-bottom: 26px;\n}\n.cs-round {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 14px;\n  background: #f7f8fc;\n  border: 1px solid #ebebf0;\n  border-radius: 12px;\n  margin-bottom: 8px;\n}\n.cs-round:last-child {\n  margin-bottom: 0;\n}\n.cs-round-num {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid #7c3aed;\n  color: #7c3aed;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n.cs-round-title {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #1a1d23;\n  margin-bottom: 2px;\n}\n.cs-round-sub {\n  font-size: 12px;\n  color: #8b93a4;\n}\n\n/* Divider */\n.cs-divider {\n  border: none;\n  border-top: 1px solid #ebebf0;\n  margin: 6px 0 22px;\n}\n\n/* CTA section */\n.cs-cta-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #1a1d23;\n  text-align: center;\n  margin-bottom: 5px;\n}\n.cs-cta-sub {\n  font-size: 13px;\n  color: #9399a6;\n  text-align: center;\n  margin-bottom: 18px;\n}\n\n/* Response buttons */\n.cs-btn-interested {\n  width: 100%;\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  margin-bottom: 10px;\n  transition: all 0.18s ease;\n  text-align: left;\n}\n.cs-btn-interested:hover {\n  background: #dcfce7;\n  border-color: #4ade80;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.15);\n}\n.cs-btn-interested.selected {\n  background: #dcfce7;\n  border-color: #22c55e;\n}\n.cs-btn-decline {\n  width: 100%;\n  background: #fff;\n  border: 1.5px solid #fecaca;\n  border-radius: 14px;\n  padding: 14px 18px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  text-align: left;\n}\n.cs-btn-decline:hover {\n  background: #fef2f2;\n  border-color: #f87171;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.12);\n}\n.cs-btn-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n.cs-btn-icon.green {\n  background: #22c55e;\n}\n.cs-btn-icon.red {\n  background: #ef4444;\n}\n.cs-btn-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1d23;\n  margin-bottom: 2px;\n}\n.cs-btn-label.green {\n  color: #15803d;\n}\n.cs-btn-label.red {\n  color: #dc2626;\n}\n.cs-btn-sublabel {\n  font-size: 12px;\n  color: #8b93a4;\n}\n.cs-btn-arrow {\n  margin-left: auto;\n  color: #22c55e;\n  font-size: 18px;\n  font-weight: 300;\n}\n\n/* Schedule slot picker */\n.cs-schedule-box {\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 16px;\n  margin-bottom: 10px;\n  animation: fadeSlideIn 0.25s ease;\n}\n@keyframes fadeSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.cs-schedule-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.cs-schedule-icon {\n  width: 28px;\n  height: 28px;\n  background: #22c55e;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n}\n.cs-schedule-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #15803d;\n}\n.cs-schedule-sub {\n  font-size: 12px;\n  color: #4ade80;\n}\n.cs-slot-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.cs-slot-field label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #6b7280;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.cs-slot-field input {\n  width: 100%;\n  padding: 9px 12px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 13px;\n  font-family: \"DM Sans\", sans-serif;\n  color: #1a1d23;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.15s;\n}\n.cs-slot-field input:focus {\n  border-color: #7c3aed;\n  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);\n}\n.cs-slot-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.cs-back-btn {\n  background: #fff;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n.cs-back-btn:hover {\n  background: #f9fafb;\n}\n.cs-confirm-btn {\n  flex: 1;\n  background: linear-gradient(135deg, #6366f1, #7c3aed);\n  border: none;\n  border-radius: 10px;\n  padding: 11px 18px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.18s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-shadow: 0 3px 12px rgba(124, 58, 237, 0.35);\n}\n.cs-confirm-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(124, 58, 237, 0.4);\n}\n.cs-confirm-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n.cs-slot-error {\n  font-size: 12px;\n  color: #f59e0b;\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Declined state */\n.cs-declined-box {\n  background: #fef2f2;\n  border: 1.5px solid #fecaca;\n  border-radius: 14px;\n  padding: 16px;\n  text-align: center;\n  animation: fadeSlideIn 0.25s ease;\n}\n.cs-declined-icon {\n  font-size: 28px;\n  margin-bottom: 8px;\n}\n.cs-declined-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #dc2626;\n  margin-bottom: 4px;\n}\n.cs-declined-sub {\n  font-size: 13px;\n  color: #9399a6;\n}\n\n/* Confirmed state */\n.cs-confirmed-box {\n  background: #f0fdf4;\n  border: 1.5px solid #86efac;\n  border-radius: 14px;\n  padding: 20px;\n  text-align: center;\n  animation: fadeSlideIn 0.25s ease;\n}\n.cs-confirmed-icon {\n  font-size: 36px;\n  margin-bottom: 10px;\n}\n.cs-confirmed-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #15803d;\n  margin-bottom: 4px;\n}\n.cs-confirmed-sub {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n/* Privacy note */\n.cs-privacy {\n  text-align: center;\n  font-size: 12px;\n  color: #9399a6;\n  margin-top: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n/* Footer */\n.cs-footer {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 12px;\n  color: #9399a6;\n}\n.cs-footer a {\n  color: #6366f1;\n  font-weight: 600;\n  text-decoration: none;\n}\n.cs-root {\n  min-height: 100vh;\n  background: linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px 40px;\n  font-family: \"Segoe UI\", sans-serif;\n}\n.cs-card {\n  width: 100%;\n  max-width: 820px;\n  background: #fff;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 16px 50px rgba(15, 23, 42, 0.12);\n}\n.cs-header {\n  padding: 20px 20px 10px 20px;\n  background: linear-gradient(135deg, #0f766e 0%, #155e75 100%);\n  color: #fff;\n}\n.cs-kicker {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.8;\n  margin-bottom: 8px;\n}\n.cs-company-name {\n  font-size: 15px;\n  font-weight: 600;\n  opacity: 0.92;\n  margin-bottom: 8px;\n}\n.cs-job-title {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 10px;\n}\n.cs-greeting {\n  font-size: 14px;\n  line-height: 1.6;\n  opacity: 0.95;\n  max-width: 680px;\n}\n.cs-body {\n  padding: 28px;\n}\n.cs-info-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n.cs-info-box {\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n}\n.cs-info-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n.cs-info-value {\n  font-size: 14px;\n  color: #0f172a;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.cs-section {\n  margin-bottom: 24px;\n}\n.cs-section-label {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n  margin-bottom: 12px;\n}\n.cs-about-text {\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.7;\n  margin: 0 0 10px;\n}\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.cs-skill-chip {\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: #ecfeff;\n  border: 1px solid #a5f3fc;\n  color: #155e75;\n  font-size: 13px;\n  font-weight: 600;\n}\n.cs-divider {\n  border: 0;\n  border-top: 1px solid #e2e8f0;\n  margin: 24px 0;\n}\n.cs-cta-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 6px;\n}\n.cs-cta-sub {\n  text-align: center;\n  color: #64748b;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n.cs-btn-interested,\n.cs-btn-decline {\n  width: 100%;\n  border-radius: 16px;\n  padding: 16px 18px;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: 0.2s ease;\n}\n.cs-btn-interested {\n  border: 1px solid #86efac;\n  background: #f0fdf4;\n  margin-bottom: 12px;\n}\n.cs-btn-decline {\n  border: 1px solid #fecaca;\n  background: #fff7f7;\n}\n.cs-btn-interested.selected {\n  background: #dcfce7;\n}\n.cs-btn-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.cs-btn-icon.green {\n  background: #16a34a;\n}\n.cs-btn-icon.red {\n  background: #dc2626;\n}\n.cs-btn-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n.cs-btn-sublabel {\n  font-size: 13px;\n  color: #64748b;\n}\n.cs-btn-arrow {\n  margin-left: auto;\n  color: #16a34a;\n  font-size: 20px;\n}\n.cs-schedule-box,\n.cs-declined-box,\n.cs-confirmed-box {\n  border-radius: 16px;\n  padding: 18px;\n}\n.cs-schedule-box {\n  background: #f8fafc;\n  border: 1px solid #cbd5e1;\n}\n.cs-slot-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n.cs-slot-field label {\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n  margin-bottom: 6px;\n}\n.cs-slot-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid #cbd5e1;\n  font-size: 14px;\n}\n.cs-slot-actions {\n  display: flex;\n  gap: 10px;\n}\n.cs-back-btn,\n.cs-confirm-btn {\n  border-radius: 10px;\n  padding: 11px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.cs-back-btn {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n.cs-confirm-btn {\n  border: 0;\n  background: #0f766e;\n  color: #fff;\n  flex: 1;\n}\n\n#TemplateForJobOpportunity .btn-success {\n  border: 0;\n  background: #0f766e !important;\n  color: #fff;\n}\n\n.cs-slot-error {\n  margin-top: 10px;\n  color: #b45309;\n  font-size: 13px;\n  font-weight: 600;\n}\n.cs-declined-box {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  text-align: center;\n}\n.cs-confirmed-box {\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  text-align: center;\n}\n.cs-state-title {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.cs-state-sub {\n  font-size: 14px;\n  color: #475569;\n  line-height: 1.6;\n}\n.cs-privacy {\n  text-align: center;\n  margin-top: 18px;\n  color: #64748b;\n  font-size: 13px;\n}\n.cs-footer {\n  margin-top: 16px;\n  color: #64748b;\n  font-size: 12px;\n  text-align: center;\n}\n@media (max-width: 640px) {\n  .cs-header,\n  .cs-body {\n    padding: 20px;\n  }\n  .cs-job-title {\n    font-size: 26px;\n  }\n  .cs-info-grid,\n  .cs-slot-row {\n    grid-template-columns: 1fr;\n  }\n}\n.bo-input {\n  padding: 6px 30px 6px 10px; /* space for arrow */\n  appearance: none; /* remove default arrow */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: #fff;\n  border: 1px solid #d4dce7;\n  border-radius: 6px;\n  font-size: 14px;\n  height: 36px;\n  /* background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='14' viewBox='0 0 20 20' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M5.516 7.548a.625.625 0 0 1 .884 0L10 11.148l3.6-3.6a.625.625 0 1 1 .884.884l-4.042 4.041a.625.625 0 0 1-.884 0L5.516 8.432a.625.625 0 0 1 0-.884z'/></svg>\"); */\n  background-repeat: no-repeat;\n  background-position: right 10px center; /* arrow aligned */\n  cursor: pointer;\n}\n.react-select__menu {\n  z-index: 99999 !important;\n}\n\n.react-select__menu-list {\n  z-index: 99999 !important;\n}\n/* Recruiter Report */\n.recruiter-report-page {\n  padding: 16px 12px 28px;\n  background: radial-gradient(\n      circle at top right,\n      rgba(59, 130, 246, 0.08),\n      transparent 22%\n    ),\n    linear-gradient(180deg, #f6f9fc 0%, #eef4fb 100%);\n  min-height: calc(100vh - 110px);\n}\n\n.recruiter-report-hero {\n  background: radial-gradient(\n      circle at top left,\n      rgba(255, 255, 255, 0.22),\n      transparent 18%\n    ),\n    linear-gradient(135deg, #163b8c 0%, #155e75 45%, #0f172a 100%);\n  border-radius: 28px;\n  padding: 22px 24px;\n  color: #fff;\n  margin-bottom: 18px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.18);\n}\n\n.recruiter-report-hero-copy {\n  flex: 1 1 560px;\n}\n\n.recruiter-report-eyebrow {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  opacity: 0.78;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.recruiter-report-title {\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1.05;\n}\n\n.recruiter-report-subtitle {\n  font-size: 14px;\n  opacity: 0.92;\n  line-height: 1.55;\n  max-width: 760px;\n}\n\n.recruiter-report-company-card {\n  min-width: 250px;\n  max-width: 300px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 20px;\n  padding: 12px;\n  backdrop-filter: blur(10px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.recruiter-report-company-label {\n  font-size: 11px;\n  margin-bottom: 6px;\n  display: block;\n  opacity: 0.92;\n  font-weight: 700;\n}\n\n.recruiter-report-loading,\n.recruiter-report-error {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #dbe7f5;\n  border-radius: 22px;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-report-loading {\n  padding: 40px 18px;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.recruiter-report-loading-text {\n  margin-top: 12px;\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.recruiter-report-error {\n  color: #be123c;\n  padding: 16px;\n}\n\n.recruiter-report-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.recruiter-summary-card {\n  border-radius: 22px;\n  padding: 18px 16px;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.05);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.recruiter-summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);\n}\n\n.recruiter-summary-card-inner {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.recruiter-summary-value {\n  font-size: 30px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.recruiter-summary-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  margin-top: 8px;\n}\n\n.recruiter-summary-accent {\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n}\n\n.recruiter-panel,\n.recruiter-breakdown-panel {\n  background: rgba(255, 255, 255, 0.92);\n  border: 1px solid #dbe7f5;\n  border-radius: 24px;\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-panel {\n  padding: 18px;\n  height: 100%;\n}\n\n.recruiter-panel-header,\n.recruiter-breakdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recruiter-panel-header {\n  margin-bottom: 16px;\n}\n\n.recruiter-panel-title {\n  font-size: 17px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-panel-kicker,\n.recruiter-breakdown-count {\n  font-size: 11px;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.recruiter-snapshot-list,\n.recruiter-metrics-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-snapshot-card {\n  display: grid;\n  grid-template-columns: 48px 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: 16px 18px;\n  border-radius: 20px;\n  border: 1px solid #e5edf8;\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.03);\n}\n\n.recruiter-avatar,\n.recruiter-table-avatar {\n  background: linear-gradient(135deg, #2563eb 0%, #0f766e 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.recruiter-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n\n.recruiter-snapshot-name {\n  font-size: 15px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-snapshot-meta {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 3px;\n}\n\n.recruiter-progress-track,\n.recruiter-table-bartrack {\n  margin-top: 9px;\n  height: 6px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.recruiter-progress-bar {\n  height: 100%;\n  border-radius: 999px;\n}\n\n.recruiter-snapshot-side {\n  text-align: right;\n}\n\n.recruiter-snapshot-score {\n  font-size: 20px;\n  font-weight: 800;\n  color: #2563eb;\n  line-height: 1;\n}\n\n.recruiter-snapshot-side-label,\n.recruiter-table-subtext,\n.recruiter-breakdown-subtitle,\n.recruiter-empty-state {\n  font-size: 10px;\n  color: #64748b;\n}\n\n.recruiter-snapshot-side-label {\n  margin-top: 4px;\n}\n\n.recruiter-metric-card {\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);\n  border: 1px solid #e5edf8;\n  border-radius: 16px;\n  padding: 14px 15px;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.02);\n}\n\n.recruiter-metric-title {\n  font-size: 12px;\n  font-weight: 800;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.recruiter-metric-desc {\n  font-size: 12px;\n  color: #475569;\n}\n\n.recruiter-breakdown-panel {\n  overflow: hidden;\n}\n\n.recruiter-breakdown-header {\n  padding: 18px;\n  border-bottom: 1px solid #e5edf8;\n}\n\n.recruiter-breakdown-subtitle {\n  margin-top: 4px;\n}\n\n.recruiter-breakdown-table-wrap {\n  overflow-x: auto;\n}\n\n.recruiter-breakdown-table {\n  width: 100%;\n}\n\n.recruiter-breakdown-table thead {\n  background: #f8fbff;\n}\n\n.recruiter-breakdown-table th {\n  padding: 14px 16px;\n  text-align: left;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: #64748b;\n  border-bottom: 1px solid #e5edf8;\n  white-space: nowrap;\n}\n\n.recruiter-breakdown-table tbody tr.is-alt td {\n  background: #fcfdff !important;\n}\n\n.recruiter-table-person {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.recruiter-table-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  font-size: 13px;\n}\n\n.recruiter-table-name {\n  color: #0f172a;\n  font-weight: 200;\n}\n\n.recruiter-table-barcell {\n  min-width: 90px;\n}\n\n.recruiter-table-barvalue {\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.recruiter-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 38px;\n  padding: 5px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.recruiter-chip-warn {\n  color: #b45309;\n  background: #fff7ed;\n}\n\n.recruiter-chip-pink {\n  color: #be185d;\n  background: #fdf2f8;\n}\n\n.recruiter-chip-blue {\n  color: #1d4ed8;\n  background: #eff6ff;\n}\n\n.recruiter-chip-teal {\n  color: #0f766e;\n  background: #ecfeff;\n}\n\n.recruiter-chip-green {\n  color: #15803d;\n  background: #f0fdf4;\n}\n\n.recruiter-empty-table {\n  padding: 24px;\n  text-align: center;\n  color: #64748b;\n}\n\n@media (max-width: 991px) {\n  .recruiter-report-hero {\n    border-radius: 22px;\n    padding: 18px 16px;\n  }\n\n  .recruiter-report-title {\n    font-size: 26px;\n  }\n\n  .recruiter-report-company-card {\n    width: 100%;\n    max-width: none;\n  }\n\n  .recruiter-panel,\n  .recruiter-breakdown-panel {\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 640px) {\n  .recruiter-report-page {\n    padding: 12px 6px 24px;\n  }\n\n  .recruiter-report-title {\n    font-size: 22px;\n  }\n\n  .recruiter-summary-card,\n  .recruiter-panel {\n    border-radius: 18px;\n  }\n\n  .recruiter-snapshot-card {\n    grid-template-columns: 44px 1fr;\n  }\n\n  .recruiter-snapshot-side {\n    grid-column: 2;\n    text-align: left;\n  }\n}\n\n/* Recruiter Report Refinements */\n.recruiter-report-page {\n  padding: 14px 14px 28px;\n  background: radial-gradient(\n      circle at top left,\n      rgba(14, 165, 233, 0.08),\n      transparent 24%\n    ),\n    radial-gradient(\n      circle at right 20%,\n      rgba(37, 99, 235, 0.07),\n      transparent 18%\n    ),\n    linear-gradient(180deg, #f8fbff 0%, #eef4fb 100%);\n}\n\n.recruiter-report-hero {\n  position: relative;\n  overflow: hidden;\n  /* min-height: 152px; */\n  margin-bottom: 14px;\n  padding: 20px 22px 16px;\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.12);\n}\n\n.recruiter-report-hero-copy,\n.recruiter-report-company-card {\n  position: relative;\n  z-index: 2;\n}\n\n.recruiter-report-hero-copy {\n  max-width: 820px;\n}\n\n.recruiter-report-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  letter-spacing: 0.16em;\n}\n\n.recruiter-report-title {\n  margin-top: 12px;\n  margin-bottom: 6px !important;\n  font-size: 28px;\n  line-height: 1.1;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.recruiter-report-subtitle {\n  max-width: 720px;\n  font-size: 13px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.recruiter-report-hero-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.recruiter-report-hero-pill {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 118px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: rgba(255, 255, 255, 0.84);\n  backdrop-filter: blur(10px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.recruiter-report-hero-pill-highlight {\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.14) 0%,\n    rgba(59, 130, 246, 0.18) 100%\n  );\n}\n\n.recruiter-report-hero-pill-value {\n  font-size: 15px;\n  font-weight: 800;\n  line-height: 1.1;\n  color: #ffffff;\n}\n\n.recruiter-report-company-card {\n  min-width: 260px;\n  max-width: 290px;\n  padding: 14px;\n  border-radius: 18px;\n  background: rgba(15, 23, 42, 0.28);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(12px);\n}\n\n.recruiter-report-company-label {\n  margin-bottom: 4px;\n  color: rgba(255, 255, 255, 0.68);\n}\n\n.recruiter-report-company-title {\n  margin-bottom: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.recruiter-report-company-footnote {\n  margin-top: 10px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.74);\n}\n\n.recruiter-report-company-card .form-select,\n.recruiter-report-company-card select,\n.recruiter-report-company-card .form-control {\n  min-height: 46px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  box-shadow: none;\n}\n\n.recruiter-report-filter-bar {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(220px, 1.2fr) repeat(\n      2,\n      minmax(160px, 0.8fr)\n    ) auto;\n  gap: 12px;\n  align-items: end;\n  margin-bottom: 14px;\n  padding: 14px 16px;\n  border-radius: 20px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);\n}\n\n.recruiter-report-filter-summary {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 90px;\n  padding: 12px 14px;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #f8fbff 0%, #f2f7fd 100%);\n  border: 1px solid #dbe7f3;\n}\n\n.recruiter-report-filter-summary-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-report-filter-summary-value {\n  margin-top: 5px;\n  font-size: 20px;\n  line-height: 1.15;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-report-filter-summary-meta {\n  margin-top: 6px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.recruiter-report-filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.recruiter-report-filter-group-wide {\n  min-width: 0;\n}\n\n.recruiter-report-filter-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-report-filter-input {\n  min-height: 40px;\n  border-radius: 12px;\n  border: 1px solid #d7e3f1;\n  background: #f8fbff;\n  color: #0f172a;\n  box-shadow: none;\n}\n\n.recruiter-report-filter-input:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.18);\n  background: #ffffff;\n}\n\n.recruiter-report-filter-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.recruiter-report-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 8px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-report-filter-chip-soft {\n  background: #f8fafc;\n  color: #475569;\n}\n\n.recruiter-report-filter-reset {\n  min-height: 38px;\n  padding: 8px 14px;\n  border-radius: 12px;\n  border: 1px solid #d7e3f1;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-report-filter-reset:hover {\n  background: #f8fbff;\n  border-color: #bfd3ea;\n}\n\n.recruiter-report-hero-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(2px);\n  opacity: 0.55;\n}\n\n.recruiter-report-hero-orb-one {\n  top: -40px;\n  right: 220px;\n  width: 160px;\n  height: 160px;\n  background: radial-gradient(\n    circle,\n    rgba(14, 165, 233, 0.42) 0%,\n    rgba(14, 165, 233, 0) 72%\n  );\n}\n\n.recruiter-report-hero-orb-two {\n  right: -20px;\n  bottom: -36px;\n  width: 220px;\n  height: 220px;\n  background: radial-gradient(\n    circle,\n    rgba(37, 99, 235, 0.34) 0%,\n    rgba(37, 99, 235, 0) 72%\n  );\n}\n\n.recruiter-report-loading,\n.recruiter-report-error {\n  min-height: 180px;\n  border-radius: 22px;\n  border: 1px solid #dce8f5;\n  background: linear-gradient(\n    135deg,\n    rgba(255, 255, 255, 0.96) 0%,\n    rgba(246, 250, 255, 0.98) 100%\n  );\n  box-shadow: 0 18px 38px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-report-loading {\n  gap: 14px;\n}\n\n.recruiter-report-loading-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: #47617d;\n}\n\n.recruiter-report-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin-bottom: 14px;\n}\n\n.recruiter-summary-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);\n}\n\n.recruiter-summary-card::after {\n  content: \"\";\n  position: absolute;\n  inset: auto -18px -18px auto;\n  width: 88px;\n  height: 88px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.recruiter-summary-card-inner {\n  position: relative;\n  z-index: 1;\n  min-height: 74px;\n}\n\n.recruiter-summary-value {\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.recruiter-summary-label {\n  margin-top: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #47617d;\n}\n\n.recruiter-summary-accent {\n  width: 38px;\n  height: 38px;\n  border-radius: 14px;\n}\n\n.recruiter-insight-strip {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n.recruiter-insight-item {\n  padding: 14px 16px;\n  border-radius: 18px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\n}\n\n.recruiter-insight-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-insight-value {\n  margin-top: 8px;\n  font-size: 20px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-insight-value-small {\n  font-size: 15px;\n}\n\n.recruiter-panel,\n.recruiter-breakdown-panel {\n  border-radius: 20px;\n  border: 1px solid #dbe7f3;\n  background: rgba(255, 255, 255, 0.94);\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);\n  backdrop-filter: blur(12px);\n}\n\n.recruiter-panel-header,\n.recruiter-breakdown-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px 12px;\n}\n\n.recruiter-panel-title {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.recruiter-panel-subtitle,\n.recruiter-breakdown-subtitle {\n  margin-top: 4px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #64748b;\n}\n\n.recruiter-panel-kicker,\n.recruiter-breakdown-count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.recruiter-snapshot-list,\n.recruiter-metrics-list {\n  padding: 0 18px 18px;\n}\n\n.recruiter-snapshot-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-snapshot-card {\n  position: relative;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 14px;\n  align-items: center;\n  padding: 14px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.05);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.recruiter-rank-badge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: #e8f1ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.recruiter-snapshot-main {\n  min-width: 0;\n}\n\n.recruiter-snapshot-card:hover,\n.recruiter-metric-card:hover,\n.recruiter-summary-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.1);\n}\n\n.recruiter-avatar,\n.recruiter-table-avatar {\n  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.22);\n}\n\n.recruiter-progress-track,\n.recruiter-table-bartrack {\n  height: 8px;\n  background: #e8eef7;\n}\n\n.recruiter-snapshot-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.recruiter-inline-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.recruiter-inline-chip-violet {\n  background: #f5f3ff;\n  color: #7c3aed;\n}\n\n.recruiter-inline-chip-blue {\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.recruiter-snapshot-score {\n  font-size: 26px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-snapshot-side {\n  min-width: 110px;\n  text-align: right;\n}\n\n.recruiter-snapshot-side-label {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.recruiter-metrics-list {\n  display: grid;\n  gap: 12px;\n}\n\n.recruiter-metrics-list-tight {\n  gap: 10px;\n}\n\n.recruiter-scope-card {\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid #dbe7f3;\n  background: linear-gradient(180deg, #fbfdff 0%, #f5f9ff 100%);\n}\n\n.recruiter-scope-title {\n  font-size: 13px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.recruiter-scope-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.recruiter-scope-k {\n  display: block;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.recruiter-scope-v {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.recruiter-metric-card {\n  position: relative;\n  overflow: hidden;\n  padding: 12px 14px 12px;\n  border-radius: 14px;\n}\n\n.recruiter-metric-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(180deg, #2563eb 0%, #0f766e 100%);\n}\n\n.recruiter-breakdown-header {\n  padding-bottom: 18px;\n}\n\n.recruiter-breakdown-table thead {\n  background: linear-gradient(180deg, #f8fbff 0%, #f1f6fd 100%);\n}\n\n.recruiter-breakdown-table th {\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n}\n\n.recruiter-breakdown-table td {\n  font-size: 13px;\n}\n\n.recruiter-breakdown-table tbody td {\n  vertical-align: middle;\n}\n\n.recruiter-breakdown-table tbody tr:hover td {\n  background: #f8fbff !important;\n}\n\n.recruiter-chip {\n  min-width: 44px;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.42);\n}\n\n.recruiter-detail-modal .modal-content {\n  overflow: hidden;\n  border: 1px solid rgba(191, 219, 254, 0.8);\n  border-radius: 24px;\n  background: radial-gradient(\n      circle at top right,\n      rgba(59, 130, 246, 0.12),\n      transparent 28%\n    ),\n    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.22);\n}\n\n.recruiter-detail-modal .modal-dialog {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.recruiter-detail-modal-header {\n  position: relative;\n  padding: 22px 24px 14px !important;\n  background: linear-gradient(135deg, #eff6ff 0%, #f8fafc 56%, #f0fdf4 100%);\n  border-bottom: 1px solid rgba(203, 213, 225, 0.72) !important;\n}\n\n.recruiter-detail-modal-header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding-right: 64px;\n}\n\n.recruiter-detail-modal-header::after {\n  content: \"\";\n  position: absolute;\n  inset: auto 24px 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    rgba(37, 99, 235, 0.2),\n    rgba(16, 185, 129, 0.16)\n  );\n}\n\n.recruiter-detail-modal-heading {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.recruiter-detail-modal-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n}\n\n.recruiter-detail-modal-title {\n  font-size: 1.12rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n.recruiter-detail-modal-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n  font-size: 0;\n  color: #64748b;\n}\n\n.recruiter-detail-modal-meta > span {\n  font-size: 0.9rem;\n}\n\n.recruiter-detail-modal-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 999px;\n  background: #94a3b8;\n}\n\n.recruiter-detail-modal-count {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(37, 99, 235, 0.08);\n  color: #1d4ed8;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.recruiter-detail-modal .btn-close {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 34px;\n  height: 34px;\n  margin: 0 !important;\n  border-radius: 999px;\n  background-color: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);\n  opacity: 1;\n  transition: transform 0.18s ease, box-shadow 0.18s ease,\n    background-color 0.18s ease;\n}\n\n.recruiter-detail-modal .btn-close:hover {\n  transform: rotate(90deg);\n  background-color: #ffffff;\n  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);\n}\n\n.recruiter-detail-modal-export {\n  min-height: 42px;\n  padding: 10px 16px;\n  border: 1px solid rgba(37, 99, 235, 0.18);\n  border-radius: 12px;\n  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);\n  color: #fff;\n  font-size: 0.9rem;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  box-shadow: 0 10px 24px rgba(29, 78, 216, 0.22);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.recruiter-detail-modal-export:hover {\n  color: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 14px 28px rgba(29, 78, 216, 0.28);\n}\n\n.recruiter-detail-modal-export:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.recruiter-detail-modal-body {\n  padding: 18px 24px 24px !important;\n  max-height: 68vh;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.7) transparent;\n}\n\n.recruiter-detail-modal-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.recruiter-detail-modal-body::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.65);\n  background-clip: padding-box;\n}\n\n.recruiter-detail-modal-table-wrap {\n  overflow: hidden;\n  border: 1px solid #dbe7f3;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.recruiter-detail-modal-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: linear-gradient(180deg, #eff6ff 0%, #f8fbff 100%);\n  white-space: nowrap;\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: #334155;\n  border-bottom: 1px solid #dbeafe;\n  border-right: 1px solid #e2e8f0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.recruiter-detail-modal-table tbody td {\n  border-color: #edf2f7;\n  transition: background-color 0.18s ease;\n}\n\n.recruiter-detail-modal-table tbody tr:nth-child(even) td {\n  background: rgba(248, 251, 255, 0.72);\n}\n\n.recruiter-detail-modal-table tbody tr:hover td {\n  background: #eff6ff;\n}\n\n.recruiter-detail-modal-empty {\n  padding: 42px 20px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fbff 100%);\n  text-align: center;\n  color: #64748b;\n  font-weight: 600;\n}\n\n@media (max-width: 991px) {\n  .recruiter-report-page {\n    padding: 16px 10px 28px;\n  }\n\n  .recruiter-report-filter-bar {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .recruiter-report-filter-summary {\n    grid-column: 1 / -1;\n  }\n\n  .recruiter-report-filter-actions {\n    grid-column: 1 / -1;\n    justify-content: flex-start;\n  }\n\n  .recruiter-report-hero {\n    min-height: auto;\n    padding: 20px 18px 18px;\n  }\n\n  .recruiter-report-title {\n    font-size: 28px;\n  }\n\n  .recruiter-report-hero-meta {\n    gap: 10px;\n  }\n\n  .recruiter-report-hero-pill {\n    min-width: calc(50% - 10px);\n  }\n\n  .recruiter-insight-strip {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .recruiter-detail-modal-body {\n    padding: 16px 16px 18px !important;\n  }\n\n  .recruiter-detail-modal-header-row {\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: 56px;\n  }\n\n  .recruiter-detail-modal-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 640px) {\n  .recruiter-report-page {\n    padding: 12px 4px 24px;\n  }\n\n  .recruiter-report-hero {\n    border-radius: 24px;\n    padding: 18px 14px 16px;\n  }\n\n  .recruiter-report-title {\n    font-size: 24px;\n  }\n\n  .recruiter-report-subtitle {\n    font-size: 13px;\n  }\n\n  .recruiter-report-hero-pill,\n  .recruiter-report-company-card {\n    width: 100%;\n    max-width: none;\n  }\n\n  .recruiter-report-filter-bar {\n    grid-template-columns: 1fr;\n    padding: 12px;\n  }\n\n  .recruiter-insight-strip,\n  .recruiter-scope-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .recruiter-panel-header,\n  .recruiter-breakdown-header,\n  .recruiter-snapshot-list,\n  .recruiter-metrics-list {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n\n  .recruiter-snapshot-card {\n    grid-template-columns: 1fr;\n  }\n\n  .recruiter-snapshot-side {\n    text-align: left;\n  }\n\n  .recruiter-rank-badge {\n    position: static;\n    width: fit-content;\n    margin-bottom: 8px;\n  }\n\n  .recruiter-detail-modal .modal-content {\n    border-radius: 18px;\n  }\n\n  .recruiter-detail-modal-header {\n    padding: 18px 16px 12px !important;\n  }\n\n  .recruiter-detail-modal-heading {\n    width: 100%;\n  }\n\n  .recruiter-detail-modal-title {\n    font-size: 1rem;\n  }\n\n  .recruiter-detail-modal-meta {\n    gap: 8px;\n    font-size: 0.82rem;\n  }\n\n  .recruiter-detail-modal .btn-close {\n    top: 14px;\n    right: 14px;\n  }\n}\n.recruiter-report-filter-summary-value {\n  min-height: 22px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.ModalStickyTabs {\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n}\n\n.activeBorder {\n  border-bottom: 3px solid #2563eb !important;\n}\n\n.inActiveBorder {\n  border: 1px solid #dbe7f3 !important;\n}\n.addCandidateBtn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n\n  border: none;\n  background: transparent;\n\n  color: #1976d2;\n  font-size: 14px;\n  font-weight: 600;\n\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n\n  transition: all 0.2s ease;\n}\n\n.addCandidateBtn:hover {\n  background-color: rgba(25, 118, 210, 0.08);\n}\n\n.addCandidateHeaderBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  border: none;\n  background: transparent;\n  color: inherit;\n}\n.manager-pipeline-panel .p-card-body,\n.manager-pipeline-panel .p-card-content {\n  overflow: hidden !important;\n  padding: 12px !important;\n  height: 100%;\n  box-sizing: border-box;\n}\n.candidate-modal .modal-content {\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n}\n.candidate-modal .modal-body {\n  overflow: hidden;\n}\n.candidate-modal .modal-dialog {\n  display: flex;\n  align-items: center;\n  min-height: 100vh;\n  margin: 0 auto;\n}\n.candidate-modal .modal-content {\n  height: 85vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 12px;\n}\n#ExpandBtn {\n  position: absolute;\n  right: 40px;\n  top: 10px;\n  z-index: 1050;\n}\n\n/* .CreateJobOrderFooter {\n  position: absolute;\n  top:80px;\n  right: 0;\n  z-index: 1050;\n  background: red;\n  width: 100px;\n} */\n.cs-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.cs-tabs button {\n  padding: 8px 14px;\n  border: 1px solid #ddd;\n  background: #f8fafc;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.cs-tabs button.active {\n  background: #103d63;\n  color: #fff;\n  border-color: #103d63;\n  border-radius: 40px;\n}\n/* Full screen blur background */\n#global-loader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(8px);\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n/* Center content */\n.loader-content {\n  text-align: center;\n  color: #fff;\n  font-family: Arial, sans-serif;\n}\n\n/* Spinner */\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid #ccc;\n  border-top: 5px solid #00bcd4;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 10px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* .calendar-container {\n  display: flex;\n  height: 500px;\n}\n\n.calendar-left {\n  width: 40%;\n  padding: 20px;\n  border-right: 1px solid #eee;\n}\n\n.calendar-right {\n  width: 60%;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.slots {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.slot-btn {\n  border: 1px solid #0d6efd;\n  background: white;\n  color: #0d6efd;\n  padding: 10px;\n  border-radius: 6px;\n  text-align: center;\n  font-weight: 500;\n}\n\n.slot-btn:hover {\n  background: #e7f1ff;\n}\n\n.slot-btn.active {\n  background: #0d6efd;\n  color: white;\n} */\n\n.cs-root {\n  min-height: 100vh;\n  background: #f0f4f8;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 16px 40px;\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    sans-serif;\n}\n\n.cs-card {\n  width: 100%;\n  max-width: 640px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n}\n\n.cs-header {\n  background: linear-gradient(135deg, #103d63 0%, #1a5a90 100%);\n  padding: 24px 24px 20px;\n}\n\n.cs-kicker {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  padding: 4px 10px;\n  border-radius: 20px;\n}\n\n.cs-body {\n  padding: 20px 20px 24px;\n}\n\n@media (min-width: 480px) {\n  .cs-body {\n    padding: 24px 28px 28px;\n  }\n  .cs-header {\n    padding: 20px 28px 6px;\n  }\n}\n\n.cs-section {\n  margin-bottom: 16px;\n}\n\n.cs-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #3e4b5f;\n  margin-bottom: 6px;\n}\n\n.cs-about-text {\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.65;\n  margin: 0 0 6px;\n}\n\n.cs-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 14px;\n  border-bottom: 2px solid #f1f5f9;\n  padding-bottom: 0;\n}\n\n.cs-tabs button {\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 0;\n  transition: color 0.15s, border-color 0.15s;\n  white-space: nowrap;\n}\n\n.cs-tabs button.active {\n  border-bottom-color: #103d63;\n}\n\n.cs-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n@media (min-width: 480px) {\n  .cs-info-grid {\n    /* grid-template-columns: repeat(4, 1fr); gap: 12px; */\n  }\n}\n\n.cs-info-box {\n  background: #f8fafc;\n  border: 1px solid #e9eef4;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.cs-info-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #94a3b8;\n  margin-bottom: 3px;\n}\n\n.cs-info-value {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  word-break: break-word;\n}\n\n.cs-skills-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.cs-skill-chip {\n  background: #e8f4fd;\n  color: #0e5fa3;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 20px;\n  white-space: nowrap;\n}\n\n.cs-divider {\n  border: none;\n  border-top: 1px solid #f1f5f9;\n  margin: 16px 0;\n}\n\n.cs-cta-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.cs-cta-sub {\n  font-size: 13px;\n  color: #64748b;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.cs-btn-interested,\n.cs-btn-decline {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1.5px solid;\n  cursor: pointer;\n  transition: transform 0.1s, box-shadow 0.1s;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #fff;\n}\n\n.cs-btn-interested {\n  border-color: #22c55e;\n}\n.cs-btn-interested:hover {\n  background: #f0fdf4;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);\n}\n\n.cs-btn-decline {\n  border-color: #f87171;\n}\n.cs-btn-decline:hover {\n  background: #fff5f5;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(248, 113, 113, 0.15);\n}\n\n.cs-btn-icon {\n  width: 38px;\n  height: 38px;\n  min-width: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n.cs-btn-icon.green {\n  background: #22c55e;\n}\n.cs-btn-icon.red {\n  background: #f87171;\n}\n\n.cs-btn-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n.cs-btn-sublabel {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 2px;\n}\n\n.cs-btn-arrow {\n  margin-left: auto;\n  font-size: 22px;\n  color: #cbd5e1;\n}\n\n.cs-declined-box,\n.cs-confirmed-box {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 18px;\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.cs-state-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #103d63;\n  margin-bottom: 6px;\n}\n\n.cs-state-sub {\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.5;\n}\n\n.cs-privacy {\n  font-size: 11px;\n  color: #cbd5e1;\n  text-align: center;\n  margin-top: 12px;\n}\n\n.cs-footer {\n  margin-top: 20px;\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n/* ── Schedule Modal ── */\n.sched-modal .modal-dialog {\n  margin: 0 auto;\n  max-width: 860px;\n  width: 100%;\n}\n\n@media (max-width: 767px) {\n  .sched-modal .modal-dialog {\n    margin: 0;\n    max-width: 100%;\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n  .sched-modal .modal-content {\n    border-radius: 20px 20px 0 0 !important;\n    max-height: 92vh;\n    overflow-y: auto;\n  }\n}\n\n.sched-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.sched-avatar {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: 50%;\n  background: #e8f4fd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0069ff;\n}\n\n.sched-company {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 2px;\n}\n.sched-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 220px;\n}\n\n@media (min-width: 480px) {\n  .sched-title {\n    max-width: 340px;\n  }\n}\n\n.sched-close {\n  margin-left: auto;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 22px;\n  color: #9ca3af;\n  line-height: 1;\n  padding: 4px 6px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sched-subheader {\n  padding: 14px 20px 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.sched-body {\n  display: flex;\n  flex-direction: column;\n  padding: 14px 20px 20px;\n  gap: 20px;\n}\n\n@media (min-width: 640px) {\n  .sched-body {\n    flex-direction: row;\n    gap: 24px;\n  }\n}\n\n.sched-calendar {\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .sched-calendar {\n    width: 280px;\n    min-width: 280px;\n  }\n}\n\n.sched-divider-v {\n  display: none;\n}\n@media (min-width: 640px) {\n  .sched-divider-v {\n    display: block;\n    width: 1px;\n    background: #f1f5f9;\n    flex-shrink: 0;\n  }\n}\n\n.sched-divider-h {\n  display: block;\n  height: 1px;\n  background: #f1f5f9;\n  width: 100%;\n}\n@media (min-width: 640px) {\n  .sched-divider-h {\n    display: none;\n  }\n}\n\n.sched-slots {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.sched-slots-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  margin-bottom: 10px;\n}\n\n.sched-slots-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 8px;\n  overflow-y: auto;\n  max-height: 260px;\n  padding-right: 2px;\n}\n\n@media (min-width: 640px) {\n  .sched-slots-grid {\n    grid-template-columns: 1fr;\n    max-height: 300px;\n  }\n}\n\n.sched-slot-btn {\n  padding: 11px 10px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: center;\n  transition: border-color 0.1s, background 0.1s;\n  white-space: nowrap;\n}\n\n.sched-footer {\n  padding: 14px 20px;\n  border-top: 1px solid #f1f5f9;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.sched-footer-btns {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.sched-footer-btns button {\n  flex: 1;\n  max-width: 200px;\n  padding: 11px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  min-height: 44px;\n}\n\n.sched-btn-cancel {\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n}\n\n.sched-btn-confirm {\n  border: none;\n  background: #0069ff;\n  color: #fff;\n}\n.sched-btn-confirm:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n.sched-error {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #b91c1c;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Cal nav */\n.cal-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.cal-nav-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  cursor: pointer;\n  font-size: 18px;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  min-width: 44px;\n}\n\n.cal-month-label {\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n}\n\n.cal-days-header {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 6px;\n}\n\n.cal-day-name {\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.04em;\n  padding: 3px 0;\n}\n\n.cal-days-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px 0;\n}\n\n.cal-day-btn {\n  width: 36px;\n  height: 36px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 13px;\n  cursor: pointer;\n  min-height: 36px;\n  min-width: 36px;\n}\n.offer-letter-modal .modal-dialog {\n  max-width: 1200px; /* Increase width */\n  margin-top: 30px; /* Distance from top */\n}\n\n.offer-letter-modal .modal-content {\n  min-height: 85vh; /* Taller modal */\n}\n\n.offer-letter-modal .modal-body {\n  max-height: calc(85vh - 140px);\n  overflow-y: auto;\n}\n.sun-editor-editable[contenteditable=\"true\"] .se-component {\n  outline: \"\" !important;\n}\n#OfferLetterModal .btn-close {\n  color: white !important;\n}\n.offer-letter-modal .modal-header .btn-close {\n  filter: invert(1) brightness(2);\n}\n.sun-editor-editable p {\n  border: none !important;\n}\n.table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.nav-tabs .nav-link.active {\n  font-weight: 600;\n  color: #12395c !important;\n}\n\n.card {\n  border-radius: 12px;\n}\n\n.modal-content {\n  border-radius: 12px;\n}\n/* Remove SunEditor's default dashed border on inserted images */\n.sun-editor-editable img,\n.sun-editor img,\n#OfferLetterModal .sun-editor-editable img,\n#OfferLetterModal .sun-editor img {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n.jor-page {\n  --bg: #f6f7f9;\n  --surface: #ffffff;\n  --line: #e4e7ec;\n  --line-soft: #eef0f3;\n  --text: #13202e;\n  --muted: #5f6b7a;\n  --faint: #98a2b1;\n  --navy: #000053;\n  --orange: #ee751d;\n  --orange-hover: #d4661a;\n  --orange-soft: #fdeedd;\n  --accent: #1f4fd8;\n  --accent-soft: #eef3fe;\n  --green: #0f9d58;\n  --green-soft: #e9f7ef;\n  --amber: #b97509;\n  --amber-soft: #fdf4e3;\n  --red: #d23b3b;\n  --red-soft: #fdeeee;\n  --radius: 10px;\n  --font-display: \"Manrope\", sans-serif;\n  --font-body: \"Inter\", sans-serif;\n  font-family: var(--font-body);\n  background: var(--bg);\n  color: var(--text);\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n  position: relative;\n}\n.jor-page * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.jor-page button {\n  font: inherit;\n  cursor: pointer;\n}\n\n.jor-page .content {\n  padding: 22px 24px 32px;\n  width: 100%;\n  margin: 0 auto;\n}\n.jor-page .page-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.jor-page .page-head h1 {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 22px;\n  letter-spacing: -0.01em;\n  color: var(--navy);\n}\n.jor-page .page-head .sub {\n  color: var(--muted);\n  font-size: 13.5px;\n  margin-top: 3px;\n}\n\n.jor-page .selbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  padding: 14px 16px;\n  margin-bottom: 18px;\n}\n.jor-page .selbar .lbl {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--faint);\n}\n.jor-page .selbar select {\n  height: 40px;\n  min-width: 280px;\n  padding: 0 12px;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--navy);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .selbar select:focus {\n  outline: none;\n  border-color: var(--orange);\n  box-shadow: 0 0 0 3px var(--orange-soft);\n}\n.jor-page .selbar .meta {\n  font-size: 13px;\n  color: var(--muted);\n}\n.jor-page .selbar .meta b {\n  color: var(--navy);\n}\n\n.jor-page .stat-groups {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 16px;\n  margin-bottom: 18px;\n}\n.jor-page .stat-card {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n  overflow: hidden;\n}\n.jor-page .stat-card .sc-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--line-soft);\n}\n.jor-page .stat-card .sc-head .ico {\n  width: 40px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n}\n.jor-page .stat-card .sc-head .ico.blue {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.jor-page .stat-card .sc-head .ico.orange {\n  background: var(--orange-soft);\n  color: var(--orange);\n}\n.jor-page .stat-card .sc-head .ico.green-ico {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .stat-card .sc-head h3 {\n  font-family: var(--font-display);\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--navy);\n}\n.jor-page .stat-card .sc-body {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n.jor-page .stat-card .sc-item {\n  padding: 14px 16px;\n  border-right: 1px solid var(--line-soft);\n}\n.jor-page .stat-card .sc-item:last-child {\n  border-right: none;\n}\n.jor-page .stat-card .sc-item .v {\n  font-family: var(--font-display);\n  font-weight: 800;\n  font-size: 22px;\n  letter-spacing: -0.02em;\n}\n.jor-page .stat-card .sc-item .v.green {\n  color: var(--green);\n}\n.jor-page .stat-card .sc-item .v.amber {\n  color: var(--amber);\n}\n.jor-page .stat-card .sc-item .v.gray {\n  color: var(--faint);\n}\n.jor-page .stat-card .sc-item .l {\n  font-size: 12px;\n  color: var(--muted);\n  margin-top: 2px;\n}\n\n.jor-page .panel {\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--radius);\n}\n.jor-page .toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--line-soft);\n}\n.jor-page .toolbar .lbl {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--faint);\n}\n.jor-page .toolbar select {\n  height: 36px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13.5px;\n  color: var(--text);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .toolbar input[type=\"date\"] {\n  height: 36px;\n  padding: 0 10px;\n  font: inherit;\n  font-size: 13px;\n  color: var(--text);\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n}\n.jor-page .toolbar select:focus,\n.jor-page .toolbar input[type=\"date\"]:focus {\n  outline: none;\n  border-color: var(--orange);\n}\n.jor-page .toolbar .reset {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--muted);\n  font-weight: 500;\n  font-size: 13px;\n}\n.jor-page .toolbar .reset:hover {\n  background: var(--bg);\n  color: var(--text);\n}\n.jor-page .toolbar .right {\n  margin-left: auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.jor-page .t-search {\n  position: relative;\n}\n.jor-page .t-search svg {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--faint);\n}\n.jor-page .t-search input {\n  height: 36px;\n  width: 220px;\n  padding: 0 10px 0 32px;\n  font: inherit;\n  font-size: 13.5px;\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  color: var(--text);\n}\n.jor-page .t-search input:focus {\n  outline: none;\n  border-color: var(--orange);\n  box-shadow: 0 0 0 3px var(--orange-soft);\n}\n.jor-page .btn-export {\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--muted);\n  font-weight: 500;\n  font-size: 13px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.jor-page .btn-export:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n  background: var(--accent-soft);\n}\n\n.jor-page table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n.jor-page thead th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--faint);\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--line-soft);\n  white-space: nowrap;\n  user-select: none;\n  background: #fcfcfd;\n  vertical-align: bottom;\n}\n.jor-page thead th.sortable {\n  cursor: pointer;\n}\n.jor-page thead th.sortable:hover {\n  color: var(--muted);\n}\n.jor-page thead th .arrow {\n  font-size: 10px;\n  margin-left: 3px;\n}\n.jor-page thead tr.grouprow th {\n  font-size: 10px;\n  text-align: left;\n  color: var(--navy);\n  border-bottom: none;\n  padding-bottom: 2px;\n  letter-spacing: 0.05em;\n}\n.jor-page thead tr.grouprow th.gsep {\n  border-left: 1px solid var(--line-soft);\n}\n.jor-page tbody td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--line-soft);\n  vertical-align: middle;\n  white-space: nowrap;\n}\n.jor-page tbody tr:last-child td {\n  border-bottom: none;\n}\n.jor-page tbody tr:hover td {\n  background: #fafbfc;\n}\n.jor-page td.gsep,\n.jor-page th.gsep {\n  border-left: 1px solid var(--line-soft);\n}\n\n.jor-page .person {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.jor-page .person .avatar {\n  width: 30px;\n  height: 30px;\n  font-size: 11.5px;\n}\n.jor-page .person .p-name {\n  font-weight: 600;\n}\n.jor-page .person .p-sub {\n  font-size: 12px;\n  color: var(--faint);\n}\n.jor-page .jobtag {\n  font-size: 12px;\n  color: var(--faint);\n}\n.jor-page .avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--accent-soft);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 13px;\n  flex: none;\n}\n\n.jor-page .badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 3px 9px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n.jor-page .badge::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.jor-page .badge.green {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .badge.amber {\n  background: var(--amber-soft);\n  color: var(--amber);\n}\n.jor-page .badge.blue {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n.jor-page .badge.gray {\n  background: var(--line-soft);\n  color: var(--muted);\n}\n.jor-page .badge.red {\n  background: var(--red-soft);\n  color: var(--red);\n}\n.jor-page .badge.navy {\n  background: #e6e6f2;\n  color: var(--navy);\n}\n\n.jor-page .tl {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 210px;\n}\n.jor-page .tl .step {\n  display: grid;\n  grid-template-columns: 8px 78px minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  font-size: 12.5px;\n}\n.jor-page .tl .step .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex: none;\n  background: var(--line);\n  position: relative;\n}\n.jor-page .tl .step.done .dot {\n  background: var(--green);\n}\n.jor-page .tl .step.sched .dot {\n  background: var(--amber);\n}\n.jor-page .tl .step.sent .dot {\n  background: var(--accent);\n}\n.jor-page .tl .step .lab {\n  color: var(--muted);\n  white-space: nowrap;\n}\n.jor-page .tl .step .time {\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  color: var(--text);\n  white-space: nowrap;\n}\n.jor-page .tl .step.pending .lab,\n.jor-page .tl .step.pending .time {\n  color: var(--faint);\n  font-weight: 400;\n}\n.jor-page .tl .step .time.muted {\n  color: var(--faint);\n  font-weight: 400;\n}\n\n.jor-page .res-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 7px;\n  padding-top: 7px;\n  border-top: 1px dashed var(--line);\n}\n.jor-page .score {\n  font-family: var(--font-display);\n  font-weight: 700;\n  font-size: 13px;\n  color: var(--navy);\n  font-variant-numeric: tabular-nums;\n}\n.jor-page .score .den {\n  color: var(--faint);\n  font-weight: 600;\n  font-size: 12px;\n}\n.jor-page .res-chip {\n  font-size: 11.5px;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n.jor-page .res-chip.pass {\n  background: var(--green-soft);\n  color: var(--green);\n}\n.jor-page .res-chip.fail {\n  background: var(--red-soft);\n  color: var(--red);\n}\n.jor-page .res-chip.pend {\n  background: var(--amber-soft);\n  color: var(--amber);\n}\n.jor-page .scorebar {\n  flex: 1;\n  height: 5px;\n  border-radius: 3px;\n  background: var(--line-soft);\n  overflow: hidden;\n  min-width: 40px;\n}\n.jor-page .scorebar i {\n  display: block;\n  height: 100%;\n  border-radius: 3px;\n}\n.jor-page .scorebar i.pass {\n  background: var(--green);\n}\n.jor-page .scorebar i.fail {\n  background: var(--red);\n}\n\n.jor-page .locked {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  color: var(--faint);\n  font-size: 12.5px;\n  line-height: 1.45;\n  padding: 2px 0;\n}\n.jor-page .locked svg {\n  flex: none;\n  margin-top: 1px;\n  color: var(--faint);\n}\n.jor-page .locked .lk-title {\n  font-weight: 600;\n  color: var(--muted);\n}\n.jor-page .badge.lock {\n  background: var(--line-soft);\n  color: var(--faint);\n}\n.jor-page .badge.lock::before {\n  display: none;\n}\n\n.jor-page .table-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-top: 1px solid var(--line-soft);\n  font-size: 13px;\n  color: var(--muted);\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.jor-page .rows-per {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.jor-page .rows-per select {\n  height: 30px;\n  border: 1px solid var(--line);\n  border-radius: 8px;\n  background: var(--surface);\n  padding: 0 8px;\n  font: inherit;\n  font-size: 13px;\n}\n.jor-page .pager {\n  display: flex;\n  gap: 4px;\n}\n.jor-page .pager button {\n  min-width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  border: 1px solid var(--line);\n  background: var(--surface);\n  color: var(--muted);\n  font-size: 13px;\n}\n.jor-page .pager button:hover:not(:disabled) {\n  background: var(--bg);\n}\n.jor-page .pager button.cur {\n  background: var(--navy);\n  color: #fff;\n  border-color: var(--navy);\n  font-weight: 600;\n}\n.jor-page .pager button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n.jor-page .empty {\n  padding: 36px 18px;\n  text-align: center;\n  color: var(--faint);\n  font-size: 13.5px;\n}\n\n.jor-page .toast {\n  position: fixed;\n  bottom: 22px;\n  left: 50%;\n  transform: translateX(-50%) translateY(8px);\n  background: var(--navy);\n  color: #fff;\n  font-size: 13.5px;\n  font-weight: 500;\n  padding: 10px 18px;\n  border-radius: 999px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s, transform 0.2s;\n  z-index: 60;\n}\n.jor-page .toast.show {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n\n@media (max-width: 1100px) {\n  .jor-page .stat-groups {\n    grid-template-columns: 1fr;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .jor-page * {\n    transition: none !important;\n  }\n}\n\n.test-result-modal .modal-content {\n  border: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #f6f8fb;\n}\n\n.talent-scan-result-dialog.p-dialog {\n  overflow: hidden;\n  border: 0;\n  border-radius: 16px;\n  background: #f6f8fb;\n}\n\n.talent-scan-result-dialog .p-dialog-header {\n  padding: 14px 18px;\n  border: 0;\n  color: #fff;\n  background: #1976ad;\n}\n\n.talent-scan-result-dialog .p-dialog-title {\n  min-width: 0;\n}\n\n.talent-scan-result-dialog .p-dialog-header-icons {\n  flex: 0 0 auto;\n}\n\n.talent-scan-result-dialog .p-dialog-header-close {\n  color: #fff;\n}\n\n.talent-scan-result-dialog .p-dialog-content {\n  max-height: 75vh;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.test-result-modal-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  align-items: center;\n  padding: 14px 18px;\n  border: 0;\n  color: #fff;\n  background: #1976ad;\n}\n\n.test-result-modal-header .modal-title {\n  min-width: 0;\n}\n\n.test-result-modal-header .btn-close {\n  flex: 0 0 auto;\n  margin: 0;\n  opacity: 0.85;\n  filter: brightness(0) invert(1);\n}\n\n.test-result-modal-header .btn-close:hover {\n  opacity: 1;\n}\n\n.test-result-modal-heading {\n  min-width: 0;\n}\n\n.test-result-modal-title {\n  overflow: hidden;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-result-modal-candidate-contact {\n  overflow: hidden;\n  margin-top: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-result-modal-body {\n  max-height: 75vh;\n  overflow-y: auto;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.test-result-modal-footer {\n  justify-content: center;\n  display: flex;\n  gap: 10px;\n  padding: 12px 20px;\n  border-top: 1px solid #d8e1eb;\n  background: #fff;\n}\n\n.ts-result-list,\n.ts-result-content,\n.ts-result-section-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ts-result-list {\n  gap: 16px;\n}\n\n.ts-result-shell {\n  border: 1px solid #d8e1eb;\n  border-radius: 16px;\n  overflow: hidden;\n  background: #f6f8fb;\n}\n\n.ts-result-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #0c447c;\n}\n\n.ts-result-header-main {\n  min-width: 0;\n}\n\n.ts-result-title {\n  color: #e6f1fb;\n  font-size: 16px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.ts-result-subtitle {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin-top: 5px;\n  color: #b7daf9;\n  font-size: 12px;\n}\n\n.ts-result-header-badges {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n}\n\n.ts-result-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.ts-result-badge.success,\n.ts-result-score-pill.good {\n  color: #27500a;\n  background: #eaf3de;\n}\n\n.ts-result-badge.danger,\n.ts-result-score-pill.low {\n  color: #791f1f;\n  background: #fcebeb;\n}\n\n.ts-result-badge.warning {\n  color: #633806;\n  background: #faeeda;\n}\n\n.ts-result-badge.info,\n.ts-result-score-pill.mid {\n  color: #0c447c;\n  background: #e6f1fb;\n}\n\n.ts-result-badge.neutral {\n  color: #444441;\n  background: #f1efe8;\n}\n\n.ts-result-content {\n  gap: 14px;\n  padding: 16px;\n  background: #f6f8fb;\n}\n\n.ts-result-section-label {\n  margin-bottom: 8px;\n  /* color: #7b8794; */\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.ts-result-card {\n  padding: 14px 16px;\n  border: 1px solid #d8e1eb;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.ts-result-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0;\n}\n\n.ts-result-card.ts-result-grid-2 {\n  overflow: hidden;\n  padding: 0;\n  border-color: #c7d2df;\n}\n\n.ts-result-info-table {\n  overflow: hidden;\n  padding: 0;\n  border-color: #c7d2df;\n}\n\n.ts-result-info-table-heading {\n  padding: 8px 12px;\n  border-bottom: 1px solid #c7d2df;\n  color: #0c447c;\n  background: #edf5fc;\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.ts-result-info-table .ts-result-grid-2 + .ts-result-info-table-heading {\n  border-top: 1px solid #c7d2df;\n}\n\n.ts-result-kv-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 30px;\n  padding: 8px 12px;\n  border-right: 1px solid #d8e1eb;\n  border-bottom: 1px solid #d8e1eb;\n}\n\n.ts-result-kv-row:nth-child(even) {\n  border-right: 0;\n}\n\n.ts-result-kv-row:nth-last-child(-n + 2) {\n  border-bottom: 0;\n}\n\n.ts-result-kv-key {\n  color: #667085;\n  font-size: 12px;\n}\n\n.ts-result-kv-val {\n  max-width: 58%;\n  color: #172033;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n\n.ts-result-kv-val.timeline {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 4px 9px;\n  border: 1px solid #b9d7ef;\n  border-radius: 999px;\n  color: #0c447c;\n  background: #eaf4fc;\n  box-shadow: 0 2px 5px rgba(24, 95, 165, 0.12);\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.ts-result-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ts-result-metrics.ts-result-metrics-four {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.ts-result-metric {\n  position: relative;\n  overflow: hidden;\n  min-height: 72px;\n  padding: 14px 16px 12px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: #fff;\n  text-align: center;\n  box-shadow: 0 2px 7px rgba(23, 32, 51, 0.06);\n}\n\n.ts-result-metric::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 4px;\n  background: currentColor;\n  content: \"\";\n  opacity: 0.75;\n}\n\n.ts-result-metric.info,\n.ts-result-metric.mid {\n  color: #0c447c;\n  border-color: #b9d7ef;\n  background: #f0f7fd;\n}\n\n.ts-result-metric.good {\n  color: #27500a;\n  border-color: #b8d698;\n  background: #f2f8e9;\n}\n\n.ts-result-metric.low {\n  color: #991b1b;\n  border-color: #f0b8b8;\n  background: #fff3f3;\n}\n\n.ts-result-metric.advanced {\n  color: #26215c;\n  background: #eeedfe;\n}\n\n.ts-result-metric.neutral {\n  color: #172033;\n  background: #fff;\n  border: 1px solid #e5ebf1;\n}\n\n.ts-result-metric-val {\n  color: currentColor;\n  font-size: 19px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.ts-result-metric-label {\n  margin-top: 5px;\n  color: #475467;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ts-result-dict-row {\n  display: grid;\n  grid-template-columns: minmax(120px, 160px) 1fr minmax(82px, auto) minmax(\n      66px,\n      auto\n    );\n  align-items: center;\n  gap: 10px;\n  min-height: 34px;\n  padding: 7px 0;\n  border-bottom: 1px solid #e5ebf1;\n}\n\n.ts-result-dict-row:last-child {\n  border-bottom: 0;\n}\n\n.ts-result-dict-name {\n  color: #172033;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ts-result-bar,\n.ts-result-level-bar {\n  overflow: hidden;\n  border: 1px solid #d8e1eb;\n  border-radius: 999px;\n  background: #eef2f6;\n}\n\n.ts-result-bar {\n  height: 6px;\n}\n\n.ts-result-bar-fill {\n  height: 100%;\n  border-radius: inherit;\n}\n\n.ts-result-bar-fill.good {\n  background: #639922;\n}\n\n.ts-result-bar-fill.mid {\n  background: #185fa5;\n}\n\n.ts-result-bar-fill.low {\n  background: #e24b4a;\n}\n\n.ts-result-score-pill {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.ts-result-legend {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n  /* color: #7b8794; */\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ts-result-legend-item,\n.ts-result-level-head {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ts-result-legend-item {\n  color: #667085;\n  font-weight: 500;\n}\n\n.ts-result-legend-item span,\n.ts-result-level-head span {\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n  flex: 0 0 auto;\n}\n\n.ts-result-legend-item.beginner span,\n.ts-result-level.beginner .ts-result-level-head span,\n.ts-result-level.beginner .ts-result-level-bar div {\n  background: #639922;\n}\n\n.ts-result-legend-item.intermediate span,\n.ts-result-level.intermediate .ts-result-level-head span,\n.ts-result-level.intermediate .ts-result-level-bar div {\n  background: #185fa5;\n}\n\n.ts-result-legend-item.advanced span,\n.ts-result-level.advanced .ts-result-level-head span,\n.ts-result-level.advanced .ts-result-level-bar div {\n  background: #534ab7;\n}\n\n.ts-result-section-list {\n  gap: 8px;\n}\n\n.ts-result-section-card {\n  display: grid;\n  grid-template-columns:\n    minmax(260px, 300px)\n    minmax(180px, 240px)\n    minmax(360px, 1fr);\n  align-items: stretch;\n  overflow: hidden;\n  border: 1px solid #cbd7e4;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(23, 32, 51, 0.05);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.ts-result-section-card:hover {\n  border-color: #aebdcd;\n  box-shadow: 0 4px 12px rgba(23, 32, 51, 0.08);\n}\n\n.ts-result-section-card.cheated {\n  border: 2px solid #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.ts-result-section-card.cheated .ts-result-section-name-col,\n.ts-result-section-card.cheated .ts-result-section-score-col,\n.ts-result-section-card.cheated .ts-result-level {\n  background: #fff7f7;\n}\n\n.ts-result-section-top {\n  display: contents;\n}\n\n.ts-result-section-name-col {\n  padding: 12px 14px;\n  border-right: 1px solid #d8e1eb;\n  background: #fbfcfe;\n}\n\n.ts-result-section-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: #101828;\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.ts-result-cheated-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 3px 9px;\n  border-radius: 999px;\n  color: #fff;\n  background: #dc2626;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.ts-result-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n\n.ts-result-chip-row > span:not(.ts-result-badge) {\n  padding: 3px 8px;\n  border: 1px solid #d6e0eb;\n  border-radius: 999px;\n  color: #344054;\n  background: #f8fafc;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.25;\n}\n\n.ts-result-chip-row.status {\n  margin-top: 7px;\n}\n\n\n.ts-result-level-head {\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.ts-result-section-score-col {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 16px;\n  border-right: 1px solid #d8e1eb;\n  height: 100%;\n  background: #f8fbff;\n}\n\n.ts-result-big-score {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  align-items: flex-start;\n}\n\n.ts-result-big-score span {\n  color: #475467;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  line-height: 1.2;\n  margin: 0;\n}\n\n.ts-result-big-score strong {\n  color: #12639a;\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  margin: 1px 0;\n}\n\n.ts-result-big-score small {\n  color: #344054;\n  font-size: 11px;\n  line-height: 1.3;\n  margin: 0;\n}\n.ts-result-section-bar-wrap {\n  flex: 1 1 auto;\n  min-width: 110px;\n}\n\n.ts-result-section-bar-label {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 4px;\n  /* color: #7b8794; */\n  font-size: 11px;\n}\n\n.ts-result-section-bar-label .good {\n  color: #27500a;\n}\n\n.ts-result-section-bar-label .mid {\n  color: #0c447c;\n}\n\n.ts-result-section-bar-label .low {\n  color: #791f1f;\n}\n\n.ts-result-levels {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  align-items: stretch;\n}\n\n.ts-result-level {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  padding: 12px 14px;\n  border-right: 1px solid #d8e1eb;\n  border-top: 3px solid transparent;\n}\n\n.ts-result-level:last-child {\n  border-right: 0;\n}\n\n.ts-result-level-head {\n  margin-bottom: 7px;\n  color: #344054;\n  font-size: 9px;\n}\n\n.ts-result-level-score-label {\n  margin-bottom: 3px;\n  color: #667085;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.ts-result-level-score {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  margin-bottom: 4px;\n}\n\n.ts-result-level-score strong {\n  font-size: 17px;\n  line-height: 1;\n}\n\n.ts-result-level.beginner {\n  border-top-color: #639922;\n  background: #fbfdf8;\n}\n\n.ts-result-level.intermediate {\n  border-top-color: #185fa5;\n  background: #f8fbff;\n}\n\n.ts-result-level.advanced {\n  border-top-color: #534ab7;\n  background: #faf9ff;\n}\n\n.ts-result-level > small {\n  color: #475467;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ts-result-level.beginner .ts-result-level-score strong {\n  color: #639922;\n}\n\n.ts-result-level.intermediate .ts-result-level-score strong {\n  color: #185fa5;\n}\n\n.ts-result-level.advanced .ts-result-level-score strong {\n  color: #534ab7;\n}\n\n.ts-result-level-score span {\n  /* color: #7b8794; */\n  font-size: 11px;\n}\n\n.ts-result-level-bar {\n  height: 4px;\n}\n\n.ts-result-level-bar div {\n  height: 100%;\n}\n\n.ts-result-level-empty {\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n.ts-result-section-extra {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  border-top: 1px solid #d8e1eb;\n}\n\n.ts-result-section-extra div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  border-right: 1px solid #d8e1eb;\n}\n\n.ts-result-section-extra div:last-child {\n  border-right: 0;\n}\n\n.ts-result-section-extra span {\n  color: #7b8794;\n  font-size: 10px;\n}\n\n.ts-result-section-extra strong {\n  color: #172033;\n  font-size: 11px;\n}\n\n.ts-result-cheated-note {\n  grid-column: 1 / -1;\n  padding: 9px 14px;\n  border-top: 1px solid #dc2626;\n  color: #991b1b;\n  background: #fee2e2;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ts-result-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.ts-result-detail-btn,\n.ts-result-close-btn {\n  min-height: 34px;\n  padding: 7px 20px;\n  border: 1px solid #185fa5 !important;\n  border-radius: 8px !important;\n  color: #0c447c !important;\n  background: #e6f1fb !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.ts-result-close-btn {\n  border-color: #cbd5e1 !important;\n  color: #172033 !important;\n  background: #f8fafc !important;\n}\n\n.ts-result-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 260px;\n  padding: 48px 24px;\n  color: #667085;\n  text-align: center;\n}\n\n.ts-result-empty-icon {\n  width: 56px;\n  height: 56px;\n  border: 2px solid #d8e1eb;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #0c447c;\n  background: #e6f1fb;\n  font-size: 24px;\n  font-weight: 800;\n  font-family: Georgia, serif;\n}\n\n.ts-result-empty-title {\n  color: #172033;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.ts-result-empty-copy {\n  max-width: 300px;\n  font-size: 14px;\n}\n\n@media (max-width: 991.98px) {\n.ts-result-grid-2,\n.ts-result-levels,\n.ts-result-section-extra {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.ts-result-metrics {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n  .ts-result-kv-row:nth-last-child(-n + 2) {\n    border-bottom: 1px solid #e5ebf1;\n  }\n\n  .ts-result-kv-row:last-child {\n    border-bottom: 0;\n  }\n\n  .ts-result-section-top {\n    display: contents;\n  }\n\n  .ts-result-section-card {\n    grid-template-columns: 1fr;\n  }\n\n  .ts-result-section-name-col,\n  .ts-result-section-score-col,\n  .ts-result-level,\n  .ts-result-section-extra div {\n    border-right: 0;\n  }\n\n  .ts-result-section-name-col,\n  .ts-result-section-score-col,\n  .ts-result-level {\n    border-bottom: 1px solid #d8e1eb;\n  }\n\n  .ts-result-dict-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .test-result-modal-body,\n  .ts-result-content {\n    padding: 12px;\n  }\n\n  .ts-result-header,\n  .ts-result-section-score-col {\n    flex-direction: column;\n  }\n\n  .ts-result-header-badges {\n    justify-content: flex-start;\n  }\n\n  .ts-result-kv-row {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .ts-result-kv-val {\n    max-width: 100%;\n    text-align: left;\n  }\n}\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box .search-icon {\n  position: absolute;\n  left: 12px;\n  color: #667085;\n  font-size: 14px;\n}\n\n.search-box input[type=\"search\"] {\n  width: 300px;\n  padding: 10px 14px 10px 36px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  background: #fff;\n  transition: all 0.3s ease;\n}\n\n.search-box input[type=\"search\"]:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n  outline: none;\n}\n.right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.right input[type=\"search\"] {\n  width: 280px;\n  padding: 10px 14px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.3s ease;\n  background: #fff;\n}\n\n.right input[type=\"search\"]:focus {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n}\n\n.right input[type=\"search\"]::placeholder {\n  color: #98a2b3;\n}\n.count-bubble {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--navy, #000053);\n  background: #eef1f6;\n  border: 1px solid var(--line, #e4e7ec);\n  border-radius: 999px;\n  padding: 4px 12px;\n  white-space: nowrap;\n}\n.count-bubble b {\n  color: var(--orange, #ee751d);\n  font-weight: 700;\n}\n.cutoff-bubble {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--orange, #ee751d);\n  background: #fff4e6;\n  border: 1px solid #ffd9b3;\n  border-radius: 999px;\n  padding: 2px 10px;\n  margin-left: 6px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.cutoff-bubble b {\n  color: var(--orange, #ee751d);\n}\n  .job-title-filter-dropdown.p-dropdown {\n    background: #fff !important;\n    border: 1px solid #ced4da !important;\n    box-shadow: none !important;\n    min-height: 31px;\n  }\n  .job-title-filter-dropdown .p-dropdown-label {\n    background: transparent !important;\n    color: #212529 !important;\n    font-weight: 400 !important;\n    padding: 4px 8px !important;\n    text-shadow: none !important;\n  }\n  .job-title-filter-dropdown .p-dropdown-label.p-placeholder {\n    color: #6c757d !important;\n  }\n  .job-title-filter-dropdown .p-dropdown-clear-icon {\n    color: #6c757d !important;\n    right: 2rem;\n  }\n  .job-title-filter-dropdown .p-dropdown-trigger {\n    color: #6c757d !important;\n  }\n  .job-title-filter-dropdown:not(.p-disabled):hover {\n    border-color: #adb5bd !important;\n  }\n  .job-title-filter-dropdown:not(.p-disabled).p-focus {\n    border-color: #86b7fe !important;\n    box-shadow: 0 0 0 0.2rem rgba(13,110,253,.25) !important;\n  }\n\n  #TelephonicTest_Table .rdt_TableHead {\n    z-index: 1;\n  }\n.swal-on-top {\n  z-index: 99999 !important;\n}\n#VitelMeetLink{\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
